export default {
  "general": {
    "action_cannot_be_undone": "Denne handling kan ikke fortrydes",
    "inactive": "Inaktiv",
    "min_characters": "{current} karakterer (min {min} karakterer)",
    "loading_results": "Indlæser resultater",
    "in": "i",
    "and": "og",
    "back": "Tilbage",
    "deleted": "Slettede",
    "clear": "Ryd",
    "close": "Luk",
    "now": "Nu",
    "go_to_login": "Gå til login",
    "max_characters": "{current} karakterer (maks. {max} karakterer)",
    "no_results": "Ingen resultater",
    "nevermind": "Ikke alligevel",
    "display_name_and_email": "{displayName} ({email})",
    "display_name": "{displayName} | {displayName} (Dig)",
    "active": "Aktiv",
    "are_you_sure_continue": "Er du sikker på, at du vil fortsætte?",
    "yes_action": "Ja, {action}",
    "okay": "Okay",
    "required": "Påkrævet",
    "yes_delete": "Ja, slet",
    "would_like_to_invite_you_to_organisation": "vil gerne invitere dig til at deltage i organisationen",
    "save": "Gem",
    "no_thanks": "Nej tak",
    "whitespace-nowrap": "Under gennemgang",
    "something_went_wrong": "Noget gik galt..",
    "take_me_home": "Tag mig hjem",
    "desktop_app_warning": {
      "message": "Du åbner mobilversionen af Batchflow på en computer. For at få adgang til den fulde værktøjskasse og den bedste brugeroplevelse, bør du skifte til desktopversionen.",
      "title": "Fungerer bedre på en computer"
    },
    "or": "eller",
    "of": "af",
    "yes_delete_template": "Ja, slet skabelonen",
    "description": "Beskrivelse",
    "name": "Navn",
    "creditor": "Kreditor",
    "forward": "Frem"
  },
  "activitylog": {
    "action": {
      "flow_was_cancelled": "Flow annulleret",
      "flow_updated_added": "{user} er blevet tilføjet som godkender før sig selv i flow",
      "field_changed_from": "fra",
      "flow_cancelled": "Annullerede det aktuelle flow {flowtype}: {flowname}",
      "export_failed_with_message": "Eksport fejlede med besked",
      "changed_approvers": "Ændrede godkendere",
      "flow_updated_replaced": "Er blevet erstattet af {user} som godkender i flow",
      "field_changed_to": "til",
      "field_changed": "Ændrede",
      "category": "Kategori",
      "flow_updated_add_approver_after": "{user} er blevet tilføjet som godkender efter sig selv flow",
      "flow_participant_inserted": "{targetUser} er blevet tilføjet som godkender i flow",
      "deleted_by": "Slettet af",
      "field_added": "Tilføjede",
      "document_return_to": "Dokument returneret til",
      "voucher_number": "Bilagsnummer",
      "reason": "Årsag",
      "workstatus_from": "Fra",
      "item_added": "Dokument oprettet",
      "item_exportet": "Eksporteret",
      "imported": "Importerede",
      "required_approvals": "Påkrævede godkendelser:",
      "workstatus_to": "Til",
      "required_declines": "Påkrævede afvisninger:",
      "item_deleted": "Slettet",
      "updated": "Opdaterede",
      "document_merge_attached": "Vedhæftede filer",
      "document_merge": "Der er vedhæftet et dokument til dette dokument",
      "document_merge_to": "Dokumentet er vedhæftet et andet dokument",
      "document_merge_second_line": "Se dokumentet og dets vedhæftede filer under"
    },
    "empty_value": "Ikke sat",
    "groups": {
      "comment_added": "Tilføjet en kommentar",
      "attachment_deleted": "Vedhæftning slettet",
      "document_approved_description": "{approver} agerede stedfortræder for {owner} grundet out of office",
      "bulk_create_cost_types_integration": "Importerede omkostningstyper",
      "document_approved": "Dokument godkendt",
      "bulk_create_projects": "Oprettede projekter",
      "document_rejected": "Dokument afvist",
      "bulk_create_projects_integration": "Importerede projekter",
      "document_approvedby": "Dokument godkendt på vegne af {owner}",
      "bulk_update_cost_types": "Opdaterede omkostningstyper",
      "bulk_create_cost_types": "Oprettede omkostningstyper",
      "attachment_added": "Vedhæftning tilføjet",
      "bulk_update_projects": "Opdaterede projekter",
      "bulk_create_employees_integration": "Importerede ansvarlige",
      "document_rejected_description": "{approver} afviste dokumentet på vegne af {owner} grundet out of office",
      "item_return_to_export_errors": "Dokument returneret til Eksportfejl",
      "item_returned_from_hold": "Returneret fra På hold",
      "item_return_to_archived": "Dokument returneret til Arkiverede",
      "item_marked_as_unique": "Markeret som unik",
      "item_export_failed": "Dokument kunne ikke eksporteres",
      "flow_created": "Påførte {flowtype}: {flowname}",
      "item_ready_for_export": "Dokument klar til eksportering",
      "flow_item_sent_to_user": "Sendt til bruger",
      "item_deleted": "Dokument slettet",
      "item_return_from_archived": "Dokument returneret fra Arkiverede",
      "item_added": "Dokument modtaget",
      "item_printed": "Dokument printet",
      "journal_line_modified": "Konteringslinje ændret",
      "fields_modified": "Ændring af felter",
      "item_export_succeded": "Dokumentet blev eksporteret",
      "flow_deleted": "Slettede {flowtype}: {flowname}",
      "document_saved_locally": "Dokument download",
      "journal_line_deleted": "Konteringslinje slettet",
      "item_put_on_hold": "Dokument sat på hold",
      "item_moved_to_archive": "Dokument flyttet til Arkiverede",
      "item_ready_for_re_export": "Dokument klar til re-eksportering",
      "item_emailed": "Dokument sendt på e-mail",
      "item_export_ready": "Klar til eksport",
      "item_flow_assigned": "Påførte {flowtype}: {flowname}",
      "journal_line_added": "Konteringslinje tilføjet",
      "flow_updated": "Opdaterede flow",
      "item_reject_note": "Tilføjede en afvisningsnote",
      "item_deleted_as_duplicate": "Dokument slettet",
      "item_return_from_delete": "Dokument returneret fra Slettede",
      "document_rejectedby": "Dokument afvist på vegne af {owner}",
      "item_saved": "Dokument gemt",
      "item_return_to_new_documents": "Dokumentretur til nyt dokument",
      "item_return_to_declined": "Dokument returneret til Afviste",
      "flow_item_received": "Dokument modtaget",
      "user_out_of_office": "Bruger er Out Of Office",
      "replaced_in_flow": "Erstattet i flow",
      "reason_category_changed": "Ændret arkivkategori",
      "voucher_imported": "Bilagsnummer importeret",
      "user_removed_from_flow": "Fjernet fra flow",
      "system": "System",
      "sent_review": "Sendt til gennemgang",
      "user_company_disable": "{flowtype} opdateret: {flowname}",
      "modified_employees": "Opdaterede ansvarlige tilknytninger",
      "flow_item_auto_declined": "Dokumentet blev automatisk afvist",
      "item_move_to_another_company": "Dokumentet er flyttet fra et andet firma ",
      "final_approval_by_limit": "{approver} havde en tilstrækkelig godkendelsesgrænse til at godkende dokumentet",
      "final_approval_by_required": "Dokumentet blev endeligt godkendt, fordi {accepted} ud af {required} påkrævede godkendelser blev modtaget",
      "document_attached": "Vedhæftet dokument",
      "calculated_due_date_applied": "Den beregnede forfaldsdato er blevet anvendt",
      "journal_template_applied": "Konteringsskabelon anvendt",
      "automatic_approval_controls": "Godkendelsen blev gennemført automatisk ud fra selskabets godkendelsesindstillinger",
      "previous_approval": "Tidligere godkendelse: {date}",
      "document_automatically_approved": "Dokument automatisk godkendt",
      "document_automatically_approved_description": "{approver} havde tidligere godkendt dette dokument."
    },
    "description": {
      "document_rejected_description": "{approver} afviste dokumentet på vegne af {owner} på grund af fravær",
      "document_approved_description": "{approver} agerede stedfortræder for {owner} på grund af fravær"
    },
    "duplicate": {
      "item_deleted_as_duplicate": "Markeret som dublet",
      "item_marked_as_unique": "Dokumentet er ikke en dublet"
    },
    "automations": {
      "accounting_line": "Konteringslinje"
    },
    "automation": {
      "began_automation": "Begyndte automatisering: {automation}"
    },
    "automation_block": {
      "added_accounting_lines": "Tilføjede {count} konteringslinjer",
      "deleted_accounting_lines": "Slettede {count} konteringslinjer"
    },
    "employees": {
      "linked": "Tilknyttede",
      "from": "Fra",
      "unlinked": "Frakoblede",
      "to": "Til"
    },
    "return_from_onhold": {
      "to_widget": "Dokument returneret til {widget}",
      "to_assignee": "Dokument returneret til godkender | Document returneret til godkendere"
    },
    "onhold": {
      "additional_note": "Supplerende note",
      "reason": "Årsag"
    }
  },
  "accounting": {
    "fields": {
      "accountname": "Kontonavn",
      "accountno": "Konto",
      "amount": "Beløb",
      "vatcode": "Momskode",
      "accountnumber": "Konto",
      "contraaccount": "Modkonto",
      "contraaccountnumber": "Modkonto",
      "postingtext": "Posteringstekst"
    },
    "popular_vatgroups": "Seneste brugte momskoder",
    "popular_dimension_list": "Seneste brugte {column}",
    "add_new_entry": "Tilføj en ny linje",
    "popular_accounts": "Seneste brugte konti",
    "delete_entry": "Slet linje",
    "save": {
      "template_name": "Skabelonnavn",
      "description": "Beskrivelse (valgfrit)",
      "template_name_placeholder": "Angiv venligst et skabelonnavn",
      "overwrite_warning_title": "Dette vil overskrive den valgte skabelon",
      "template_to_overwrite_required": "Vælg venligst en skabelon, der skal overskrives",
      "template_name_required": "Angiv venligst et skabelonnavn",
      "title": "Gem som skabelon",
      "new_template": "Ny skabelon",
      "new_template_subtitle": "Opret en ny skabelon ud fra de aktuelle journalposter",
      "save_as": "Gem som",
      "overwrite_template": "Overskriv skabelon",
      "description_placeholder": "Beskriv, hvornår denne skabelon skal bruges",
      "overwrite_existing_subtitle": "Overskriv eksisterende skabelon fra de aktuelle journalposteringer",
      "template_to_overwrite": "Skabelon, der skal overskrives",
      "save_template": "Gem skabelon",
      "overwrite_existing": "Overskriv eksisterende",
      "overwrite_warning_subtitle": "Overskrivningen vil opdatere felterne for journalposter, beskrivelse, ikon og beløb."
    },
    "browse": {
      "favorites": "Favoritter",
      "empty_description": "Opret en skabelon, som du kan genbruge til fremtidige journalposteringer.",
      "search_placeholder": "Søg efter skabeloner",
      "empty_title": "Der er endnu ikke tilføjet nogen skabeloner",
      "filter_templates": "Filterskabeloner",
      "title": "Skabeloner",
      "templates": "Gennemse skabeloner",
      "apply_template": "Anvend skabelon",
      "starting_point_hint": "Denne skabelon er et udgangspunkt. Du kan gennemgå og redigere den, når den er blevet anvendt.",
      "all": "Alle",
      "empty_search_description": "Tjek stavningen, eller prøv en ny søgning",
      "empty_search_title": "Vi kunne ikke finde den skabelon, du ledte efter"
    },
    "template": {
      "add_accounting_line": "Tilføj mindst én post for at gemme",
      "already_exists": "Der findes allerede en skabelon med dette navn.",
      "save_as_tooltip": "Gem som skabelon",
      "applied": "Skabelonen anvendt",
      "link_removed": "Skabelonlink fjernet"
    }
  },
  "action": {
    "flow_was_cancelled": "Flow annulleret"
  },
  "columns": {
    "rejected_by": "Afvisere",
    "actions": "Handlinger",
    "approvals": "Godkendelser",
    "approved_by": "Godkendere",
    "approvers": "Godkendere",
    "decline_reason": "Årsag til afvisning",
    "showdoc": "Vis dokument",
    "on_hold_reason": "Årsag til på hold",
    "export_type": "Fejl",
    "export_time": "Forsøgt eksporteret",
    "project_number": "Projektnummer",
    "export_status": "Status",
    "show_document": "Vis dokument",
    "notes": "Kommentarer",
    "export_error": "Fejl",
    "created": "Oprettelsesdato",
    "status": "Status",
    "docid": "Dokument-ID",
    "guid": "Guid",
    "company": "Selskab",
    "time_spent": "Tid brugt",
    "assignee": "Tildelte",
    "archived_date": "Arkiveret dato",
    "deletion_date": "Sletningsdato",
    "creditor": "Kreditor",
    "category": "Kategori",
    "reason": "Årsag",
    "document_type": "Dokumenttype",
    "voucher_number": "Bilagsnummer",
    "validation": "Validering",
    "due_date": "Forfaldsdato",
    "invoice_id": "Fakturanummer",
    "export_date": "Eksportdato",
    "total_amount": "Totalbeløb",
    "invoice_date": "Fakturadato",
    "department": "Afdeling",
    "location": "Lokation"
  },
  "admin-activitylog": {
    "groups": {
      "user_avatar_updated": "Skiftede avatar",
      "automation_deleted": "Slettede automatisering {automation}",
      "miscellaneous": "Diverse indstillinger",
      "security": "Sikkerhedsindstillinger",
      "user_invite": "Inviteret ny bruger",
      "user_company_disable": "Deaktiverede bruger {user}",
      "miscellaneous_mandatory_onhold_additional_note": "Ændrede diverse indstillinger",
      "user_change_password_request": "Anmodede om nulstilling af adgangskode for {user}",
      "user_2fa_enable": "Tofaktorgodkendelse blev konfigureret",
      "role_change": "Redigerede {role} rolle",
      "role_change_setting": "Redigerede {role} rolle",
      "automation_status_updated": "Opdaterede automatisering {automation}",
      "user_2fa_disable": "Tofaktorgodkendelse blev fjernet",
      "automation_added": "Tilføjede automatisering {automation}",
      "authentication_mandatory_two_factor": "Ændrede sikkerhedsindstillinger",
      "automation_updated": "Opdaterede automatisering {automation}",
      "user_update_workstatus": "Ændrede arbejdsstatus for {user}",
      "user_update_info": "Opdaterede brugeroplysninger",
      "widget_changed": "Widgetændringer foretaget til {widget}",
      "user_invite_resend": "Brugerinvitation gensent",
      "user_invite_accepted": "Invitation er blevet accepteret",
      "user_role_change": "Ændrede rolle for {user}",
      "user_invite_revoked": "Invitation blev tilbagekaldt",
      "user_password_changed": "Opdaterede sin adgangskode"
    },
    "approval_limits": {
      "unlimited": "Ubegrænset",
      "group_changed": "Ændrede godkendelsesgrænse for {user} i {company}",
      "unknown_user": "Ukendt bruger",
      "changed_document_type": "Ændrede godkendelsesgrænse for {documentType}"
    },
    "unknown_company": "Ukendt selskab",
    "flows": {
      "changed_flow_users": "Ændrede brugere på flow"
    },
    "user_change_role": {
      "to_role": "Til {role}",
      "from_role": "Fra {role}"
    },
    "user_role_change": {
      "company_info": "Ændrede rolle i {company}"
    },
    "user_invite": {
      "company_include": "Selskaber inkluderer",
      "company_role_info": "{company} som {role}",
      "resend_to": "Invitation sendt til {email}",
      "revoked_from": "Invitation til {email} blev tilbagekaldt",
      "sent_to": "Invitation sendt til {email}",
      "accepted": "Invitation til {email} blev accepteret",
      "language": "Inviteret med sprog {language}"
    },
    "user": {
      "workstatus_delegate_in_company": "Stedfortræder i {company} er sat til {user}",
      "workstatus_changed_timeframe": "Tidsramme",
      "workstatus_changed": "Ændrede arbejdsstatus"
    },
    "user_change_password_request": {
      "details": "Anmodning sendt til {email}"
    },
    "widget": {
      "action_changed_view": "Ændrede visningsrettigheder til {action}",
      "permissions": "Ændrede widget indstillinger",
      "deactivated": "Widget blev deaktiveret",
      "actions": "Ændrede aktioner",
      "activated": "Widget blev aktiveret",
      "key_metrics": "Ændrede nøglemålinger",
      "metric_changed_view": "Ændrede visningsrettigheder til {metric}"
    },
    "role": {
      "widget_changed": "Ændret widget-synlighed for {widget}",
      "setting_changed": "Ændrede {setting}"
    },
    "user_remove": {
      "changeinfo": "{user} i {company}",
      "replace_by": "Erstattet med"
    }
  },
  "approval_limits": {
    "final_approver_tooltip_description": "Sidste godkender får altid en ubegrænset beløbsgrænse, så dokumentet kan godkendes.",
    "final_approver": "Sidste godkender (ubegrænset beløbsgrænse)",
    "badge_label": "Beløbsgrænse",
    "one_time_update_action": "Opdater beløbsgrænse",
    "set_last_approver_tooltip_description": "Flyt denne godkender til det sidste trin i flowet.",
    "unlimited": "Ubegrænset beløbsgrænse",
    "set_last_approver_tooltip_title": "Sæt som sidste godkender",
    "tooltip_edit_title": "Opdater beløbsgrænse",
    "tooltip_readonly_title": "Beløbsgrænse",
    "errors": {
      "amount_must_be_non_negative": "Beløbsgrænser kan ikke være negative.",
      "duplicate_document_type": "Hver dokumenttype kan kun have én beløbsgrænse.",
      "invalid_document_type": "Vælg en gyldig dokumenttype.",
      "amount_must_be_positive": "Beløbsgrænser skal være større end nul."
    },
    "one_time_modal_title": "Angiv flowspecifik beløbsgrænse",
    "restore_description": "Gendan brugerens standardbeløbsgrænse.",
    "flow_modal_title": "Flowspecifikke beløbsgrænser",
    "one_time_modal_hint": "Denne grænse tilsidesætter brugerens standardbeløbsgrænse i dette flow.",
    "flow_tooltip_edit_description": "Du kan angive en flowspecifik beløbsgrænse for denne godkender.",
    "tooltip_readonly_description": "Denne grænse er sat af en administrator eller bogholder.",
    "restore_title": "Gendan beløbsgrænse",
    "flow_tooltip_edit_title": "Opdater flowets beløbsgrænse",
    "tooltip_edit_description": "Du kan opdatere brugerens beløbsgrænse.",
    "final_approver_tooltip_title": "Ubegrænset beløbsgrænse",
    "one_time_amount_label": "Beløbsgrænse",
    "flow_modal_description": "Angiv det maksimale beløb {user} må godkende i dette flow.",
    "overall_limit": "Samlet grænse",
    "unlimited_only": "Ubegrænset",
    "multiple": "Flere beløbsgrænser",
    "multiple_limit": "Flere beløbsgrænser",
    "multiple_limitations": "Flere beløbsgrænser"
  },
  "automation": {
    "status": {
      "inactive": "Inaktive",
      "active": "Aktiv"
    },
    "save_automation_modals": {
      "automation_name": "Automatiserings navn",
      "description_placeholder": "Angiv en beskrivelse af din automatisering",
      "automation_description": "Beskrivelse",
      "automation_name_placeholder": "Angiv et navn til din automatisering"
    },
    "event": {
      "document-received": "Dokument modtaget"
    },
    "actions": {
      "applied_most_used_accounting_lines": "Anvendte {created_lines} ofte brugte bogføringslinjer for {creditor} ({documentType}), i alt {amount}",
      "assigned_to_flow": "Tildelt til {flow}",
      "invalid_flow": "Det valgte flow var ugyldigt",
      "invalid_note": "Noten var ugyldig",
      "note_created": "Note oprettet",
      "applied_recent_journal_entry": "Anvendte {created_lines} nylige bogføringslinjer for {creditor} ({documentType}), i alt {amount}",
      "no_recent_accounting_lines_found": "Der blev ikke fundet nogen nylige bogføringslinjer",
      "auto_account_invoice_failed": "Automatisk bogføring blev ikke gennemført",
      "handler_block_type_mismatch": "Den gemte bloktype passede ikke til handlingen",
      "no_creditor_number_found": "Der blev ikke fundet et kreditornummer",
      "no_accounting_lines_found": "Der blev ikke fundet nogen bogføringslinjer",
      "assigned_to_user": "Tildelt til {user}",
      "sent_to_user": "Sendt til {user}",
      "invalid_user": "Den valgte bruger var ugyldig",
      "auto_account_invoice_completed": "Automatisk bogføring blev gennemført med {suggested_line_count} foreslåede linjer",
      "no_recent_items_found": "Der blev ikke fundet nogen nylige bilag",
      "sent_to_flow": "Sendt til {flow}",
      "created_journal_entries": "Oprettede {created_lines} bogføringslinjer for {creditor} ({documentType}), i alt {amount}",
      "due_date_calculated": "Den beregnede forfaldsdato er blevet anvendt.",
      "due_date_creditor_missing": "Forfaldsdatoen kunne ikke beregnes, fordi kreditoren mangler.",
      "due_date_payment_term_missing": "Forfaldsdatoen kunne ikke beregnes, fordi kreditorens betalingsbetingelser mangler.",
      "due_date_payment_term_unsupported": "Forfaldsdatoen kunne ikke beregnes ud fra kreditorens betalingsbetingelser.",
      "due_date_unchanged": "Forfaldsdatoen er uændret.",
      "due_date_invoice_date_missing": "Forfaldsdatoen kunne ikke beregnes, fordi fakturadatoen mangler.",
      "export_not_applied": "Dokumentet skal være godkendt og må ikke tidligere være sendt til eksport.",
      "document_approved": "Dokumentet blev godkendt af automationsbrugeren.",
      "export_requested": "Dokumentet er sendt til eksport.",
      "document_approval_not_applied": "Dokumentet kan ikke godkendes i sin nuværende tilstand."
    },
    "history": {
      "started": "Startet",
      "status": "Status",
      "additional_execution": "Yderligere kørselsresultater",
      "unavailable": "Kørselshistorikken er ikke tilgængelig.",
      "block_details": "Blokresultat",
      "did_not_pass": "Ikke opfyldt",
      "in_progress": "I gang",
      "partial_snapshot": "Nogle gemte snapshots kunne ikke læses. Tilgængelige kørselsresultater vises.",
      "additional_execution_description": "Disse besøgte blokke fandtes ikke i definitionen, der blev gemt, da kørslen blev sat i kø.",
      "queued": "I kø",
      "show_details": "Vis kørselsdetaljer",
      "finished": "Afsluttet",
      "result": "Resultat",
      "ran_automation": "Kørte automatisering: {automation}",
      "not_visited": "Ikke besøgt i denne kørsel",
      "hide_details": "Skjul kørselsdetaljer",
      "open_in_automations": "Åbn i automatiseringer",
      "loading": "Indlæser kørselshistorik",
      "title": "Historik for automatiseringskørsel",
      "succeeded": "Gennemført",
      "description": "Se den gemte automatiseringsdefinition og resultatet for hver besøgt blok.",
      "duration": "Varighed",
      "failed": "Fejlede",
      "interrupted": "Afbrudt",
      "queued_at": "Sat i kø {date}",
      "unavailable_value": "Ikke tilgængelig",
      "unknown_automation": "Ukendt automatisering",
      "loop_iteration": "Gennemløb {index}: {source}",
      "fit_to_view": "Tilpas til visning",
      "stopped_subsequent_automations": "Stoppede efterfølgende automatiseringer"
    },
    "block": {
      "interrupted": "Kørslen blev afbrudt",
      "failed": "Blokken fejlede",
      "result_unavailable": "Der blev ikke gemt et resultat"
    },
    "loops": {
      "not_implemented": "Loops er ikke implementeret"
    },
    "template_deleted_title": "Automatisering deaktiveret",
    "open_automation": "Åbn automatisering",
    "template_deleted_body": "Automatiseringen \"{automation}\" blev deaktiveret, fordi konteringsskabelonen \"{template}\" blev slettet."
  },
  "archive": {
    "document_reason_message": "Vælg en kategori for dokumentet",
    "meta": {
      "description": "Arkiverede dokumenter",
      "title": "Arkiver"
    },
    "reason_choice": {
      "processed_outside_system": "Behandlet uden for systemet",
      "receipt_document": "Kontoudtog",
      "cancelled_or_credited": "Annulleret eller krediteret",
      "attached_to_other_document": "Vedhæftet til et andet dokument",
      "delivery_note": "Følgeseddel"
    },
    "document": "Flyt dokument til Arkiverede"
  },
  "automations": {
    "action": {
      "title": "Handling: {action}"
    },
    "actions": {
      "action": "handling",
      "add_an_action": "Tilføj en handling til automatiseringen",
      "actions": "Handlinger",
      "delete": "Slet automatisering",
      "no_search_results": "Vi kunne ikke finde den handling, du ledte efter",
      "redo": "Gentag",
      "edit": "Rediger navn og beskrivelse",
      "test_automation": "Test Automatisering",
      "search_for_an_action": "Søg efter en handling",
      "undo": "Fortryd",
      "unknown_action_type": "Ukendt handlingstype",
      "settings": "Automatiseringsindstillinger"
    },
    "apply_most_used_flow": {
      "period": "Periode",
      "the_period": "De {period}, {action}",
      "assign_and_send": "tildel flow og send til gennemgang",
      "last_6_months_description": "Anvend det mest brugte flow fra de seneste 6 måneder",
      "title": "Anvend mest brugte flow",
      "last_3_months_description": "Anvend det mest brugte flow fra de seneste 3 måneder",
      "last_month_description": "Anvend det mest brugte flow fra den seneste måned",
      "assign": "tildel flow",
      "last_3_months": "Seneste 3 måneder",
      "last_month": "Seneste måned",
      "title_from": "Anvend det mest brugte flow fra:",
      "subtitle": "Anvend det mest brugte flow fra kreditoren",
      "last_6_months": "Seneste 6 måneder",
      "select_period_option": "Vælg en indstilling for periode"
    },
    "apply_most_recent_journal_entries": {
      "blank_description": "Lad være med at indsætte noget",
      "copy_posting_text": "Kopier posteringsteksten",
      "insert_creditor_name": "Indsæt kreditornavn",
      "select_posting_text_option": "Vælg en indstilling for posteringsteksten",
      "amount": "Beløb",
      "add_remainder_as_new_entry": "Tilføj restbeløb på en ny linje\n\n",
      "blank": "Blank",
      "add_remainder_to_first_entry": "Tilføj restbeløb til første linje",
      "copy_posting_text_description": "Kopier posteringsteksten fra de forrige linjer",
      "select_amount_option": "Vælg en indstilling for beløb",
      "add_full_amount_to_first_entry": "Tilføj beløb til første linje",
      "posting_text": "Posteringstekst",
      "accounting_lines": "Konteringslinjer",
      "distribute_evenly_description": "Fordel beløbet ligeligt på alle konteringslinjer. Eventuel afrundingsdifference tilføjes til den første linje",
      "title": "Anvend seneste konteringslinjer",
      "insert_creditor_name_description": "Indsæt kreditornavn på hver konteringslinje",
      "add_full_amount_to_first_entry_description": "Tilføj hele beløbet til den første konteringslinje, og lad alle øvrige linjer stå til nul",
      "add_remainder_as_new_entry_description": "Behold de eksisterende linjebeløb, og tilføj et eventuelt restbeløb som en ny konteringslinje",
      "add_remainder_to_first_entry_description": "Behold de eksisterende linjebeløb, og tilføj et eventuelt restbeløb til den første linje\n",
      "subtitle": "Anvend kreditors seneste konteringslinjer",
      "distribute_evenly": "Fordel ligeligt på konteringslinjer\n"
    },
    "apply_most_recent_flow": {
      "description_assign": "Anvend seneste flow og tildel ",
      "assign_and_send": "Tildel seneste flow og send til gennemgang",
      "subtitle": "Anvend det senest brugte flow fra kreditoren",
      "assign": "Tildel seneste flow",
      "description_assign_and_send": "Anvend seneste flow og tildel og send til gennemgang",
      "title": "Anvend senest brugte flow"
    },
    "apply_most_used_journal_entries": {
      "last_3_months_description": "Anvend den mest brugte konteringskombination fra de seneste 3 måneder",
      "last_6_months": "Seneste 6 måneder",
      "last_3_months": "Seneste 3 måneder",
      "last_6_months_description": "Anvend den mest brugte konteringskombination fra de seneste 6 måneder",
      "select_period_option": "Vælg en indstilling for periode",
      "the_period": "De {period}",
      "last_month_description": "Anvend den mest brugte konteringskombination fra den seneste måned.",
      "title_from": "Anvend den mest brugte kontering fra:",
      "title": "Brug de mest anvendte konteringslinjer",
      "subtitle": "Anvend de mest brugte konteringslinjer fra kreditoren",
      "period": "Periode",
      "last_month": "Seneste måned"
    },
    "buttons": {
      "add_action": "Tilføj handling",
      "delete_automation": "Slet automatisering",
      "save_automation": "Gem automatisering",
      "create_new_automation": "Opret ny automatisering",
      "apply_journal_entry": "Tilføj konteringslinjer",
      "yes_save_changes": "Ja, gem ændringer",
      "go_back": "Gå tilbage",
      "save_and_activate": "Gem og aktiver",
      "automation_order": "Automatiseringsrækkefølge",
      "remove_component": "Fjern komponent",
      "add_component": "Tilføj {component}",
      "add_loop": "Tilføj loop",
      "apply_check": "Tilføj tjek",
      "apply_creditor_check": "Tilføj kreditortjek",
      "revert_changes": "Nulstil ændringer",
      "yes_delete_automation": "Ja, slet automatisering",
      "update_automation": "Opdater automatisering",
      "add_check": "Tilføj tjek",
      "saving_automation": "Gemmer automatisering",
      "apply_send_action": "Tilføj handling",
      "apply_event_type": "Anvend event",
      "add_loop_action": "Tilføj loop handling",
      "delete_check": "Slet tjek",
      "add_loop_check": "Tilføj loop tjek",
      "delete_loop": "Slet loop",
      "add_step": "Tilføj trin",
      "add_loop_step": "Tilføj loop trin",
      "delete_action": "Slet handling"
    },
    "checks": {
      "check_method": "Tjekmetode",
      "checks": "Tjeks",
      "is_not_empty": "Er ikke tom",
      "is_empty": "Er tom",
      "add_a_check": "Tilføj et tjek til automatiseringen",
      "not_equals": "Er ikke",
      "search_for_a_check": "Søg efter et tjek",
      "check": "tjek",
      "choose_a_check_method": "Vælg venligst en tjekmetode",
      "is_one_of": "Er en af",
      "no_search_results": "Vi kunne ikke finde det tjek, du ledte efter",
      "is_not_one_of": "Er ikke en af",
      "equals": "Er",
      "greater_than_or_equal_to": "Er større end eller lig med",
      "greater_than": "Er større end",
      "does_not_contain_similar": "Indeholder ikke lignende",
      "contains_similar": "Indeholder lignende",
      "not_equals_description": "Kontrollerer, om feltet ikke matcher værdien præcist",
      "does_not_start_with": "Starter ikke med",
      "less_than_or_equal_to_description": "Kontrollerer, om feltet er mindre end eller lig med værdien",
      "does_not_start_with_description": "Kontrollerer, om feltet ikke starter med værdien",
      "does_not_match_regex": "Matcher ikke regex",
      "ends_with_description": "Kontrollerer, om feltet slutter med værdien",
      "equals_description": "Kontrollerer, om feltet matcher værdien præcist",
      "less_than_description": "Kontrollerer, om feltet er mindre end værdien",
      "does_not_contain_description": "Kontrollerer, om feltet ikke indeholder værdien",
      "less_than": "Er mindre end",
      "is_not_empty_description": "Kontrollerer, om feltet har en værdi",
      "contains_description": "Kontrollerer, om feltet indeholder værdien",
      "greater_than_description": "Kontrollerer, om feltet er større end værdien",
      "is_empty_description": "Kontrollerer, om feltet ikke har en værdi",
      "does_not_match_regex_description": "Kontrollerer, om feltet ikke matcher et regulært udtryk",
      "is_not_one_of_description": "Kontrollerer, om feltet ikke matcher nogen af de valgte værdier",
      "matches_regex": "Matcher regex",
      "does_not_end_with": "Slutter ikke med",
      "does_not_contain": "Indeholder ikke",
      "is_one_of_description": "Kontrollerer, om feltet matcher en af de valgte værdier",
      "less_than_or_equal_to": "Er mindre end eller lig med",
      "ends_with": "Slutter med",
      "greater_than_or_equal_to_description": "Kontrollerer, om feltet er større end eller lig med værdien",
      "matches_regex_description": "Kontrollerer, om feltet matcher et regulært udtryk",
      "contains": "Indeholder",
      "does_not_end_with_description": "Kontrollerer, om feltet ikke slutter med værdien",
      "starts_with_description": "Kontrollerer, om feltet starter med værdien",
      "starts_with": "Starter med"
    },
    "columns": {
      "status": "Status ",
      "description": "Beskrivelse",
      "name": "NAVN",
      "event_type": "Event type",
      "stop_other_automations": "Auto-stop"
    },
    "check": {
      "else_if": "Ellers hvis: {type} {condition}",
      "if": "Hvis: {type} {condition}"
    },
    "block": {
      "add_a_component": "Tilføj et komponent"
    },
    "creditor_check": {
      "add_more_creditors": "Tilføj flere kreditorer",
      "creditor": "Kreditor",
      "title": "Kreditor",
      "choose_a_creditor": "Vælg venligst en kreditor",
      "additional_creditor": "Ekstra kreditor | Ekstra kreditorer",
      "creditors": "{count} kreditore",
      "subtitle": "Tjek kreditoren"
    },
    "events": {
      "no_search_results": "Vi kunne ikke finde den begivenhed, du ledte efter",
      "search_for_an_event": "Søg efter et event",
      "event_title": "Events",
      "event_subtitle": "Vælg, hvilket event du vil starte fra"
    },
    "groups": {
      "document": "Dokument",
      "journal-entries": "Kontering",
      "flow": "Flow",
      "amounts": "Beløb",
      "payment-details": "Betalingsoplysninger",
      "dates": "Datoer",
      "loop-checks": "Linjetjek"
    },
    "create_journal_entries": {
      "add_rest_amount_to_last_entry_description": "Tilføj restbeløbet til den sidste konteringslinje",
      "title": "Opret konteringslinjer",
      "manual": "Manuel indtasting",
      "creditor_name": "Kreditornavn",
      "full_invoice_amount": "Fulde faktura beløb",
      "rest_invoice_amount": "Restbeløb",
      "subtitle": "Opret en eller flere konteringslinjer",
      "distribute_amount_evenly": "Fordel ligeligt",
      "add_rest_amount_to_last_entry": "Tilføj restbeløb til sidste konteringslinje",
      "add_full_amount_to_first_entry_description": "Tilføj hele beløbet til første konteringslinje",
      "add_full_amount_to_first_entry": "Tilføj hele beløbet til første linje",
      "manual_description": "Indtast beløbet manuelt på hver konteringslinje",
      "template_load_failed": "Konteringsskabelonen kunne ikke indlæses.",
      "remove_template_link": "Fjern tilknytning til skabelon",
      "template_linked": "Tilknyttet skabelon: {name}",
      "template_missing": "Den tilknyttede konteringsskabelon er ikke længere tilgængelig. Erstat den eller fjern tilknytningen for at opsætte konteringslinjer."
    },
    "empty": {
      "description": "Kom i gang ved at oprette automatiseringer, så Batchflow klarer arbejdet for dig",
      "header": "Ingen automatiseringer er blevet oprettet endnu..."
    },
    "notifications": {
      "deleted_automation_subtitle": "{automation} blev slettet korrekt, og vil ikke blive kørt igen",
      "automation_was_updated_subtitle": "{automation} blev opdateret korrekt",
      "automation_was_not_saved_subtitle": "{automation} kunne ikke gemmes, prøv igen senere",
      "automation_was_saved_subtitle": "{automation} blev gemt korrekt",
      "automation_was_not_saved": "Noget gik galt..",
      "deleted_automation": "Automatiseringen blev slettet",
      "automation_was_updated": "Automatiseringen blev opdateret",
      "automation_was_saved": "Automatiseringen blev gemt"
    },
    "event": {
      "event_subtitle": "Vælg hvilken type event du vil starte med",
      "document-received": "Dokument modtaget",
      "event_title": "Event",
      "document_received_title": "Dokument er modtaget",
      "document_received_subtitle": "Kører, når et nyt dokument modtages i Batchflow",
      "document-ready-for-export": "Dokument er klar til eksport",
      "item_approved_title": "Dokument er godkendt",
      "document-final-approved": "Dokument er endeligt godkendt",
      "item_declined_subtitle": "Kører, når et dokument bliver endeligt afvist i flowet",
      "item_export_error_title": "Dokument har eksportfejl",
      "item_declined_title": "Dokument er afvist",
      "document-put-on-hold": "Dokument er sat på hold",
      "document-exported": "Dokument er eksporteret",
      "item_export_error_subtitle": "Kører, når der opstår en fejl under eksport",
      "item_approved_subtitle": "Kører, når et dokument bliver godkendt af en bruger",
      "document-approved": "Dokument er godkendt",
      "item_put_on_hold_subtitle": "Kører, når et dokument bliver sat på hold",
      "item_put_on_hold_title": "Dokument er sat på hold",
      "item_received_title": "Dokumentet er modtaget",
      "item_ready_for_export_subtitle": "Kører, når et dokument bliver klar til eksport",
      "item_exported_title": "Dokument er eksporteret",
      "item_final_approved_title": "Dokumentet er endeligt godkendt",
      "item_final_approved_subtitle": "Kører, når et dokument bliver endeligt godkendt i flowet",
      "document-export-error": "Dokument har en eksportfejl",
      "item_exported_subtitle": "Kører, når eksporten af et dokument er fuldført",
      "item_sent_to_inbox_subtitle": "Kører, når et dokument sendes til godkendelse",
      "item_received_subtitle": "Kører, når et nyt dokument modtages i Batchflow",
      "item_ready_for_export_title": "Dokumentet er klar til eksport",
      "document-sent-to-inbox": "Dokument er sendt til en indbakke",
      "item_sent_to_inbox_title": "Dokumentet er sendt til godkendelse",
      "document-declined": "Dokument er afvist"
    },
    "fields": {
      "description": "Beskrivelse",
      "statusstring": "Status",
      "eventtypestring": "Event type",
      "name": "Navn",
      "conditionstring": "Tjekmetode"
    },
    "components": {
      "add_component": "Tilføj et komponent til din automatisering",
      "components": "Komponenter"
    },
    "condition": {
      "title": "Betingelse: {condition}"
    },
    "loops": {
      "loop": "loop",
      "loops": "Loops",
      "add_a_loop": "Tilføj et loop",
      "coming_soon": "Kommer snart...",
      "incompatible_fields": "Den valgte kilde understøtter ikke disse felter: {fields}",
      "show": "Vis",
      "action_count": "{count} handling | {count} handlinger",
      "source": "Kilde",
      "for_each": "Loop over",
      "for_each_description": "Kører underliggende blokke én gang for hver linje i kilden",
      "collapse": "Skjul",
      "product_lines_description": "Én gang for hver varelinje på dokumentet",
      "check_count": "{count} tjek | {count} tjek",
      "choose_source": "De trin, du tilføjer, køres én gang for hver af disse linjer",
      "empty_body": "Ingen trin endnu",
      "accounting_lines": "Konteringslinjer",
      "product_lines": "Varelinjer",
      "accounting_lines_description": "Én gang for hver konteringslinje på dokumentet"
    },
    "order_modal": {
      "activate": "Aktiver",
      "automation_could_not_be_activated": "Automatiseringen kunne ikke aktiveres",
      "title": "Automatiseringsrækkefølge",
      "deactivate": "Deaktiver",
      "move_to_top": "Flyt til toppen",
      "move_to_bottom": "Flyt til bunden",
      "no_automations": "Ingen automatiseringer at sortere endnu",
      "create_automations_to_order": "Når automatiseringer er oprettet, vil du kunne ændre rækkefølgen, de bliver udført i.",
      "applying_order": "Tildeler rækkefølge",
      "search_for_automations": "Søg efter automatisering",
      "navigate_to_automation": "Gå til automatisering",
      "apply_order": "Tildel rækkefølge",
      "automation_could_not_be_activated_description": "Automatiseringen skal mindst have én handling før at den kan aktiveres.\nVil du gå til automatiseringen for at tilføje en handling?"
    },
    "search": {
      "please_check_your_spelling": "Tjek din stavning eller prøv et andet søgeord"
    },
    "send_to_flow": {
      "subtitle": "Send dokumentet i et specifikt flow",
      "assign_and_send_description": "Tildel og send dokumentet til brugernes indbakke",
      "assign_and_send": "Tildel flow og send til gennemgang",
      "assign": "Tildel",
      "assign_description": "Tildel flow uden at sende til gennemgang",
      "flow": "Flow",
      "select_a_flow": "Vælg venligst et flow",
      "assign_method": "Tildelingsmetode",
      "title": "Tildel til flow",
      "select_an_assign_method": "Vælg venligst en tildelingsmetode"
    },
    "send_to_user": {
      "select_an_assign_method": "Vælg venligst en tildelingsmetode",
      "user": "Bruger",
      "subtitle": "Send dokumentet til en specifik bruger",
      "assign": "Tildel",
      "assign_method": "Tildelingsmetode",
      "assign_user_and_send": "Tildel bruger og send til gennemgang",
      "assign_description": "Tildel brugeren uden at sende til gennemgang",
      "title": "Tildel til bruger",
      "choose_a_user": "Vælg venligst en bruger",
      "assign_user_and_send_description": "Tildel og send dokumentet til brugerens indbakke"
    },
    "status": {
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "deleted": "Slettet"
    },
    "warnings": {
      "remove_entire_chain_confirmation_subtext": "Denne handling kan fortrydes ved at klikke Fortryd",
      "unsaved_changes": "Vil du beholde dine ændringer?",
      "delete_automation_confirmation": "Ved at slette automatiseringen mister du den nuværende opsætning. Automatiseringen vil blive fjernet fra listen og kan ikke køres igen.",
      "remove_entire_chain_confirmation": "Ved at fjerne '{component}' fjerner du denne og alle underliggende komponenter.",
      "remove_entire_chain": "Du er ved at slette en hel sektion",
      "unsaved_changes_confirmation": "Du har ændringer, der ikke er gemt. Hvis du forlader siden nu, vil de gå tabt.",
      "delete_automation": "Er du sikker på, at du ønsker at slette automatiseringen?"
    },
    "title": {
      "no_description_provided": "Ingen beskrivelse er blevet angivet",
      "untitled_automation": "Unavngiven automatisering"
    },
    "save_automation_modal": {
      "save_automation_title": "Gem automatisering"
    },
    "tooltips": {
      "add_an_else": "Tilføj en ellers-handling"
    },
    "save_automation_modals": {
      "save_automation_subtitle": "Sæt navn og beskrivelse af din automatisering"
    },
    "search_empty": {
      "header": "Ingen matchende automatiseringer",
      "description": "Prøv en anden søgning for at finde automatiseringer."
    },
    "loop": {
      "title": "{loop}",
      "coming_soon": "Kommer snart..."
    },
    "automation_order": "Automatiseringsrækkefølge",
    "validation": {
      "activation_requirements": "Løs kravene, før denne automatisering aktiveres.",
      "not_ready_to_activate": "Ikke klar til aktivering",
      "template_missing": "En tilknyttet konteringsskabelon mangler. Ret den berørte handling, før automatiseringen aktiveres.",
      "self_trigger_warning": "Denne handling kan udløse automatiseringen igen. Loopbeskyttelse forhindrer gentagne kørsler, men gennemgå events og handlingerne, før automationen aktiveres."
    },
    "item_field_check": {
      "currency_subtitle": "Tjek valutaen",
      "ocr_text_subtitle": "Tjek om dokumentet indeholder en bestemt tekst",
      "vat_amount_subtitle": "Tjek momsbeløbet",
      "document_type_placeholder": "Vælg venligst en dokumenttype",
      "net_amount_subtitle": "Tjek nettobeløbet",
      "vat_amount_title": "Momsbeløb",
      "vat_amount_label": "Momsbeløb",
      "regex_no_matches": "Ingen matches fundet",
      "invoice_number_placeholder": "Indtast fakturanummer eller mønster",
      "payment_type_label": "Betalingstype",
      "due_date_subtitle": "Tjek forfaldsdatoen",
      "invoice_date_title": "Fakturadato",
      "currency_label": "Valuta",
      "payment_type_subtitle": "Tjek betalingstypen",
      "invoice_date_label": "Fakturadato",
      "value_not_available": "En eller flere valgte værdier er ikke tilgængelige for dette felt.",
      "condition_not_available": "Denne kontrolmetode er ikke tilgængelig for det valgte felt.",
      "ocr_text_placeholder": "Indtast tekst eller wildcard",
      "invoice_number_label": "Fakturanummer",
      "additional_field_value_label": "Værdi i yderligere felt",
      "payment_type_placeholder": "Vælg venligst en betalingstype",
      "amount_placeholder": "Indtast beløb",
      "add_more_values": "Tilføj flere værdier",
      "total_amount_subtitle": "Tjek totalbeløbet",
      "regex_test_label": "Testværdi",
      "invoice_number_title": "Fakturanummer",
      "net_amount_label": "Nettobeløb",
      "document_type_title": "Dokumenttype",
      "additional_field_title": "Yderligere felter",
      "additional_field_subtitle": "Søg i selskabsspecifikke dokumentfelter",
      "date_placeholder": "ÅÅÅÅ-MM-DD",
      "regex_test_placeholder": "Indtast en værdi, der skal testes",
      "regex_invalid": "Indtast et gyldigt regulært udtryk",
      "additional_field_label": "Yderligere felt",
      "total_amount_label": "Totalbeløb",
      "regex_empty_match": "Tomt match",
      "regex_matches_found": "{count} match fundet | {count} matches fundet",
      "not_date_filter": "Ikke {filter}",
      "additional_field_value_placeholder": "Indtast feltværdi eller wildcard",
      "net_amount_title": "Nettobeløb",
      "total_amount_title": "Totalbeløb",
      "invoice_date_subtitle": "Tjek fakturadatoen",
      "document_type_label": "Dokumenttype",
      "currency_placeholder": "Vælg venligst en valuta",
      "payment_type_title": "Betalingstype",
      "due_date_label": "Forfaldsdato",
      "due_date_title": "Forfaldsdato",
      "generic_title": "Feltkontrol",
      "document_type_subtitle": "Tjek dokumenttypen",
      "invoice_number_subtitle": "Tjek fakturanummeret",
      "additional_field_placeholder": "Vælg venligst et yderligere felt",
      "duplicate_value": "Den samme værdi kan ikke bruges mere end én gang.",
      "too_many_values": "Fjern de ekstra værdier, før kontrollen anvendes.",
      "currency_title": "Valuta",
      "ocr_text_title": "Dokumenttekst",
      "ocr_text_label": "Dokumenttekst",
      "line_price_label": "Linjepris",
      "account_number_label": "Kontonummer",
      "discount_percentage_label": "Rabatprocent",
      "quantity_subtitle": "Tjek antallet",
      "unit_price_label": "Enhedspris",
      "line_amount_label": "Beløb",
      "item_number_label": "Varenummer",
      "vat_percentage_label": "Momsprocent",
      "loop_text_placeholder": "Indtast en værdi",
      "description_subtitle": "Tjek beskrivelsen",
      "loop_field_subtitle": "Tjek et felt på den aktuelle linje",
      "line_price_subtitle": "Tjek linjeprisen",
      "line_name_label": "Linjenavn",
      "line_name_subtitle": "Tjek linjenavnet",
      "date_on_or_before": "På eller før",
      "quantity_label": "Antal",
      "date_on_or_after": "På eller efter",
      "description_label": "Beskrivelse",
      "date_after": "Efter",
      "discount_amount_label": "Rabatbeløb",
      "vat_percentage_subtitle": "Tjek momsprocenten",
      "unit_price_subtitle": "Tjek enhedsprisen",
      "item_number_subtitle": "Tjek varenummeret",
      "date_before": "Før",
      "posting_text_label": "Posteringstekst",
      "vat_code_label": "Momskode"
    },
    "conditions": {
      "invalid_block": "Betingelsesblokken var ugyldig",
      "passed": "Betingelsen blev opfyldt",
      "did_not_pass": "Betingelsen blev ikke opfyldt"
    },
    "search_and_filter": "Søg og filtrer efter Navn, Beskrivelse eller Begivenhedstype",
    "settings_modal": {
      "stop_if_validation_fails": "Stop ved valideringsfejl",
      "subtitle": "Angiv specifikke indstillinger for denne automatisering",
      "stop_other_automations_on_success": "Stop automatisk andre automatiseringer",
      "title": "Automatiseringsindstillinger",
      "stop_if_validation_fails_description": "Hvis der opstår valideringsfejl, når denne automatisering kører, stopper den",
      "stop_other_automations_on_success_description": "Når denne automatisering lykkes, springes senere matchende automatiseringer over"
    },
    "variable_expression": {
      "overlay_heading": "Dokumentvariabler",
      "text_placeholder": "Skriv tekst, eller brug {'@'} til at indsætte en variabel",
      "formula_badge": "Formel",
      "operator_left_bracket": "Venstre parentes",
      "validation_divide_by_zero": "Du kan ikke dividere med nul",
      "remove_dynamic_text": "Fjern dynamisk tekst",
      "validation_unmatched_bracket": "Uparret parentes",
      "operator_divide": "Divider",
      "operator_right_bracket": "Højre parentes",
      "validation_operator_after_open": "En operator kan ikke følge en åbningsparentes",
      "overlay_subtitle_operators": "Vælg en operator til beregning",
      "add_function": "Tilføj en funktion",
      "validation_empty_text": "Tilføj først tekst eller en variabel",
      "validation_ends_with_operator": "En formel kan ikke slutte med en operator",
      "validation_empty_amount": "Tilføj først en variabel eller et tal",
      "operator_multiply": "Multiplicer",
      "operator_subtract": "Subtraher",
      "operator_add": "Adder",
      "overlay_subtitle": "Vælg en variabel, der skal tilføjes",
      "operators_category": "Operatorer",
      "overlay_subtitle_with_operators": "Vælg en variabel eller operator, der skal tilføjes",
      "full_view": "Fuld visning",
      "validation_missing_operator": "Manglende operator mellem værdier",
      "dynamic_text_badge": "Dynamisk tekst",
      "validation_invalid_amount": "Det er ikke en gyldig formel",
      "empty_calculation": "Intet tilføjet endnu",
      "add_dynamic_text": "Tilføj dynamisk tekst",
      "validation_two_operators": "To operatorer i træk",
      "validation_starts_with_operator": "En formel kan ikke starte med en operator",
      "remove_formula": "Fjern formel",
      "calculation_help": "Skriv tal, variabler eller operatorer",
      "overlay_search_empty": "Tjek stavningen, eller prøv en ny søgning"
    },
    "stop_other": {
      "off": "Fra",
      "on": "Til"
    },
    "calculate_due_date": {
      "description": "Forfaldsdatoen beregnes ud fra fakturadatoen og kreditorens betalingsbetingelser. Hvis den ikke kan beregnes, bruges forfaldsdatoen på dokumentet i stedet",
      "title": "Beregn forfaldsdato",
      "description_title": "Sådan beregnes forfaldsdatoen",
      "subtitle": "Beregn forfaldsdato ud fra kreditors betalingsbetingelser"
    },
    "approve_document": {
      "description_title": "Automatisk godkendelse",
      "description": "Dokumentet godkendes automatisk af systembrugeren “{user}”, når dokumentet er valideret uden fejl",
      "title": "Godkend dokument",
      "subtitle": "Godkend dokumentet automatisk"
    },
    "export_document": {
      "description": "Det godkendte dokument eksporteres af systembrugeren “{user}”. Mislykkede eksporter skal forsøges igen manuelt.",
      "description_title": "Automatisk eksport",
      "subtitle": "Eksporter det godkendte dokument automatisk",
      "title": "Eksporter dokument"
    }
  },
  "attachment": {
    "delete": {
      "warning": "Denne handling fjerner den vedhæftede fil fra dokumentet.",
      "warning2": "Denne handling kan ikke fortrydes.",
      "header": "Er du sikker på, at du vil slette den vedhæftede fil?",
      "yes_delete": "Ja, slet vedhæftet fil"
    }
  },
  "document": {
    "search": "Søg",
    "change_archive_category_message": "Vælg en arkivkategori for dette dokument ",
    "return_error": "Dokumentreturnering mislykkedes!",
    "change_category": "Skift kategori",
    "permently_delete": "Er du sikker på, at du vil slette dokumentet permanent??",
    "change_archive_category": "Skift arkivkategori",
    "approved": "Dokumentet blev godkendt",
    "return_from_delete_message": "Dokumentet vil blive fjernet fra Slettede og returneret til",
    "action_initial_message": "Vælg den handling, du ønsker at udføre på dokumentet.",
    "place_on_hold": "Dokument sat på hold",
    "re_export": "Eksporter igen",
    "permanently_delete_title": "Er du sikker på, at du vil slette dokumentet permanent?",
    "permanently_delete": "Slet permanent",
    "deletion_note": "Årsag til sletning",
    "move_to_archive": "Flyt til Arkiverede",
    "permanent_delete_message": "Dokumentet vil blive slettet permanent fra Batchflow.",
    "return_from_hold": "Dokument returneret",
    "direction": "Retning",
    "re_export_message": "Dokumentet vil blive sendt til {erpname} igen.",
    "return_toast": "Dokument returneret",
    "return_success": "Arkiveret dokument til nyt dokument",
    "re_export_error": "Dokumentet kunne ikke eksporteres igen.",
    "sorting": "Sortering",
    "re_export_title": "Er du sikker på, at du vil eksportere dette dokument igen?",
    "flow": "Dokumentflow",
    "return_title": "Er du sikker på, at du vil returnere dokumentet?",
    "archive_return_message": "Dokumentet fjernes fra sletning og returneres til arkivet.",
    "declined": "Dokumentet blev afvist",
    "delete_placeholder": "Angiv årsagen til at slette dokumentet",
    "clear_search": "Ryd søgning",
    "return": "Returner",
    "move_to_exported": "Flyt til Eksporteret",
    "delete": "Slet",
    "export": {
      "dont_show_again": "Vis ikke igen",
      "in_progress_title": "Dit dokument bliver eksporteret",
      "in_progress_help_text": "Mens eksporten er i gang, vil dokumentet fremgå under Udgående. Når eksporten er fuldført, flyttes det til Eksporterede.",
      "re_export": "Eksporter dette dokument igen",
      "re_export_success": "Du har eksporteret dokumentet igen.",
      "in_progress_message": "Hvis eksporten lykkes, vil {erpname} returnere et bilagsnummer. Dette kan tage et par minutter.",
      "re_export_success_toast_title": "Dokumentet er blevet eksporteret igen."
    },
    "duplicate": {
      "title": "Duplikeret dokument"
    },
    "archive": {
      "toast_message": "Du har nu ændret arkivkategorien til ",
      "toast_title": "Arkivkategori ændret"
    },
    "reason": {
      "change_category_error": "Ændring af varekategori mislykkedes!"
    },
    "item": {
      "return_from": "Fra",
      "return_to": "Du har returneret dokumentet til"
    },
    "yes_permanently_delete": "Ja, slet permanent",
    "yes_re_export": "Ja, eksporter igen",
    "active": {
      "title": "Aktivt dokument"
    },
    "return_message": "Dokumentet fjernes fra Arkivede og returneres til \nNye dokumenter",
    "return_to_widget_message": "Dokumentet vil blive returneret til",
    "sorting_and_company": "Sortering og virksomheder"
  },
  "command_palette": {
    "dates": {
      "last_90_days": "Sidste 90 dage",
      "last_60_days": "Sidste 60 dage",
      "current_month": "Nuværende måned",
      "current_quarter": "Indeværende kvartal",
      "last_quarter": "Sidste kvartal",
      "last_month": "Sidste måned",
      "last_30_days": "Sidste 30 dage",
      "operator": "Dato"
    },
    "filter": {
      "currency": "Valuta",
      "amount": "Beløb",
      "creditor": "Kreditor",
      "flow": "Flow",
      "filter_by_document_type": "Filtrer efter dokumenttype",
      "filter_by_ocr": "Filtrer efter fritekst",
      "filter_by_date": "Filtrer efter dato",
      "posting": "Kontering",
      "document_type": "Dokumenttype",
      "status": "Status",
      "date": "Dato",
      "filter_by_amount": "Filtrer efter beløb",
      "ocr": "Fritekst",
      "filter_by_status": "Filtrer efter status",
      "filter_by_invoiceno": "Filtrer efter fakturanummer",
      "filter_by_payment_method": "Filtrer efter betalingstype",
      "filter_by_creditor": "Filtrer efter kreditor",
      "filter_by_posting": "Filtrer efter kontering",
      "payment_type": "Betalingstype",
      "filter_by_flow": "Filterer efter flow",
      "filter_by_currency": "Valuta",
      "company": "Selskab",
      "filter_by_assignee": "Filtrer efter tildelt",
      "assigned_to_out_of_office_users": "Tildelt til brugere, der er out of office",
      "filter_by_document_id": "Filtrer efter dokument-ID",
      "filter_by_vouchernumber": "Filtrer efter bilagsnummer",
      "assignee": "Tildelt",
      "assigned_to": "Tildelt til"
    },
    "placeholder": "Skriv en kommando eller søg...",
    "search": {
      "please_wait_while_we_check": "Vent venligst imens vi tjekker",
      "no_results_found": "Ingen resultater fundet",
      "searching": "Søger...",
      "search_for": "Søg efter '{search}'",
      "check_spelling_or_try_again": "Tjek stavningen, eller prøv en ny søgning"
    },
    "operator": {
      "before": "Før",
      "is_less_than": "Er mindre end",
      "like": "Indeholder",
      "after": "Efter",
      "range": "Interval",
      "is_bigger_than": "Er større end",
      "equal_to": "Er lig med",
      "on": "På"
    },
    "keybinds": {
      "to_select": "for at vælge",
      "to_go_back": "for at gå tilbage",
      "to_close": "for at lukke",
      "press": "Tryk",
      "to_navigate": "for at navigere"
    },
    "result": {
      "show_more": "Vis flere",
      "documents": "Dokumenter",
      "lists": "Lister",
      "show_documents_in_widget": "Vis {count} i {widget}",
      "show_all_documents": "Vis {count} dokument | Vis alle {count} dokumenter",
      "no_assignees": "Ingen tildelte"
    },
    "status": {
      "export_error": "Eksportfejl",
      "declined": "Afviste",
      "deleted": "Slettede",
      "exported": "Eksporterede",
      "archive": "Arkiv",
      "approved": "Godkendte",
      "on_hold": "På hold",
      "new_documents": "Nye dokumenter",
      "my_inbox": "Min indbakke",
      "under_review": "Under gennemgang"
    },
    "results": {
      "archived_documents": "Arkiverede dokumenter"
    },
    "groups": {
      "filter_by_company": "Filtrer på selskab",
      "suggestions": "Forslag",
      "go_to_widget": "Gå til widget"
    },
    "amount": {
      "operator": "Beløb"
    },
    "widget_action": {
      "go_to": "Gå til {widget}",
      "go_to_inbound": "Gå til Indgående"
    }
  },
  "bottomsheet": {
    "logout_message": "Det ser ud til, at du er blevet logget ud af Batchflow."
  },
  "costtype": {
    "fields": {
      "closedaccountnumber": "Kontonummer - lukket",
      "costtypenumber": "Omkostningsnummer",
      "active": "Aktiv",
      "markup": "Avanceprocent",
      "vatcode": "Momskode",
      "ongoingaccountnumber": "Kontonummer - igangværende"
    }
  },
  "datepicker": {
    "choose_a_date": "Vælg en dato",
    "apply_range": "Brug interval",
    "choose_a_date_range": "Vælg et dato interval"
  },
  "creditors": {
    "creditor": {
      "zip_code": "Postkode",
      "contact_email": "E-mail",
      "standard_currency": "Standard valuta",
      "contact_phone": "Telefonnummer",
      "payment_scheme": "Betalingstype",
      "phone_number": "Telefonnummer",
      "creditor_number": "Kreditornummer",
      "cvr": "CVR-nummer",
      "creditor_id": "Kreditor-ID",
      "currency": "Valuta",
      "payment_terms": "Betalingsbetingelser",
      "type": "Type",
      "address": "Adresse",
      "country": "Land",
      "payment_details": "Betalingsoplysninger",
      "contact_details": "Kontaktoplysninger",
      "contact_name": "Kontaktperson",
      "city": "By",
      "registration_number": "Registreringsnummer",
      "name": "Kreditornavn",
      "details": "Kreditor detaljer",
      "account_number": "Kontonummer"
    },
    "columns": {
      "cvr": "CVR-nummer",
      "name": "Navn",
      "address": "Adresse",
      "creditornumber": "Kreditornummer"
    },
    "search_and_filter": "Søg og filtrer efter Navn, Kreditornr. eller CVR-nr."
  },
  "confirm": {
    "email": {
      "button": "Log ind med din nye e-mail",
      "description": "Du har bekræftet din nye e-mailadresse, som nu kan bruges til at få adgang til Batchflow.",
      "title": "Din nye e-mail er nu bekræftet!"
    }
  },
  "dates": {
    "older": "Ældre",
    "yesterday": "I går",
    "today": "I dag"
  },
  "default": {
    "not_set": "Ikke angivet"
  },
  "details": {
    "meta": {
      "description": "Se dine faktura detaljer",
      "title": "Detaljer"
    }
  },
  "documents": {
    "meta": {
      "title": "Dokumenter",
      "description": "Se dine dokumenter"
    },
    "entry": {
      "cant_remind_yourself": "Du kan ikke sende påmindelser til dig selv.",
      "you_can_remind_again": "Du kan påminde igen {time}",
      "view": "Se",
      "not_set": "Ikke angivet",
      "last_reminded": "Sidst påmindet",
      "exported": "Eksporteret",
      "days_in_inbox": "{days} i indbakken",
      "review_started": "{days} siden flow start",
      "remind_assignee": "Påmind",
      "last_viewed": "Sidst vist",
      "assignee": "Tildelt"
    },
    "empty": {
      "subheader": "Gå videre til din næste opgave... eller tag en kaffepause.",
      "header": "Du er helt opdateret!"
    },
    "search_empty": {
      "subheader": "Vi kunne desværre ikke finde, hvad du ledte efter. Prøv venligst en ny søgning.",
      "header": "Søgeboksen er tom!"
    },
    "list": {
      "end_of_list": "Det ser ud til, at du har set det hele! Du er nået til enden af listen."
    },
    "preview": {
      "title": "Dokumentvisning"
    },
    "validation": {
      "issues": "{count} advarsel | {count} advarsler"
    },
    "alerts": {
      "due_in_days": "Forfalder om {count} dag | Forfalder om {count} dage",
      "title": "Advarsler",
      "overdue": "Forfalden",
      "due_today": "Forfalder i dag",
      "overdue_days": "{count} dag over forfald | {count} dage over forfald"
    }
  },
  "economic_integration": {
    "expansions": {
      "projects": "Projekter",
      "header": "Udvidelser"
    },
    "api_details": {
      "header": "API Detaljer",
      "api_token": "e-conomic API nøgle",
      "how_do_i_find_api_token": "Hvordan finder jeg min e-conomic API nøgle?",
      "connection_established": "Forbundet",
      "subtitle": "Angiv venligst en API nøgle"
    },
    "journal_details": {
      "how_do_i_find_journals": "Hvor finder jeg kladderne i e-conomic, og hvilken skal jeg vælge?",
      "header": "Kladde",
      "journal": "e-conomic kladde",
      "subtitle": "Vælg venligst hvilken kladde du vil benytte"
    },
    "dimensions": {
      "subtitle": "Vælg venligst hvilke dimensioner at inkludere",
      "header": "Dimensioner",
      "show_dimension": "Vis '{dimension}'"
    },
    "configuration": {
      "header": "e-conomic integration"
    },
    "units": {
      "header": "Enheder",
      "enable_unit": "Vis Enhed{unit} / Antal{unit}",
      "subtitle": "Vælg venligst hvilke enheder at inkludere"
    },
    "setup": {
      "completing_setup": "Gennemfører opsætning",
      "verifying_connection": "Verificerer nøgle",
      "verify_connection": "Verificer nøgle",
      "complete": "Gennemfør opsætning",
      "next": "Næste",
      "header": "Opsæt e-conomic integration",
      "back": "Tilbage"
    },
    "sections": {
      "section_2": "Betalingsbetingelser",
      "last_run": "Seneste kørsel",
      "latest_job_status_3": "Fejlet",
      "interval": "Interval",
      "force_run": "Kør",
      "section_9": "Enheder",
      "section_7": "Dimensioner",
      "header": "Sektioner",
      "latest_job": "Seneste job",
      "section_8": "Moms koder",
      "section_-1": "Eksport",
      "latest_job_status_processed_items": "Håndterede {count} genstande",
      "section": "Sektion",
      "next_run": "Næste kørsel",
      "section_3": "Betalingstyper",
      "enabled": "Aktiveret",
      "section_0": "Kontoplan",
      "completion_time": "Færdiggørelsestid",
      "latest_job_status_0": "Afventer",
      "section_1": "Leverandøre",
      "section_10": "Medarbejder"
    },
    "webhooks": {
      "type": "Type",
      "webhook_type_1": "Kreditor opdateret",
      "webhook_type_5": "Projekt opdateret",
      "body": "Sendte data",
      "webhook_type_8": "Momskode opdateret",
      "webhook_type_2": "Betalingsbetingelser opdateret",
      "url": "URL",
      "webhook_type_9": "Enheder opdateret",
      "webhook_type_0": "Kontoplan opdateret",
      "webhook_type_10": "Medarbejder opdateret",
      "webhook_type_7": "Dimensioner opdateret"
    }
  },
  "sidebar": {
    "search": "Søg",
    "shortcuts": "Genveje",
    "archive": "Arkiv",
    "inbound": "Indgående / Udgående",
    "settings": "Indstillinger",
    "documents": "Dokumenter",
    "wiki": "Wiki"
  },
  "document_status": {
    "approved": "Godkendt",
    "on_hold": "På hold",
    "archived": "Arkiverede",
    "declined": "Afvist",
    "exporting": "Eksporterer",
    "under_review": "Under gennemgang",
    "exported": "Eksporteret",
    "export_failed": "Eksportfejl",
    "notinflow": "Nye dokumenter"
  },
  "document_types": {
    "customer_order": "Kundeordre",
    "goods_invoice": "Varefaktura",
    "creditnote": "Omkostningskreditnota",
    "split": "Split",
    "mileage": "Kørsel",
    "goods_credit_note": "Varekreditnota",
    "expense": "Udlæg",
    "invoice": "Omkostningsfaktura",
    "requisition": "Rekvisition",
    "credit_note": "Omkostningskreditnota",
    "travel": "Travel"
  },
  "due": {
    "date": "Forfalder"
  },
  "economic_integrations": {
    "webhooks": {
      "how_to_setup_webhooks": "Hvordan opsætter jeg webhooks i e-conomic?",
      "copy_url": "Kopier URL",
      "copy_body": "Kopier sendte data",
      "header": "Webhooks"
    }
  },
  "emails": {
    "bulk_reminder": {
      "greeting": "Hej",
      "questions_or_assistance": "Hvis du har spørgsmål eller har brug for hjælp, bedes du kontakte os på",
      "document_review_request": "Anmodningen om dokumentgennemgang er vigtig og bør adresseres så hurtigt som muligt. Åbn Batchflow for at begynde gennemgangsprocessen.",
      "would_like_to_remind_you": "vil gerne minde dig om, at du har",
      "open_batchflow": "Åbn Batchflow",
      "documents": "dokumenter,",
      "subtitle": "Du har dokumenter, der venter",
      "subject": "Du har dokumenter til gennemgang",
      "pending_for_review": "der afventer gennemgang."
    },
    "thank_you": "Tak,",
    "the_batchflow_team": "Batchflow-teamet",
    "company_invitation": {
      "greeting": "Hej",
      "would_like_to_invite_you_to_organisation": "vil gerne invitere dig til at deltage i organisationen",
      "open_batchflow": "Åbn Batchflow",
      "open_invitation": "Åbn invitationen",
      "open_invitation_to_get_started": "Åbn invitationen for at oprette din bruger og begynde at arbejde med Batchflow. Bemærk, at invitationen udløber efter en måned",
      "open_batchflow_to_get_started_multiple": "Åben Batchflow og log ind for at se dokumenter for de nye selskaber",
      "open_batchflow_to_get_started": "Åben Batchflow og log ind for at se dokumenter for det nye selskab",
      "you_have_been_invited": "Du er blevet inviteret",
      "would_like_to_invite_you_to_company": "vil gerne invitere dig til at deltage i selskabet",
      "in_batchflow": "i Batchflow",
      "questions_or_assistance": "Hvis du har spørgsmål eller brug for hjælp, kan du kontakte os på",
      "subject": "Du er blevet inviteret"
    },
    "confirm_email": {
      "verify_email": "Bekræft ny e-mail",
      "is_this_your_new_email": "Er dette din nye e-mail?",
      "greeting": "Hej",
      "subject": "Bekræft din nye e-mail",
      "request_to_change_email": "Der er blevet anmodet om at ændre den e-mail, du bruger til at logge ind på Batchflow.",
      "please_verify_new_email": "Bekræft venligst, at dette er den nye e-mail, du vil bruge til at logge ind på Batchflow og modtage beskeder i fremtiden.",
      "if_not_you_then_contact_us": "Hvis du ikke har anmodet om denne ændring, bedes du kontakte os på"
    },
    "general": {
      "questions_or_assistance": "Hvis du har spørgsmål eller har brug for hjælp, bedes du kontakte os på ",
      "open_batchflow": "Åbn Batchflow"
    },
    "forgot_password": {
      "password_reset_valid_2": "kun",
      "reset_password_button": "Nulstil adgangskode",
      "request_reset_password": "Der er anmodet om at nulstille adgangskoden til din Batchflow-konto.",
      "subtitle": "Lad os nulstille din adgangskode",
      "password_reset_valid_4": "én gang.",
      "password_reset_valid_1": "Denne nulstillingsanmodning er",
      "password_reset_valid_3": "gældende de næste 24 timer, og kan kun benyttes",
      "reset_request_warning": "Hvis du ikke har anmodet om at nulstilling din adgangskode, bedes du kontakte os på",
      "greeting": "Hej",
      "subject": "Nulstil din adgangskode"
    },
    "reminder": {
      "would_like_to_remind_you": "vil gerne minde dig om, at du har et dokument, der afventer gennemgang.",
      "subject": "Du har et dokument til gennemgang",
      "document_review_request": "Anmodningen om dokumentgennemgang er vigtig og bør adresseres så hurtigt som muligt. Åbn Batchflow for at begynde gennemgangsprocessen.",
      "due_date": "Forfalder"
    },
    "daily_inbox_reminder": {
      "overdue_body_emphasis": "med det samme",
      "body": "Du har {count} dokument(er), der afventer gennemgang og godkendelse.",
      "overdue_body_prefix": "dokument(er) har nu overskredet forfaldsdatoen og afventer stadig din godkendelse. Gennemgå dem venligst",
      "greeting": "Hej",
      "current_month_body_after_count": "dokument(er) blev modtaget tidligere på måneden og afventer stadig din godkendelse. Hvis du godkender dem nu, hjælper det med at sikre en smidig og rettidig månedsafslutning.",
      "current_month_title": "Månedsafslutning nærmer sig",
      "due_soon_title": "Forfaldsdato nærmer sig",
      "due_soon_body_after_count": "dokument(er) nærmer sig forfaldsdatoen og afventer stadig din godkendelse. Gennemgå dem venligst hurtigt for at undgå forsinkelser og sen behandling.",
      "pending_body_count_suffix": "dokument(er)",
      "title": "Du har dokumenter til behandling",
      "review_prompt": "Brug et øjeblik på at gennemgå og godkende dine afventende dokumenter",
      "subject": "Batchflow | Du har dokumenter til behandling",
      "timely_approval_prefix": "Selvom dokumentet/dokumenterne måske ikke forfalder endnu,",
      "overdue_body_suffix": "for at undgå yderligere forsinkelser.",
      "why_it_matters_second": "Forsinkelser skaber frustration og kan føre til ufuldstændig eller sen rapportering",
      "overdue_title": "Forfaldne",
      "pending_body_suffix": "der afventer gennemgang og godkendelse.",
      "why_it_matters": "Hvorfor er det vigtigt?",
      "why_it_matters_third": "Dokumenter fra sidste måned er særligt vigtige at håndtere med det samme",
      "timely_approval_suffix": "- især når vi nærmer os slutningen af måneden.",
      "pending_body_prefix": "Du har",
      "review_pending_documents": "Gennemgå afventende dokumenter",
      "timely_approval_emphasis": "er rettidig godkendelse er vigtig",
      "why_it_matters_first": "Bogholderiet er afhængigt af din godkendelse for at bogføre dokumenter i tide til månedsafslutningen",
      "previous_month_title": "Afventer fra sidste måned",
      "previous_month_body_after_count": "dokument(er) blev modtaget i sidste måned og afventer stadig din godkendelse. De kræver opmærksomhed hurtigst muligt for at sikre en korrekt månedsafslutning.",
      "previous_months_title": "Afventer fra tidligere måneder"
    },
    "address": "Mileparken 22, 2. - DK-2740 Skovlunde"
  },
  "sorting": {
    "ascending": "Stigende",
    "descending": "Faldende",
    "apply": "Anvend",
    "category": "Kategorier"
  },
  "exported": {
    "reason_choice": {
      "already_exists_in_erp": "Findes allerede i ERP",
      "export_error_resolved_outside_batchflow": "Eksportproblem løst uden for BatchFlow",
      "entered_manually_in_erp": "Indtastet manuelt i ERP"
    },
    "document_reason_message": "Vælg en årsag til at markere dokumentet som eksporteret",
    "document": "Flyt dokument til Eksporteret"
  },
  "enablemfa": {
    "complete": "Fuldfør opsætning af totrinsbekræftelse",
    "completing": "Fuldfører opsætning af totrinsbekræftelse",
    "back": "Fortsæt til Batchflow",
    "complete_subtitle": "For kontoen <b>{email}</b>",
    "complete_title": "Totrinsbekræftelse fuldført",
    "success": "I fremtiden skal du bruge din authenticator app sammen med din e-mail og adgangskode for at logge ind.<br/><br/>Opbevar dine gendannelseskoder sikkert for at få adgang til din konto, hvis du mister din authenticator app.",
    "title": "Opsæt totrinsbekræftelse",
    "error": {
      "6digit_code": "En 6-cifret kode er påkrævet"
    },
    "meta": {
      "title": "Opsæt totrinsbekræftelse",
      "description": "Slå Multi-Factor til for din konto"
    },
    "success_title": "Authenticator app er blevet sat op",
    "invalid_code": "Koden er ikke gyldig, prøv venligst igen",
    "subtitle": "Scan QR-koden med din authenticator app og indtast den 6-cifrede kode, der vises i appen",
    "bottomtext": "Har du ikke en authenticator app? Prøv {link}",
    "recoverycodes": "Gendannelseskoder:",
    "qrcode": {
      "title": "Konfigurer tofaktorautentificering",
      "copy_failed": "QR-koden kunne ikke kopieres.\n",
      "copy": "Kopier koden",
      "continue": "Fortsæt",
      "subtitle": "Kopier denne kode, og indtast den i din autentificeringsapp",
      "code_copy_success": "QR-koden er kopieret!"
    },
    "code": {
      "subtitle": "Indtast den 6-cifrede kode, der vises i appen"
    },
    "mobile": {
      "trytext": "Prøv",
      "bottomtext": "Har du ikke en autentificeringsapp? "
    }
  },
  "users": {
    "columns": {
      "usertype": "Rolle",
      "companies": "Selskaber",
      "employee": "Navn",
      "mail": "E-mail",
      "status": "Status"
    },
    "out_of_office": {
      "users_are_out_of_office": "{count} bruger er Out of office | {count} brugere er Out of office",
      "user_is_out_of_office": "Bruger er Out of office",
      "users_are_delegates": "{count} bruger er stedfortræder | {count} brugere er stedfortræder"
    },
    "active": "Aktiv",
    "search_empty": {
      "header": "Der er ikke noget i boksen!",
      "subheader": "Vi kunne ikke finde det, du ledte efter. Prøv en anden søgning."
    },
    "deactivated": "Deaktiveret",
    "inactive": "Deaktiveret",
    "search_and_filter": "Søg og filtrer efter Navn, E-mail, Selskaber eller Status"
  },
  "erp": {
    "name": {
      "2": "e-conomic",
      "3": "Uniconta",
      "5": "Ordrestyring",
      "6": "Dataløn",
      "7": "Zenegy",
      "9": "SAP Business One",
      "10": "Minuba",
      "11": "MicroBizz",
      "12": "Business Central",
      "unknown": "Ukendt"
    }
  },
  "employee": {
    "fields": {
      "employeenumber": "Medarbejdernummer",
      "zipcode": "Postnummer",
      "address": "Adresse",
      "active": "Aktiv",
      "phone": "Telefon",
      "groupnumber": "Gruppenummer",
      "city": "By",
      "email": "E-mail"
    }
  },
  "excel": {
    "fields": {
      "creditor": "Kreditornummer",
      "bankaccountnumber": "Kontonummer"
    },
    "download": {
      "message": "Dette tager et øjeblik...",
      "title": "Klargøring af din Excel-fil",
      "error_title": "Excel-download mislykkedes",
      "missing_data": "Der er ingen data tilgængelig til eksport.",
      "error_message": "Excel-filen kunne ikke downloades. Prøv igen."
    }
  },
  "export_bulk": {
    "go_to_document": "Gå til dokument | Gå til dokumenter",
    "progress_details": "Afbrydelse af eksport påvirker kun dokumenter som endnu ikke er eksporteret.",
    "mandatory_issue_message": "{count} dokument har valideringsproblemer. | {count} dokumenter har valideringsproblemer.",
    "cancel_action": "Afbryd",
    "confirm_validate": "Dokumentet vil blive valideret før eksport. Hvis det ikke har valideringsfejl, bliver det eksporteret automatisk. | Alle dokumenter vil blive valideret før eksport. Dokumenter uden valideringsfejl bliver eksporteret automatisk.",
    "toast_message": "{count} dokument blev eksporteret. | {count} dokumenter blev eksporteret.",
    "toast_title": "Dokument eksporteret | Dokumenter eksporteret",
    "issue_title": "Valideringsproblem ved eksport | Valideringsproblemer ved eksport",
    "confirm_guide": "Hvis dokumentet indeholder fejl, bliver du guidet gennem det, så det kan rettes manuelt. | Hvis dokumenterne indeholder fejl, bliver du guidet gennem dem, så de kan rettes manuelt.",
    "progress_message": "Dette kan tage et øjeblik",
    "optional_issue_message": "{count} dokument har valideringsproblemer. | {count} dokumenter har valideringsproblemer.",
    "error_message": "Masseeksporten kunne ikke gennemføres.",
    "issue_cta": "Vil du gennemgå og rette det nu? | Vil du gennemgå og rette dem nu?",
    "progress_title": "Eksportere dokumenter",
    "confirm_title": "Er du sikker på, at du vil eksportere {count} dokument? | Er du sikker på, at du vil eksportere {count} dokumenter?",
    "confirm_action": "Eksporter dokument | Eksporter dokumenter"
  },
  "flow": {
    "edit": {
      "edit_flow_replace_me": "Erstat mig",
      "add_approver": "Tilføj godkender",
      "edit_flow_message": "Find en, der kan erstatte dig, eller tilføj en anden godkender",
      "approver_before_me_message": "Indsæt en godkender før dig i flowet",
      "choose_update_method": "Vælg en opdateringsmetode",
      "approver_before_me": "Tilføj godkender før mig",
      "approver_after_me_message": "Indsæt en godkender efter dig i flowet",
      "approver_after_me": "Tilføj godkender efter mig",
      "edit_flow_title": "Rediger det nuværende flow",
      "edit_flow_replace_me_message": "Vælg godkender i stedet for dig",
      "replace_me": "Erstat mig",
      "flow_choose_update_method": "Vælg en opdateringsmetode"
    },
    "stepflow": "Stepflow",
    "next_step": "Næste trin",
    "approval_limit": "Beløbsgrænse",
    "using_flow_named": "Bruger {type}: {name}",
    "using_stepflow": "Bruger stepflow",
    "currently_active": "Aktiv i øjeblikket",
    "multiflow": "Multiflow",
    "close": "Close",
    "using_multiflow": "Bruger multiflow",
    "next_approver": "Næste godkender",
    "using_noflow": "Flow er ikke sat op",
    "approve_count": "{count} godkendelse krævet | {count} godkendelser krævet",
    "list": {
      "choose_approver_list": "Vælg en godkender, der skal erstatte dig i det aktuelle flow",
      "list_approver": "Liste over godkendere i det aktuelle flow",
      "approver_list_before_title": "Vælg en godkender, der skal indsættes før dig i det aktuelle flow",
      "approver_list_after_title": "Vælg en godkender, der skal indsættes efter dig i det aktuelle flow",
      "list_updated_approver": "Liste over godkendere i det opdaterede flow"
    },
    "warnings": {
      "approve_warning_tooltip_2": "Hvis der ikke kan træffes en endelig beslutning, vil dokumentet automatisk blive afvist.",
      "continue_anyway": "Fortsæt alligevel",
      "approve_count_warning_title": "Denne proces kan ikke garantere en endelig afgørelse",
      "approve_count_warning_footer": "Hvis der ikke kan træffes en endelig beslutning, vil dokumentet automatisk blive afvist.",
      "approve_count_warning_description_2": "Juster venligst reglerne for at undgå denne situation.",
      "approve_warning_tooltip_1": "Med de nuværende indstillinger kan alle svare, uden at dokumentet er blevet godkendt eller afvist. Du bedes justere reglerne for at undgå denne situation.",
      "adjust_rules": "Juster reglerne",
      "approve_count_warning_description_1": "Med de nuværende indstillinger kan alle svare, uden at dokumentet bliver godkendt eller afvist."
    },
    "meta": {
      "title": "flow"
    },
    "users": {
      "search_placeholder": "Søg efter et navn eller en e-mailadresse"
    },
    "errors": {
      "flow_profile_name_already_exists": "Der findes allerede et flow med det navn",
      "flow_template_name_already_exists": "A flow with this name already exists",
      "approval_limit_must_be_positive": "Beløbsgrænser skal være større end nul.",
      "invalid_approval_limit_mode": "Vælg en gyldig tilstand for beløbsgrænsen."
    },
    "using_flowtype": {
      "multiflow": "Bruger Multiflow: {flowName}",
      "stepflow": "Bruger Stepflow: {flowName}"
    },
    "forward_to": {
      "updated_flow": "Det opdaterede flow",
      "updated_flow_card_title": "Rediger det opdaterede flow"
    }
  },
  "fields": {
    "password_validation": {
      "nonalfa": "Et symbol (fx #&%)",
      "title": "Opret en sikker adgangskode",
      "upperlower": "Store og små bogstaver",
      "length": "8 karakterer langt",
      "numeric": "Et tal"
    },
    "payment_methods": {
      "none": "Ingen",
      "fik": "FI-kode",
      "international": "International",
      "bank_account": "Bankkonto",
      "entry_only": "Kun bogføring"
    }
  },
  "exporterror": {
    "message": {
      "go_to_log": "Gå til log"
    }
  },
  "flowstate": {
    "remaining": {
      "approvers": "{count} godkendere tilbage",
      "noone": "Ingen godkendere tilbage",
      "approver": "{count} godkender tilbage"
    },
    "state": {
      "approved_document": "Har allerede godkendt dokumentet",
      "declines": "Afvisninger",
      "inprogress": "I gang",
      "approvals": "Godkendelser",
      "upcoming": "Kommende",
      "approved": "Godkendt",
      "declined_document": "Har allerede afvist dokumentet",
      "declined": "Afvist",
      "processed": "Behandlet"
    },
    "notset": {
      "details": "Vælg godkendere eller flow for at begynde godkendelsesprocessen",
      "header": "Godkendere eller flow er ikke sat op"
    },
    "toast": {
      "add_approver_message": "Du er blevet tilføjet til gennemgangsprocessen for et dokument.",
      "replace_me": "Flow opdateret",
      "button_text": "Gå til dokumentet",
      "replace_me_message": "Du har nu opdateret flow på det følgende dokument."
    },
    "usernotfound": "Ukendt bruger",
    "decline_count": "{count} afvisning | {count} afvisninger",
    "no_approvals": "Ingen godkendere",
    "header": {
      "onetimeflow": "Engangsflow"
    },
    "no_declined": "Intet fald",
    "delegatefor": "Stedfortræder for {user}",
    "edit": {
      "replace_me": "Vil erstatte dig",
      "approver_after_me": "Bliver den næste, der skal godkende efter dig",
      "approver_before_me": "Bliver den næste godkender",
      "already_in_flow": "Er allerede i gang",
      "insufficient_approval_limit_tooltip": "Denne godkender kan ikke indsættes efter dig, da vedkommendes godkendelsesgrænse ikke er tilstrækkelig til at fungere som den sidste godkender i flowet.",
      "insufficient_approval_limit": "Utilstrækkelig godkendelsesgrænse"
    },
    "no_declines": "Ingen afvisere",
    "selected": {
      "button": "Ændre",
      "header": "er valgt"
    },
    "date": {
      "days": "{days} dage siden",
      "today": "I dag kl: {time}"
    },
    "approve_count": "{count} godkendelse | {count} godkendelser",
    "delegate_for": "Stedfortræder for {user}",
    "self": "Dig",
    "you": "Du",
    "update": {
      "yes_sure": "Ja, det er jeg sikker på",
      "replace_me_1": "Er du sikker på, at du vil erstattes?",
      "approver_before_me_2": "Denne handling vil indsætte ",
      "update_flow": "Opdater flow",
      "approver_order": "Er du sikker på, at du vil ændre godkendelsesrækkefølgen for flowet?",
      "replace_me_2": "Denne handling vil afmelde dig fra arbejdsgangen, og du vil ikke længere kunne få adgang til dokumentet.",
      "approver_after_me_3": "efter dig i det nuværende flow.",
      "approver_before_me_3": "før dig i flowet – du modtager dokumentet bagefter, hvis det er nødvendigt."
    },
    "upcoming": {
      "empty_message": "{name} er sidste godkender",
      "emptystate": "Godkendt",
      "empty_message_self": "{name} er sidste godkender"
    },
    "acting": {
      "delegate_for_tooltip": "Fungerede som repræsentant for {user}"
    },
    "remaning": {
      "approvers": "Resterende godkendere"
    }
  },
  "global": {
    "to": "Til",
    "enabled": "Aktiveret",
    "mandatory": "Obligatorisk",
    "yesterday": "I går",
    "optional": "Valgfri",
    "assignee": "tildelte",
    "self_object": "Dig",
    "from": "Fra",
    "self": "Du",
    "disabled": "Deaktiveret",
    "today": "I dag",
    "indefinitely": "På ubestemt tid",
    "and": "og",
    "assignees": "Tildelte"
  },
  "forgotpassword": {
    "back": "Tilbage til login",
    "result_message_error": "Der opstod en fejl ved afsendelse af din e-mail. Prøv venligts igen senere.",
    "meta": {
      "title": "Glemt adgangskode",
      "description": "Nulstil din adgangskode"
    },
    "resetting": "Nulstiller password",
    "email": "E-mail",
    "result_title_error": "Fejl ved afsendelse af e-mail til",
    "result_title_success": "E-mail sendt til",
    "enter_email": "Indtast din e-mail",
    "title_error": "Fejl ved afsendelse af e-mail",
    "title_success": "E-mail sendt",
    "sub_title_error": "Der opstod en fejl ved afsendelse af e-mail. Prøv venligst igen senere.",
    "title": "Glemt adgangskode?",
    "result_message_success": "Du vil have modtaget en e-mail med et link til at nulstille din adgangskode, hvis den e-mail du angav, er tilknyttet en gyldig konto.<br><br>Hvis du ikke har modtaget en e-mail, så tjek venligst din spam-mappe og sørg for, at den angivne e-mail er korrekt.<br>E-mailen er sendt fra <b>{replyemail}</b><br><br>Hvis du stadig ikke har modtaget en e-mail, så prøv venligst at nulstille din adgangskode igen eller kontakt vores supportteam.",
    "sub_title_success": "Vi har sendt dig instruktioner til at nulstille din adgangskode",
    "reset": "Nulstil adgangskode",
    "sub_title": "Vi sender dig instruktioner til at nulstille din adgangskode",
    "bottom_text": "Hvis du ikke ser en e-mail til nulstilling af din adgangskode, så husk at tjekke dit spamfilter for en e-mail fra <b>{supportemail}</b>"
  },
  "inbound": {
    "empty": {
      "view_emails_in_administration": "Se dine e-mail-adresser under Indstillinger",
      "no_documents_yet": "Du har ikke modtaget nogle dokumenter endnu...",
      "start_sending_documents": "Begynd at sende dokumenter som vedhæftninger til din indgående Batchflow-e-mail, så vil de blive vist her.",
      "email_example": "Eksempel på e-mail: {email}",
      "go_to_inbound_administration": "Gå til Indstillinger"
    },
    "ocr": {
      "customer_order_validation_description": "OCR med validering udføres først ved hjælp af AI, efterfulgt af en menneskelig validering. Dette betyder, at alle data, der udtrækkes af AI'en, bliver valideret af mennesker for at sikre datakvalitet.\n\nI modsætning til AI arbejder mennesker ikke døgnet rundt.\nDette betyder, at menneskelig validering kun finder sted inden for en bestemt tidsramme (mandag til fredag fra 08:00 til 16:00 CET).\n\nDen gennemsnitlige behandlingstid beregnes ud fra denne tidsramme og er et gennemsnit for de sidste 30 dage.\n\nEksempel 1:\nEt dokument ankommer onsdag kl. 15:00 og færdiggøres torsdag kl. 08:30.\nDette resulterer i en behandlingstid på 1,5 time: 1 time onsdag (15:00–16:00) og 0,5 time torsdag (08:00–08:30).\n\nEksempel 2:\nEt dokument ankommer fredag kl. 15:30 og færdiggøres mandag kl. 09:30.\nDette resulterer i en behandlingstid på 2 timer: 0,5 time fredag (15:30–16:00) og 1,5 time mandag (08:00–09:30).",
      "customer_order": "Kundeordre",
      "ocr_for_customer_order": "OCR med validering for kundeordre",
      "ocr_without_validation": "OCR uden validering",
      "ocr_with_validation": "OCR med validering",
      "with_validation_description": "OCR med validering udføres først ved hjælp af AI, efterfulgt af en menneskelig validering. Dette betyder, at alle data, der udtrækkes af AI'en, bliver valideret af mennesker for at sikre datakvalitet.\n\nI modsætning til AI arbejder mennesker ikke døgnet rundt.\nDette betyder, at menneskelig validering kun finder sted inden for en bestemt tidsramme (mandag til fredag fra 08:00 til 16:00 CET).\n\nDen gennemsnitlige behandlingstid beregnes ud fra denne tidsramme og er et gennemsnit for de sidste 30 dage.\n\nEksempel 1:\nEt dokument ankommer onsdag kl. 15:00 og færdiggøres torsdag kl. 14:00.\nDette resulterer i en behandlingstid på 7 timer: 1 time onsdag (15:00–16:00) og 6 timer torsdag (08:00–14:00).\n\nEksempel 2:\nEt dokument ankommer fredag kl. 14:00 og færdiggøres mandag kl. 12:00.\nDette resulterer i en behandlingstid på 6 timer: 2 timer fredag (14:00–16:00) og 4 timer mandag (08:00–12:00).",
      "without_validation_description": "OCR uden validering udføres kun ved hjælp af AI med fuldautomatisk ekstraktion. AI'en vil finde den nødvendige information efter bedste evne.\n\nAI'en arbejder døgnet rundt, så behandlingen starter, så snart dokumentet modtages.\n\nDen gennemsnitlige behandlingstid, der beregnes, er den faktiske tid, som AI'en bruger på at udtrække data, og den er et gennemsnit for de sidste 30 dage.",
      "with_validation": "Med validering",
      "without_validation": "Uden validering"
    },
    "errors": {
      "document_deleted_or_not_available": "Dette dokument er blevet slettet og er ikke længere tilgængeligt til genbehandling",
      "failed_validation": "Der opstod en fejl under behandling af dokumentet",
      "processing_error": "Behandlingsfejl",
      "you_cant_view_this_document": "Beklager! Du kan ikke se dette dokument",
      "should_you_have_access": "Burde du have adgang? Kontakt din administrator",
      "cannot_reprocess_document": "Kan ikke genbehandle dette dokument",
      "it_looks_like_this_document_is_off_limits": "Det ser ud til, at du ikke har adgang til dette dokument. Det kan være på grund af rettigheder knyttet til din nuværende rolle.",
      "document_has_not_finished_processing": "Dokumentet er ikke færdigbehandlet endnu.",
      "header": "Dokumentet behandles stadig"
    },
    "buttons": {
      "update_executing": "Opdaterer",
      "update": "Opdater",
      "upload_document": "Upload dokument"
    },
    "title": "Indgående",
    "columns": {
      "time_spent": "Tid brugt",
      "company": "Selskab",
      "from": "Afsender",
      "received_date": "Modtagelsesdato",
      "ocr_type": "OCR Type",
      "status": "Status",
      "subject": "Emne",
      "receival_type": "Modtagelsestype"
    },
    "document": {
      "reprocessing_failed": "Der skete en fejl da vi forsøgte at sende dokumentet til genbehandling.",
      "reprocessing_started_header": "Genbehandling startet",
      "reprocess_document": "Send til genbehandling",
      "reprocessing_started": "Dokumentet er sendt til genbehandling og vil være klar om kort tid",
      "reprocessing_failed_header": "Vi stødte ind i en fejl"
    },
    "search_and_filter": "Søg efter Selskab, Emne eller Afsender",
    "actions": {
      "delete": "Slet dokument",
      "go_to_document": "Gå til dokument"
    },
    "received_date": "Modtagelsesdato",
    "receival_type": {
      "email": "E-mail",
      "vans": "e-faktura",
      "uts": "UTS"
    },
    "status": {
      "processing": "Under behandling",
      "failed": "Fejlet",
      "reprocessing": "Under genbehandling",
      "done": "Færdig",
      "processed": "Behandlet"
    },
    "stats": {
      "without_validation": "uden validering",
      "processing_time": "Gns. behandlingstid",
      "processing_time_for": "Gns. behandlingstid for",
      "customer_order": "kundeordre",
      "with_validation": "med validering"
    },
    "description": "Se og administrer indgående dokumenter"
  },
  "flow_profiles": {
    "columns": {
      "users": "Brugere",
      "flow_type": "Flow type",
      "flow_name": "Navn"
    },
    "buttons": {
      "create_new_flow": "Opret nyt flow"
    },
    "search_and_filter": "Søg og filtrer efter Navn eller Brugere"
  },
  "header": {
    "profile": "Profil",
    "go_back": "Tilbage",
    "logout": "Log ud",
    "company_filter": {
      "show_all_companies": "Vis alle virksomheder"
    }
  },
  "item": {
    "attributes": {
      "difference_description": "Se differencen mellem totalbeløb/nettobeløb og det konterede beløb på dokumentet",
      "document_delete_text": "Dokumentet er blevet slettet",
      "document_archive_category": "Kategori",
      "declined_by_description": "Se hvem der har afvist dokumentet",
      "assigned": "Tildelt",
      "document_on_hold_additional_note": "Yderligere bemærkning",
      "export_error_reason": "Eksport fejl",
      "document_declined_text_description": "Se dokumentets status",
      "document_on_hold_additional_note_description": "Se den ekstra bemærkning, der forklarer, hvorfor dokumentet er sat på hold",
      "document_declined_reason_description": "Se hvorfor dokumentet er blevet afvist",
      "export_error_text": "Dokumentet kunne ikke eksporteres",
      "accounted_description": "Se det konterede beløb (sum af konteringslinjer) for dokumentet",
      "declined_by": "Afvist af",
      "document_archive_reason": "Årsag",
      "document_on_hold_text_description": "Se dokumentets status",
      "difference": "Difference",
      "document_on_hold_text": "Dokumentet er på hold",
      "assignee_description": "Se hvem der er tildelt dokumentet",
      "accounted": "Konteret",
      "document_on_hold_reason_description": "Se årsagen til at dokumentet er sat på hold samt en supplerende note om hvorfor",
      "document_declined_reason": "Årsag",
      "export_error_text_description": "Se dokumentets status",
      "assignee": "Tildelt",
      "issues_and": "og",
      "document_delete_reason": "Årsag",
      "export_error_reason_description": "Se årsagen til at dokumentet er fejlet ekporten",
      "document_on_hold_reason": "Årsag",
      "count_validation_issues": "{count} valideringsproblem | {count} valideringsproblemer",
      "document_declined_text": "Dokumentet er blevet afvist",
      "voucher_pending_title": "Afventer {erp}",
      "time_assigned_description": "Se hvor lang tid dokumentet har været under godkendelse",
      "last_reminded_description": "Se hvornår seneste påmindelse blev sendt",
      "ready_for_export_text": "Dokument er klar til at eksportere",
      "total_amount": "Totalbeløb",
      "time_assigned": "Tildelt tid",
      "last_reminded": "Sidste påmindelse",
      "validation_issues": "Valideringsproblemer",
      "mandatory_issues_description": "{count} fejl",
      "voucher_missing_help": "Du kan manuelt indtaste et bilagsnummer hvis nødvendigt.",
      "voucher_missing_reason": "Intet bilagsnummer blev returneret fra {erp}.",
      "no_assignee": "Ikke tildelt",
      "no_on_hold_reason": "På hold uden årsag",
      "no_reminders": "Ikke påmindet",
      "voucher_overwritten_by": "Redigeret af {name} ",
      "time_remaining_description": "Se hvor lang tid der er til dokumentet forfalder",
      "voucher_updated": "Opdateret: {date}",
      "net_amount": "Nettobeløb",
      "voucher_received_from": "Modtaget fra {erp}",
      "net_amount_description": "Se Nettobeløbet for dokumentet",
      "optional_issues_description": "{count} advarsel | {count} advarsler",
      "voucher_waiting": "Venter på et bilagsnummer",
      "no_decline_reason": "Ingen afvist årsag",
      "validation_issues_description": "{errors} fejl og {warnings} advarsler",
      "voucher_pending": "Afventer",
      "total_amount_description": "Se Totalbeløbet for dokumentet",
      "time_remaining": "Tid tilbage",
      "voucher_elapsed_time": "Forløbet tid",
      "voucher_missing_title": "Manglende bilagsnummer",
      "no_decline_user": "Ikke afvist af en bruger",
      "validation_errors": "Valideringsfejl",
      "no_export_error_reason": "Ingen eksport fejl",
      "voucher_missing": "Mangler",
      "validation_errors_description": "Se valideringsfejl for dokumentet",
      "no_on_hold_additional_note": "Ingen yderligere bemærkning",
      "voucher_received": "Modtaget: {date}",
      "delete_by": "Slettet af",
      "document_delete_reason_description": "Se hvorfor dokumentet blev slettet",
      "voucher_number": "Bilagsnummer",
      "document_archive_reason_description": "Giver brugere mulighed for at se og redigere kategorien i Arkiveret",
      "voucher_number_description": "Se bilagsnummeret for dokumentet",
      "due_date": "Forfaldsdato",
      "delete_by_description": "Se hvem der har slettet dokumentet"
    },
    "accounting": {
      "title": "Konteringslinjer",
      "columns": "Kolonner",
      "layout_options": "Layout",
      "no_journal_entries": "Ingen linjer er blevet tilføjet endnu",
      "layout_compact": "Kompakt",
      "layout_standard": "Standard",
      "layout_expanded": "Udvidet",
      "no_journal_entries_description": "Tilføj dine linjer her for at starte fakturaafstemningen",
      "layout_dynamic_description": "Vokser med dine linjer og ruller, når pladsen er fuld",
      "layout_expanded_description": "Fylder pladsen, så du kan arbejde med mange linjer",
      "layout_dynamic": "Adaptiv",
      "layout_compact_description": "Viser kun overskriften, så fakturaen forbliver synlig"
    },
    "optional_note": "Tilføj en note (valgfrit)",
    "on_hold": "Sæt fakturaen på hold",
    "buttons": {
      "edit_voucher_number": "Rediger bilagsnummer",
      "return_document": "returner dokument",
      "return_from_hold_success_message": "har returneret følgende dokument til <strong>{widget}</strong>",
      "move_to_archived": "Flyt til Arkiverede",
      "edit_flow": "Rediger flow",
      "delete": "Slet dokument",
      "start_review_success_message": "har sendt følgende dokument til gennemgang:",
      "forward_to": "Videresend til...",
      "export_document": "Eksporter dokument",
      "move_item_to_another_company": "Et andet firma",
      "email_file_as_pdf": "Send PDF via e-mail",
      "executing_export": "Eksporterer dokument",
      "item_decline": "Afvis",
      "approve": "Godkend",
      "executing_approve": "Godkender",
      "return_from_hold_widget": "Returner til {widget}",
      "choose_approvers": "Vælg godkendere",
      "move_as_exported": "Eksporterede",
      "move_document_to": "Flyt dokument til",
      "view_on_hold_reason": "Vis årsag til ventetilstand",
      "move_to_exported": "Flyt til Eksporterede",
      "save_file_as_pdf": "Download som PDF",
      "return_to": "Returner til",
      "item_approve": "Godkend",
      "move_to_exported_success_message": "Har flyttet følgende dokument til Eksporteret:",
      "remind_assignees": "Påmind tildelte",
      "remind_assignee": "Påmind tildelte",
      "approve_success_message": "har godkendt følgende dokument:",
      "executing_start_review": "Sender til gennemgang",
      "put_on_hold_success_message": "Har sat følgende dokument på hold:",
      "send_to_archive": "Arkiverede",
      "decline_success_message": "har afvist følgende dokument:",
      "move_as_archived": "Arkiverede",
      "start_review": "Send til gennemgang",
      "send_to_exported": "Eksporterede",
      "save_file_as_xml": "Download som XML",
      "return_from_hold": "Returner fra på hold",
      "change_approvers": "Skift godkendere",
      "executing_change_approvers": "Skifter godkendere",
      "move_to": "Flyt til...",
      "move_to_archive": "Flyt dokument til Arkiverede",
      "executing_return_to_assignee": "Returner til modtageren",
      "place_on_hold": "Sæt på hold",
      "decline": "Afvis",
      "remind_assignee_has_been_reminded_today": "{user} er blevet påmindet i dag",
      "document_permanently_delete": "Slet permanent",
      "change_category": "Skift kategori",
      "document_re_export": "Eksporter igen",
      "document_return": "Returner",
      "executing_on_hold_return": "Returnerer",
      "another_document": "Et andet dokument",
      "move_to_archive_success_message": "Har flyttet følgende dokument til Arkiverede:",
      "print_document": "Print...",
      "print_e_invoice": "E-faktura",
      "download_pdf": "PDF",
      "download_xml": "XML",
      "download_document": "Download som...",
      "print_pdf": "PDF"
    },
    "column": {
      "taxamount": "Momsbeløb",
      "invoiceno": "Fakturanummer",
      "invoicedate": "Fakturadato",
      "duedate": "Forfaldsdato",
      "totalamount": "Totalbeløb",
      "netamount": "Nettobeløb"
    },
    "delete": {
      "30_day_warning_2": "Efter 90 dage vil dokumentet blive slettet permanent, og vil ikke længere være tilgængeligt.",
      "30_day_warning": "Dokumentet vil blive flyttet til arkivet, hvor det vil blive opbevaret i 30 dage.",
      "item_was_permanently_deleted": "Du har slettet dokumentet permanent.",
      "delete_item_warning": "Vil du gerne slette dette dokument?",
      "30_day_warning_3": "Du vil kunne se dokumentet i widgetten Slettede.",
      "item_was_deleted": "Du har slettet dokumentet.",
      "yes_delete_document": "Ja, slet dokumentet",
      "permanent_delete_error": "Permanent sletning af dokument mislykkedes!",
      "toast_title": "Dokument slettet",
      "permanently_deleted_toast_title": "Dokument slettet permanent",
      "warning_footer": "Alle brugere, der er tilknyttet dette dokument, vil blive underrettet om sletningen"
    },
    "fields": {
      "document_details": "Dokumentdetaljer",
      "paymentcreditor": "Kontonummer",
      "currencycode": "Valuta",
      "bankaccount": "Registreringsnummer",
      "duedate": "Forfaldsdato",
      "vouchernumber": "Bilagsnummer",
      "creditor_no_and_name": "Kreditor",
      "creditor": "Kreditor",
      "payment_details": "Betalingsoplysninger",
      "totalamount": "Totalbeløb",
      "iban": "IBAN-nummer",
      "creditor_details": "Kreditordetaljer",
      "taxamount": "Momsbeløb",
      "amount": "Beløb",
      "documenttype": "Dokumenttype",
      "paymentscheme": "Betalingstype",
      "paymentmethod": "Betalingstype",
      "creditor_id": "Kreditor-ID",
      "creditorname": "Kreditor",
      "bankaccountnumber": "Kontonummer",
      "created": "Modtagelsesdato",
      "invoiceno": "Fakturanummer",
      "swiftbic": "BIC/Swift",
      "paymentreference": "Betalings-ID",
      "paymenttype": "Kortart",
      "invoicedate": "Fakturadato",
      "netamount": "Nettobeløb",
      "dates": "Datoer",
      "fikcode": "Kortart",
      "internationalswiftbic": "BIC/Swift",
      "fikreference": "Betalings-ID",
      "domesticbankaccountnumber": "Kontonummer",
      "fikcreditorid": "Kreditor-ID",
      "domesticbankregistrationnumber": "Registreringsnummer",
      "internationaliban": "IBAN-nummer",
      "creditorno": "Kreditornummer",
      "reconciliation_account": "Betalingskonto",
      "payment_date": "Betalingsdato"
    },
    "move": {
      "moving_item": "Flytter dokument",
      "confirm_message_1": "Den valgte virksomhed understøtter muligvis ikke alle felter eller journaloplysninger fra dette dokument.",
      "confirm_title": "Flyt dokumentet til",
      "another_company_description": "Vælg venligst den afdeling, dokumentet skal flyttes til",
      "confirm_message_2": "Alle data, der ikke understøttes, vil blive fjernet under flytningen. Du kan gennemgå og opdatere dokumentet, når det er blevet flyttet.",
      "failed_title": "Overførsel af dokument til et andet firma mislykkedes!",
      "confirm_footer": "Dokumentet flyttes til mappen »Nye dokumenter«.",
      "search_for_company": "Søg efter en virksomhed",
      "toast_description": "Dokumentet er nu flyttet til {company}",
      "yes_move_item": "Ja, flyt dokumentet",
      "toast_title": "Dokumentet er flyttet til et andet firma",
      "failed_description": "Dokumentet blev ikke flyttet til {company}",
      "another_company": "Flyt dokument"
    },
    "details": {
      "link_copied_to_item": "Kopieret link (URL) til Batchflow ID #{docId} ",
      "next_document": "Næste dokument",
      "document_actions": "Dokumenthandlinger",
      "copied": "Kopieret",
      "show_duplicates": "Vis dublet | Vis dubletter",
      "document_id": "Dokument-ID",
      "creation_date": "Oprettelsesdato",
      "duplicate_counts": "{count} Duplikeret dokument | {count} Duplikerede dokumenter",
      "activity_log": "Aktivitetslog",
      "comments": "Kommentarer",
      "documents_remaining": "{count} dokument tilbage | {count} dokumenter tilbage",
      "invoice_no": "Dokument-ID",
      "link_copied_to_clipboard": "Link kopieret",
      "expand_document": "Udvid dokument",
      "cost_credit_note": "Omkostningskreditnota",
      "expand_fields": "Udvid felter",
      "document_type_updated": "Dokumenttypen er blevet opdateret.",
      "goods_credit_note": "Varekreditnota",
      "attachments": "Vedhæftninger",
      "previous_document": "Forrige dokument"
    },
    "flow_status": {
      "0": "Nyt dokument",
      "1": "Under gennemgang",
      "2": "Annulleret",
      "3": "Afvist",
      "4": "Accepteret",
      "5": "Venter",
      "6": "Slettet",
      "7": "Eksporteret",
      "11": "Eksport fejlede"
    },
    "multiple_users": {
      "document_no_longer_available": "Dokumentet er ikke længere tilgængeligt",
      "decline_the_document": "afvise dokumentet",
      "document_no_longer_available_text": "En anden bruger har udført en handling, der har ændret dokumentets status, hvilket gør, at du ikke længere kan redigere eller ændre det.\n",
      "declining_the_document": "Afvisning af dokumentet",
      "are_you_sure_action": "Er du sikker på, at du ønsker at {action}?",
      "moving_the_document_to_exported": "Flytter dokumentet til eksporteret",
      "move_the_document_to_exported": "flytte dokumentet til eksporteret",
      "exporting_the_document": "Eksportering af dokumentet",
      "move_the_document_to_archive": "flytte dokumentet til arkiv",
      "returning_document_to_state": "Returnering af dokumentet",
      "action_cannot_be_undone": "Denne handling kan ikke fortrydes.",
      "export_the_document": "eksportere dokumentet",
      "moving_the_document_to_archive": "Flytter dokumentet til arkiv",
      "move_to_exported": "flyt til eksporteret",
      "delete_the_document": "slette dokumentet",
      "approving_the_document": "Godkendelse af dokumentet",
      "approve_the_document": "godkende dokumentet",
      "deleting_the_document": "Sletning af dokumentet",
      "move_to_archive": "flyt til Arkiverede",
      "warning_action_result": "{action} vil medføre, at andre aktive brugere ikke har adgang til dokumentet længere.",
      "send_the_document_to_exported": "flytte dokumentet til eksporteret",
      "setting_the_document_on_hold": "At sætte dokumentet på hold",
      "sending_the_document_to_exported": "Flytter dokumentet til eksporteret",
      "sending_the_document_to_archive": "Flytter dokumentet til arkiv",
      "set_the_document_on_hold": "sætte dokumentet på hold",
      "you_will_be_taken_to_next_document": "Du går videre til næste dokument eller tilbage til listen.",
      "sending_the_document_for_review": "At sende dokumentet til gennemgang",
      "send_the_document_to_archive": "flytte dokumentet til arkiv",
      "return_document_to_state": "returnere dokumentet til {state}",
      "send_the_document_for_review": "sende dokumentet til gennemgang"
    },
    "document": {
      "validation_mobile_error": "Det ser ud til, at der er nogle valideringsproblemer i dokumentet, som ikke kan løses på mobilen."
    },
    "forward_to": {
      "state_processed": "Har allerede behandlet dette dokument",
      "state_allready_in_queue": "Allerede i dette flow",
      "error": "Dokumentet kunne ikke videresendes."
    },
    "validation": {
      "invoice_date_is_before_due_date": "Forfaldsdato er før fakturadato",
      "project_requires_cost_type": "Projekt kræver en omkostningstype",
      "document_is_duplicate": "Dokumentet er en dublet",
      "condition_execution_failed": "Kunne ikke køre validering {validationAction} - {conditionType}",
      "yes_i_am_sure": "Ja, jeg er sikker",
      "cost_type_requires_project": "Omkostningstypen kræver et projekt",
      "required_accounting_lines_are_not_filled": "Obligatoriske felter på konteringslinjer er ikke udfyldt",
      "required_item_fields_are_not_filled": "Obligatoriske felter er ikke udfyldt",
      "cost_type_is_not_active": "Omkostningstypen er ikke aktiv",
      "payment_fields_validation_failed": "Betalingsoplysningerne er ikke korrekte",
      "creditor_is_not_active": "Kreditoren er ikke aktiv",
      "document_has_already_been_exported": "Dokumentet er allerede eksporteret",
      "total_amount_is_not_sum_of_accounting_lines": "Summen af konteringslinjer stemmer ikke overens med {amountField}",
      "payment_fields_do_not_match_creditor_defaults": "Betalingsoplysninger afviger fra kreditor",
      "errors_found": "{count} fejl er blevet fundet",
      "due_date_is_outside_allowed_range": "Forfaldsdato er ældre end {maximumAgeDays} dage",
      "net_amount_plus_vat_equals_total_amount": "Nettobeløb plus momsbeløb er ikke lig med totalbeløb",
      "optional_errors_found": "{count} advarsel blev fundet på denne faktura | {count} advarsler blev fundet på denne faktura",
      "invoice_date_is_outside_allowed_range": "Fakturadato er ældre end {maximumAgeDays} dage",
      "account_is_not_active": "Konto er ikke aktiv",
      "contra_account_is_not_active": "Modkonto er ikke aktiv",
      "missing_journal_entries": "Manglende obligatorisk journalpost",
      "column_document": "Dokument",
      "payment_mismatch_helper": "Gennemgå forskellene, før du fortsætter.",
      "payment_mismatch_subtitle": "Betalingsoplysningerne på dokumentet er forskellige fra kreditorens gemte betalingsoplysninger.",
      "column_field": "Felt",
      "column_creditor": "Kreditor",
      "empty_value": "-",
      "payment_mismatch_title": "Betalingsoplysningerne er forskellige"
    },
    "return": {
      "yes_return": "Ja, returner"
    },
    "note": {
      "no_additional_note": "Der blev ikke givet yderligere bemærkninger."
    },
    "action_descriptions": {
      "edit_voucher_number": "Giver brugere mulighed for at redigere dokumentets bilagsnummer.",
      "another_company": "Giver brugere mulighed for at flytte dokumenter til et andet firma.",
      "send_to_exported": "Giver brugere mulighed for at flytte dokumenter til Eksporterede.",
      "remind_assignees": "Giver brugere mulighed for at påminde de aktuelle tildelte.",
      "return_from_hold": "Giver brugere mulighed for at returnere dokumenter fra på hold.",
      "change_approvers": "Giver brugere mulighed for at skifte godkendere på det aktive flow.",
      "export_document": "Giver brugere mulighed for at eksportere dokumenter fra denne widget.",
      "choose_approvers": "Giver brugere mulighed for at vælge godkendere til dokumentet.",
      "move_document_to": "Samler de destinationer, brugere kan flytte dokumenter til",
      "send_to_archive": "Giver brugere mulighed for at flytte dokumenter til Arkiverede",
      "default": "Styrer, om denne dokumenthandling er tilgængelig i widgetten.",
      "send_for_review": "Giver brugere mulighed for at sende dokumenter til gennemgang.",
      "move_to": "Samler flytterelaterede handlinger, der er tilgængelige fra denne widget.",
      "document_re_export": "Giver brugere mulighed for at eksportere dokumenter igen.",
      "change_category": "Giver brugere mulighed for at ændre dokumenters arkivkategorier",
      "on_hold": "Giver brugere mulighed for at sætte dokumenter på hold",
      "approve": "Giver brugere mulighed for at godkende dokumenter fra denne widget",
      "document_permanently_delete": "Giver brugere mulighed for at slette dokumenter permanent",
      "delete": "Giver brugere mulighed for at slette dokumenter fra denne widget",
      "decline": "Giver brugere mulighed for at afvise dokumenter fra denne widget",
      "document_return": "Giver brugere mulighed for at returnere dokumenter til en aktiv widget",
      "edit_flow": "Giver brugere mulighed for at redigere det aktive godkendelsesflow",
      "another_document": "Giver brugere adgang til at flette et dokument med et andet dokument"
    },
    "meta": {
      "description": "Se og behandl det valgte dokument",
      "title": "Dokument"
    },
    "access_denied": {
      "description": "Det ser ud til, at dette dokument ikke er tilgængeligt for din konto. \nHvis du mener, at der er tale om en fejl, bedes du kontakte din administrator",
      "title": "Det ser ud til, at du ikke har adgang til at se dette dokument"
    },
    "automation": {
      "refresh_document": "Opdater dokument",
      "failed_title": "Automatisering mislykkedes",
      "completed_text": "{processed}/{total} behandlet, opdater siden for at se ændringer.",
      "failed_text": "Automatiseringen er mislykkedes. Tjek aktivitetsloggen for flere detaljer.",
      "completed_title": "Automatiseringer er fuldført",
      "close": "Luk"
    }
  },
  "invitation": {
    "get_to_know_you": {
      "phone_number": "Telefonnummer",
      "title": "Fortæl lidt om dig selv",
      "full_name_placeholder": "Indtast dit fulde navn",
      "continue_to_password": "Fortsæt og opret adgangskode",
      "subtitle": "Indtast dine oplysninger",
      "full_name": "Fulde navn",
      "phone_number_placeholder": "12 34 56 78",
      "language": "Sprog",
      "phone_title": "Hvad er dit nummer?",
      "language_subtitle": "Batchflow vises på det valgte sprog",
      "search_language": "Søg efter sprog",
      "name_title": "Hvad hedder du?",
      "search_country_code": "Søg efter landekode",
      "invalid_phone_number": "Indtast et gyldigt telefonnummer",
      "select_country_code": "Vælg din landekode",
      "language_title": "Hvilket sprog foretrækker du?",
      "country_code": "Landekode",
      "select_language": "Vælg dit foretrukne sprog",
      "account_creation_failed": "Vi kunne ikke oprette din konto. Prøv igen.",
      "next": "Næste",
      "phone_subtitle": "Angiv din landekode og dit telefonnummer",
      "name_subtitle": "Dit fulde navn vises i Batchflow for dine kolleger",
      "back": "Tilbage",
      "saving_your_information": "Fortsætter",
      "skip_for_now": "Ikke nu"
    },
    "revoke_invitation": {
      "warning": "Denne handling vil fjerne invitationen og brugeren fra din oversigt.",
      "yes_revoke": "Ja, tilbagekald invitation",
      "title": "Er du sikker på, at du ønsker at tilbagekalde invitationen til {email}?"
    },
    "set_password": {
      "password": "Adgangskode",
      "confirm_password_placeholder": "Bekræft venligst din adgangskode",
      "title": "Lad os oprette din adgangskode",
      "lets_get_started": "Lad os komme i gang",
      "password_placeholder": "Indtast din adgangskode",
      "confirm_password": "Bekræft din adgangskode",
      "subtitle": "Venligst angiv en adgangskode",
      "account_creation_failed": "Vi kunne ikke oprette din konto. Prøv igen.",
      "setting_your_password": "Starter op"
    },
    "twofactor": {
      "description": "Hold din konto sikker med tofaktorgodkendelse (2FA). Ved at bruge en app som Microsoft Authenticator tilføjes et ekstra trin til login-processen, så selv hvis nogen får fat i din adgangskode, kan de ikke få adgang til din konto.",
      "lets_set_up_authentication": "Lad os sætte det op",
      "set_up_later": "Gør det senere",
      "twofactor_authentication": "Tofaktorgodkendelse",
      "title": "Forbedret sikkerhed",
      "quick_to_setup": "Det er hurtigt at opsætte. Vi anbefaler det!"
    },
    "expired": {
      "contact_administrator": "Kontakt venligst din Administrator for flere oplysninger.",
      "title": "Denne invitation eksisterer ikke længere",
      "description": "Dette kan ske, hvis invitationen er blevet tilbagekaldt af en eller anden grund, er udløbet, eller hvis du allerede har accepteret den."
    },
    "resend_invitation": {
      "yes_resend": "Ja, gensend invitation",
      "title": "Er du sikker på, at du ønsker at gensende invitationen til {email}",
      "warning": "Denne handling vil sende brugeren en ny invitation til Batchflow på e-mail"
    },
    "actions": {
      "revoke_invitation": "Tilbagekald invitation",
      "resend_invitation": "Gensend invitation"
    }
  },
  "infobar": {
    "outofoffice": {
      "you_are_delegate": "Du er stedfortræder for {user}",
      "multible_users": "Flere brugere er indstillet som fraværende",
      "no_delegate": "Bruger {user} er Out of office — der er ikke angivet nogen stedfortræder",
      "user_and_delegate": "Bruger {delegate} er stedfortræder for {user}",
      "multiple_users": "Flere brugere er Out of office"
    },
    "document_state": {
      "read_only": "Læsetilstand"
    },
    "automation": {
      "in_progress": "Automatisering i gang. {processed}/{total} behandlet",
      "unlock": "Lås op"
    }
  },
  "invite_user": {
    "errors": {
      "user_exists_in_selected_companies": "Brugeren eksisterer allerede i de valgte selskaber"
    }
  },
  "invitaton": {
    "set_password": {
      "subtitle": "Opret en adgangskode"
    }
  },
  "integration_errors": {
    "e-conomic": {
      "attachment_file_too_large": "Filen overskrider den maksimalt tilladte grænse på 10 MB i e-conomic."
    }
  },
  "modals": {
    "attachment": {
      "upload_box_header": "Klik for upload eller træk og slip",
      "drop_new_file": "Klik for upload eller træk og slip en ny",
      "uploading": "Uploader",
      "unsupported_filetype": "Ikke-understøttet filtype",
      "file_exceeds_size": "Overskrider grænsen på {size} MB",
      "empty_description": "Uploadede filer vil bliver vist her",
      "upload_complete": "Upload færdig ({size})",
      "title": "Vedhæftninger",
      "empty_title": "Ingen vedhæftninger er blevet tilføjet endnu...",
      "cancel_upload": "Fortryd",
      "uploaded_documents": "Uploadede dokumenter",
      "valid_upload_filesize": "Vi accepterer filer op til 25 MB",
      "valid_filetypes": "De mest almindelige filtyper er understøttet"
    },
    "activity": {
      "empty_header": "Ingen log",
      "filter_journal": "Kontering",
      "header": "Aktivitetslog",
      "filter_batchflow4": "BatchFlow4",
      "filter_entries": "Felter",
      "filter_errors": "Fejl",
      "empty_description": "Der blev ikke fundet nogen log i dette filter",
      "filter_flow": "Flow",
      "filter_all": "Alle",
      "filter_match": "Match"
    },
    "approval_limits": {
      "user_description": "Angiv beløbsgrænser for {company}. Beløb angives i {currency}.",
      "update_limits": "Opdater beløbsgrænser",
      "description": "Angiv individuelle beløbsgrænser baseret på dokumenttyper. Disse beløbsgrænser gælder kun for Stepflows.",
      "title": "Beløbsgrænser",
      "document_type_description": "Angiv en specifik beløbsgrænse for dokumenter markeret som {documentType}.",
      "amount_label": "Beløbsgrænse",
      "document_types": "Dokumenttyper",
      "updating_limits": "Opdaterer grænser",
      "overall_limit": "Angiv en overordnet beløbsgrænse",
      "overall_description": "Angiv en overordnet beløbsgrænse, der gælder for alle dokumenttyper.",
      "amount_placeholder": "Angiv venligst en beløbsgrænse",
      "overall_limitation": "Overordnet begrænsning",
      "no_limitation": "Ubegrænset",
      "document_specific_description": "Anvend en dokumentspecifik godkendelsesbegrænsning",
      "limitation_types": "Begrænsningstyper",
      "no_limitation_description": "Ingen beløbsgrænse er påført",
      "overall_limitation_placeholder": "Angiv venligst en overordnet godkendelsesbegrænsning",
      "document_specific_helper": "Hvis der ikke er sat en begrænsning på den specifikke dokumenttype, vil den som standard være uden begrænsning.",
      "document_specific": "Dokumentspecifik begrænsning",
      "overall_limitation_description": "Anvend en overordnet begrænsning, der dækker alle dokumenttyper"
    },
    "admin_activity": {
      "filter_security": "Sikkerhed",
      "filter_all": "Alle",
      "filter_users": "Brugere",
      "filter_roles": "Roller",
      "filter_widgets": "Widgets",
      "filter_inbound": "Indgående",
      "filter_miscellaneous": "Diverse"
    },
    "choose_approvers": {
      "choose_from_existing_flows_description": "Brug en prædefineret liste af godkendere og flow-type",
      "choose_from_existing_flows": "Vælg fra eksisterende flows",
      "choose_from_existing_flows_button": "Vælg eksisterende flow",
      "create_a_one_time_flow": "Opret et engangsflow",
      "will_open_as_default": "Vil åbne som standard",
      "change_approvers": "Skift godkendere",
      "create_a_one_time_flow_button": "Opret engangsflow",
      "title": "Vælg godkendere",
      "create_a_one_time_flow_description": "Definer en engangsgruppe for denne specifikke godkendelsesprocess",
      "open_as_default": "Åben som standard"
    },
    "change_password": {
      "change_password": "Skift adgangskode",
      "header": "Opdater din adgangskode",
      "current_password_placeholder": "Indtast venligst din nuværende adgangskode",
      "current_password": "Nuværende adgangskode",
      "new_password": "Nye adgangskode",
      "new_password_placeholder": "Indtast venligst din nye adgangskode",
      "changing_password": "Opdaterer adgangskode",
      "confirm_password_placeholder": "Bekræft venligst din nye adgangskode",
      "confirm_password": "Bekræft ny adgangskode"
    },
    "duplicate": {
      "active_document": "Aktivt dokument",
      "button_delete_subtitle": "Markerer det aktive dokument som et dublet og sletter det",
      "button_delete": "Slet aktivt dokument",
      "action_delete_success_message": "Har markeret følgende dokument som et dublet. Dokumentet vil blive slettet.",
      "button_delete_title": "Slet aktivt dokument",
      "action_unique_success_message": "Har markeret følgende dokument som unikt",
      "found_duplicates": "Dubletter fundet",
      "button_unique": "Marker som unik",
      "choose_action": "Vælg en duplikeringshandling",
      "header": "Duplikerede dokumenter",
      "button_unique_subtitle": "Markerer det aktive dokument som unikt og ikke en dublet",
      "button_unique_title": "Marker som unik"
    },
    "change_name": {
      "header": "Skift dit navn",
      "change_name": "Skift navn",
      "changing_name": "Skifter navn",
      "new_name_placeholder": "Indtast venligst dit nye navn",
      "new_name": "Nyt navn"
    },
    "create_flow": {
      "flow_name": "Navn",
      "create_new_flow": "Opret et nyt flow",
      "create_one_time_flow": "Opret et nyt engangsflow"
    },
    "decline_item": {
      "nevermind": "Fortryd",
      "placeholder": "Angiv din årsag her...",
      "label": "Venligst angiv årsagen til at du afviser dette dokument (obligatorisk)",
      "decline": "Afvis dokument",
      "header": "Afvis dokument",
      "error": "Dokumentet kunne ikke afvises."
    },
    "comments": {
      "send_executing": "Sender kommentar",
      "nocomments": "Ingen kommentarer er blevet tilføjet endnu",
      "placeholder": "Skriv din kommentar her",
      "header": "Kommentarer",
      "nocomment_subtext": "Skriv din kommentar nedenfor for at starte en samtale",
      "label": "Din kommentar",
      "send": "Send kommentar"
    },
    "change_phone_number": {
      "header": "Skift dit telefonnummer",
      "changing_phone_number": "Skifter telefonnummer",
      "phone_number_placeholder": "Nyt telefonnummer",
      "phone_number": "Telefonnummer",
      "change_phone_number": "Skift telefonnummer"
    },
    "change_workstatus": {
      "startdate": "Startdato",
      "title": "Skift arbejdsstatus",
      "choose_timeframe": "Vælg et tidsrum, hvor du er ude af kontoret",
      "subtitle_working": "Sæt din aktuelle arbejdsstatus som Arbejder",
      "update_work_status": "Skift arbejdsstatus",
      "saving_work_status": "Skifter arbejdsstatus",
      "delegate_type_flow": "Flow",
      "subtitle_out_of_office": "Sæt den aktuelle arbejdsstatus til Out of office",
      "enddate": "Slutdato (valgfrit)",
      "title_out_of_office": "Out of office",
      "choose_delegates": "Vælg en stedfortræder for hvert selskab",
      "end_date": "Vælg venligst en slutdato",
      "delegate_type_user": "Bruger",
      "workstatus": "Arbejdsstatus",
      "title_working": "Arbejder",
      "end_date_error": "Slutdato skal være større eller lig startdato",
      "start_date_error": "Startdatoen skal være i dag eller senere",
      "loading_delegate": "Indlæser stedfortræder...",
      "delegate_unavailable": "Stedfortræder ikke tilgængelig"
    },
    "change_email": {
      "emails": "E-mails",
      "header": "Skift din e-mail",
      "email_description": "Vi sender en bekræftelsesmail til din nye email, som skal verificeres for at fuldføre skiftet",
      "confirm_email": "Bekræft ny e-mail",
      "new_email_placeholder": "Indtast venligst din nye e-mail",
      "change_email": "Skift e-mail",
      "confirm_email_placeholder": "Bekræft venligst din nye e-mail",
      "changing_email": "Skifter e-mail",
      "new_email": "Nye e-mail"
    },
    "change_avatar": {
      "header": "Skift dit profilbillede",
      "save_avatar": "Gem billede",
      "saving_avatar": "Gemmer billede"
    },
    "choose_existing_flow": {
      "title": "Vælg godkendere",
      "search_empty_title": "Ingen matchende godkendere",
      "search_empty_description": "Vi kunne ikke finde et flow eller en bruger. Prøv et andet navn."
    },
    "change_language": {
      "description": "Vælg det sprog, der skal bruges i brugergrænsefladen"
    },
    "create_one_time_flow": {
      "title": "Opret et engangsflow"
    },
    "forward_to": {
      "edit_flow": "Rediger flow",
      "replace": "Erstat mig",
      "title": "Videresend til ...",
      "edit_current_flow": "Rediger nuværende flow"
    },
    "flow": {
      "name": "Navn",
      "type": "Type",
      "forward_to": "Videresend dokument",
      "no_approvers_description": "Søg efter godkendere for at tilføje dem til flowet",
      "create_and_change": "Opret flow og skift godkendere",
      "no_approvers": "Ingen godkendere er blevet tilføjet endnu",
      "delete_flow_profile_confirmation": "Er du sikker på, at du ønsker at slette flowet {flowProfileName}?",
      "required_declines": "Påkrævede afvisninger",
      "description": "Beskrivelse",
      "details": "Detaljer",
      "remove_approver": "Fjern godkender",
      "create_and_apply": "Opret flow og påfør godkendere",
      "required_approvals": "Påkrævede godkendelser",
      "creating_flow": "Opretter flow",
      "forwarding_to": "Videresender dokument",
      "apply_approvers": "Tilføj godkendere",
      "approvers": "Godkendere",
      "search_for_flow_or_approver": "Søg efter et flow eller navne på godkendere",
      "delete_flow_profile_confirmation_warning": "Denne handling vil ikke påvirke aktive flows",
      "edit_flow_template_tooltip_description": "Redigering af flowet opretter et engangsflow med det eksisterende flow som skabelon",
      "create_new_flow": "Opret et nyt flow",
      "applying_approvers": "Tilføjer godkendere",
      "change_approval_type": "Skift godkendelsestype",
      "create_new": "Opret nyt flow",
      "search_for_approvers": "Søg efter godkendere for at tilføje dem til flowet",
      "rules": "Regler",
      "description_subtitle": "Valgfri note, der hjælper andre med at vælge dette flow",
      "approvers_subtitle": "Tilføj personer, der kan godkende dokumenter i dette flow",
      "type_subtitle": "Vælg et trinflow eller et multiflow",
      "required_approvals_subtitle": "Hvor mange personer der skal godkende",
      "details_subtitle": "Angiv navn, type og beskrivelse for dette flow",
      "name_subtitle": "Bruges i flowlister og når flowet anvendes",
      "required_declines_subtitle": "Hvor mange personer der skal afvise",
      "rules_subtitle": "Vælg hvor mange godkendelser dette flow kræver"
    },
    "remind_assignees": {
      "has_been_notified": "Er blevet påmindet",
      "nevermind": "Ikke alligevel",
      "remind_all_assignees": "Er du sikker på, at du vil sende påmindelser for",
      "already_sent": "{count} tildelte var allerede påmindet",
      "this_action": "Denne handling vil sende en påmindelse på e-mail til alle brugere, der er tildelt at gennemgå disse dokumenter.",
      "has_reminded_assignees": "Har sendt påmindelser for {count} dokument | Har sendt påmindelser for {count} dokumenter",
      "assignees": "{count} dokument | {count} dokumenter",
      "remind_assignee_description": "Denne handling vil sende en påmindelses-mail.",
      "remind_assignee": "Er du sikker på at du vil påminde",
      "error_message": "Vi stødte på en fejl da vi forsøgte at sende påmindelsen, prøv venligst igen senere.",
      "last_reminder_sent": "Seneste påmindelse sendt",
      "has_notified_multiple_users": "Har påmindet {count} brugere tildelt dette dokument",
      "in_list": "i listen?",
      "remind_all": "Påmind tildelte"
    },
    "edit_voucher_number": {
      "manual_text": "Dette bilagsnummer blev manuelt redigeret af {username}, og er ikke synkroniseret med {erpname}.",
      "title": "Rediger bilagsnummer",
      "toast_error_text": "Der opstod en fejl under gemning af bilagsnummer",
      "saving": "Gemmer bilagsnummer",
      "missing_text": "Der blev ikke returneret et bilagsnummer fra {erpname}. Du kan indtaste et manuelt, eller vente til det automatisk modtages.",
      "toast_success_title": "Bilagsnummer gemt",
      "toast_success_text": "Bilagsnummer blev gemt korrekt.",
      "overwrite": "Gem bilagsnummer",
      "system_text": "Dette bilagsnummer blev modtaget fra {erpname}, og kan ikke redigeres.",
      "toast_error_title": "Kunne ikke gemme bilagsnummer",
      "pending_text": "{batchflow} afventer i øjeblikket et bilagsnummer fra {erpname}. Hvis der modtages et bilagsnr. senere, kan det erstatte en manuel indtastning."
    },
    "find_replacement": {
      "each_associated_company": "hvert associeret selskab",
      "replacing_and_removing_user": "Fjerner og udskifter bruger",
      "subtitle_delegates": "{count} stedfortræder | {count} stedfortrædere",
      "header": "Find en erstatning",
      "subtitle": "{flows} flow and {documents} documents affected",
      "replacing_and_deactivation_user": "Deaktiverer og udskifter bruger",
      "replace_and_remove_user": "Udskift og fjern bruger",
      "title": "Vælg en erstatning for {company}. Dette valg vil erstatte {user} i alle flows samt overføre alle dokumenter til erstatningen.",
      "subtitle_docs": "{count} dokument| {count} dokumenter",
      "replace_and_deactivate_user": "Udskift og deaktiver bruger",
      "subtitle_post": "påvirket",
      "subtitle_flow": "{count} flow, | {count} flows,"
    },
    "welcomeback": {
      "set_working": "Ja, opdater min status",
      "header": "Velkommen tilbage!",
      "message": "Vi kan se, at du er vendt tilbage i løbet af din{newline}ferie. {newline}Ønsker du at indstille dig selv som arbejdende?",
      "footnote": "Denne handling opdaterer din arbejdsstatus i din virksomhed."
    },
    "onhold": {
      "comment_label": "Supplerende note ({parameter})",
      "comment_placeholder": "Angiv supplerende oplysninger"
    },
    "loggedout": {
      "subtext1": "Det ser ud til, at din session er udløbet.",
      "header": "Du er blevet logget ud",
      "to_login_button": "Tag mig til log ind",
      "subtext2": "Du skal logge ind igen for at fortsætte med at bruge Batchflow."
    },
    "invite_new_user": {
      "email": "E-mail",
      "inviting_user": "Sender invitation",
      "header": "Inviter ny bruger",
      "subheader": "Angiv brugerens e-mail og hvilket sprog invitationen skal sendes på",
      "companies_header": "Vælg hvilke selskaber brugeren skal have adgang til",
      "invite_user": "Inviter bruger",
      "language": "Sprog"
    },
    "remind_item_assignees": {
      "remind": "Påmind"
    },
    "general": {
      "yes": "Ja",
      "no": "Ikke nu"
    },
    "invite_user": {
      "please_select_role": "Vælg venligst en rolle"
    },
    "one_time_approval_limits": {
      "maximum_amount_description": "Angiv det maksimale beløb {user} må godkende i dette flow."
    },
    "attach_to_another_document": {
      "toast_description": "Du har nu vedhæftet dokumentet til:",
      "attach": "Vedhæft til dokumentet",
      "confirm_title": "Vil du vedhæfte dokumentet og arkivere det?\n",
      "toast_title": "Vedhæftet dokument",
      "confirm_description_1": "Dette vil vedhæfte det aktuelle dokument til det valgte dokument.",
      "title": "Vedhæft til et andet dokument",
      "confirm_description_2": "Dette dokument flyttes til »Arkiverede« med kategorien \"Vedhæftet til et andet dokument\".",
      "description": "Vælg det dokument, du vil vedhæfte dette dokument til",
      "yes_attach": "Ja, vedhæft dokument"
    }
  },
  "login": {
    "enter_details": "Indtast venligst dine loginoplysninger",
    "logging_in": "Logger ind",
    "welcome": "Velkommen",
    "mfa": {
      "invalidmfacode": "Koden er ikke gyldig, prøv venligst igen",
      "mustenable_message": "Denne side betyder, at dit selskabs administrator har øget sikkerheden, hvilket kræver tofaktorgodkendelse.<br /><br />Opsæt en authenticator app som Microsoft Authenticator og par den med Batchflow.",
      "mustenable_subtitle": "Tofaktorgodkendelse",
      "mustenable_bottomtext": "Hjælp til at opsætte tofaktorgodkendelse? Se {wikilink}",
      "mustenable_button": "Lad os opsætte totrinsgodkendelse",
      "title": "Bekræft, at det er dig",
      "verify": "Bekræft mig",
      "mustenable_title": "Øget sikkerhed",
      "verifying": "Bekræfter",
      "subtitle": "Åbn din authenticator app og indtast den 6-cifrede kode",
      "mustenable_description": "Opsæt tofaktorgodkendelse for at fortsætte med at bruge Batchflow"
    },
    "meta": {
      "description": "Log ind på din konto",
      "title": "Log ind"
    },
    "forgot_password": "Glemt adgangskode?",
    "password": "Adgangskode",
    "login": "Log ind",
    "password_placeholder": "Indtast din adgangskode",
    "email_placeholder": "Indtast din e-mail",
    "email": "E-mail",
    "errors": {
      "invalid_credentials": "E-mail eller adgangskode er ugyldig, prøv venligst igen"
    },
    "invalid_credentials": "E-mail eller adgangskode er ikke gyldig. Prøv igen",
    "remember_me": "Husk mig"
  },
  "loginmfa": {
    "meta": {
      "title": "Multifaktor-autentificering",
      "description": "Login med multifaktor-autentificering"
    }
  },
  "languages": {
    "da": "Dansk",
    "en": "English"
  },
  "moodal": {
    "userpermission": {
      "header": "Brugerrettigheder",
      "user_details": "Brugeroplysninger",
      "updating_permission": "Opdaterer rettigheder",
      "update_permission": "Opdater rettigheder"
    }
  },
  "module": {
    "projects": {
      "name": "Projekter",
      "description": "Håndter projekter i Batchflow"
    },
    "departments": {
      "description": "Håndter afdelinger i Batchflow",
      "name": "Afdelinger"
    }
  },
  "notifications": {
    "list": {
      "empty_title": "Vi kunne ikke finde nogle notifikationer",
      "all_for_30_days": "Det er alle dine notifikationer for de seneste 30 dage",
      "all_unread_for_30_days": "Det er alle dine ulæste notifikationer for de sidste 30 dage",
      "empty_description": "Tjek Alle for at se dine tidligere meddelelser...",
      "mark_all_as_unread": "Marker alle som ulæste",
      "mark_all_as_read": "Marker alle som læst",
      "all": "Alle",
      "unread": "Ulæste ({count})",
      "unread_empty_title": "Du har ingen ulæste notifikationer"
    },
    "flow": {
      "canceled_header": "Gennemgang blev annulleret",
      "you_have_been_added_to_queue": "Har tilføjet dig til at gennemgå dette dokument.",
      "removed_from_queue": "Har annulleret gennemgangen af dette dokument, og du vil blive fjernet fra gennemgangsprocessen.",
      "flow_updated": "{flowProfileName} er blevet opdateret",
      "flow_updated_description": "Du har opdateret {flowProfileName}",
      "flow_deleted": "Flow er blevet slettet",
      "flow_deleted_description": "Du har slettet flowet",
      "canceled_message": "Gennemgangen blev annulleret for dette dokument, og brugeren i flowet er blevet informeret. | Gennemgangen blev annulleret for dette dokument, og brugerne i flowet er blevet informeret."
    },
    "change_avatar": {
      "error_reading_file_description": "Dit billede er enten korrupt eller utilgængeligt. Forsøg venligst igen",
      "file_too_large": "Din fil er for stor",
      "invalid_file_type_description": "Upload venligst et billede af enhver type",
      "success_description": "Din avatar er blevet opdateret successfuldt",
      "invalid_file_type": "Forkert filtype",
      "error_reading_file": "Vi kunne ikke indlæse dit billede",
      "file_too_large_description": "Din fil er for stor, og overstiger grænsen på 10 MB - find venligt en mindre.",
      "success": "Din avatar er opdateret"
    },
    "replace_user": {
      "multi_companies": "flere selskaber",
      "header": "Bruger er blevet fjernet fra selskab",
      "message_docs": "{count} dokument| {count} dokumenter",
      "message_updated": "er blevet opdateret",
      "message_flow": "{count} flow | {count} flows",
      "no_changes": "Der blev ikke ændret nogle flows eller dokumenter"
    },
    "go_to_document": "Gå til dokument | Gå til dokumenter",
    "organisation": {
      "you_have_saved_miscellaneous_settings": "Du har gemt diverse indstillinger for din organisation",
      "you_have_saved_security_settings": "Du har gemt sikkerhedsindstillinger for din organisation",
      "organisation_saved_settings": "Indstillinger gemt"
    },
    "change_phone_number": {
      "you_have_successfully_changed_your_phone_number": "Du har ændret dit telefonnummer",
      "phone_number_has_been_changed": "Telefonnummer er blevet ændret"
    },
    "change_email": {
      "please_log_in_using_new_email": "Log venligst ind med din nye e-mail for at fortsætte arbejdet i Batchflow.",
      "your_email_has_been_changed": "Din e-mail er blevet ændret",
      "mail_change_verification_sent": "Verificering af e-mailændring sendt",
      "email_verification_sent_to_mail": "Vi har sendt en verificeringsmail til {email}. \nBekræft den for at begynde at bruge din nye e-mailadresse."
    },
    "duplicate": {
      "mark_as_unique_text": "Du har markeret følgende dokument som unikt.",
      "mark_as_duplicate_header": "Dokument markeret som dublet",
      "mark_as_duplicate_text": "Du har markeret følgende dokument som en dublet. \nDokumentet vil blive slettet.",
      "mark_as_unique_header": "Dokument markeret som unikt"
    },
    "change_name": {
      "you_have_successfully_changed_your_name": "Du har opdateret dit navn",
      "name_has_been_changed": "Navn er blevet opdateret"
    },
    "reminder": {
      "notified_multiple_users_on_multiple_documents_header": "Brugere er blevet påmindet",
      "multiple_documents": "Har påmindet dig om, at du har {count} dokumenter til gennemgang.",
      "notified_multiple_users_header": "Bruger er blevet påmindet | Brugere er blevet påmindet",
      "notified_multiple_users_text": "Du har påmindet {count} bruger om dette dokument. | Du har påmindet {count} brugere om dette dokument.",
      "notified_multiple_users_on_multiple_documents_text": "Du påmindet brugere på {count} dokument. | Du har påmindet brugere på {count} dokumenter.",
      "single_document": "Har påmindet dig om et dokument, der er til gennemgang.",
      "already_notified": "Brugere på {count} dokument er allerede påmindet | Brugere på {count} dokumenter er allerede påmindet"
    },
    "assigned_you_to_documents": "Har tildelt dig til {count} dokumenter | Har tildelt dig til {count} dokument",
    "password": {
      "you_have_successfully_updated_your_password": "Du har ændret din adgangskode",
      "password_updated": "Adgangskoden er blevet opdateret"
    },
    "deactivate_user_badge_companies": "{count} selskaber",
    "approve": {
      "header": "Dokument godkendt",
      "text": "Du har godkendt følgende dokument."
    },
    "assigned_you_to_flows": "Har tildelt dig til {count} flows| Har tildelt dig til {count} flow",
    "title": "Notifikationer",
    "invitation": {
      "resent_to_email": "Du har gensendt en invitation til {email}",
      "invitation_resent": "Invitationen blev gensendt",
      "invitation_revoked": "Invitationen blev tilbagekaldt",
      "sent_to_email": "Du har sendt en invitation til {email}",
      "revoked_invitation_to_mail": "Du har tilbagekaldt en invitation til {email}",
      "invitation_sent": "Invitationen blev sendt",
      "has_joined_your_organization": "Har tilsluttet sig din organisation",
      "invitation_error": "Invitationen kunne ikke sendes. Prøv igen.",
      "error": "Invitationen mislykkedes"
    },
    "export": {
      "header": "Dokument eksporteret",
      "text": "Du har eksporteret følgende dokument"
    },
    "deactivate_user": {
      "header": "Brugeren er blevet deaktiveret"
    },
    "altered_assigned_document": {
      "put_on_hold": "Har sat et dokument du er tildelt På hold."
    },
    "error_deactivate_user": {
      "header": "Brugeren kunne ikke deaktiveres i {company}\n"
    },
    "decline": {
      "text": "Du har afvist følgende dokument.",
      "header": "Dokument afvist"
    },
    "work_status_changed": "Har opdateret sin nuværende arbejdsstatus fra {oldStatus} til {newStatus}",
    "general": {
      "something_went_wrong": "Noget gik galt...",
      "something_went_wrong_description": "Noget gik galt. Prøv igen."
    },
    "export_text": "Du har eksporteret følgende dokument:",
    "work_status": {
      "your_work_status_updated": "Din arbejdsstatus er blevet opdateret",
      "you_have_updated_your_work_status": "Du har succesfuldt opdateret din arbejdsstatus fra {fromState} til {toState}.",
      "you_have_updated_user_work_status": "Arbejdsstatus er blevet opdateret",
      "user_work_status_updated": "Du har successfuldt opdateret {user}s arbejdsstatus fra {fromState} til {toState}."
    },
    "review": {
      "send_for_review_header": "Dokument sendt til gennemgang",
      "send_for_review_text": "Dokumentet blev sendt til gennemgang hos godkenderen i det valgte flow. | Dokumentet blev sendt til gennemgang hos godkenderer i det valgte flow.",
      "user_added_to_review_process": "Har tilføjet dig til gennemgangsprocessen for et dokument."
    },
    "widget": {
      "widget_saved": "{widget} er blevet gemt",
      "you_have_saved_widget": "Du har gemt indstillingerne for {widget}"
    },
    "replace_user_error": {
      "sub_message_single": "{company} kunne ikke fjernes.",
      "header": "Noget gik galt ... Prøv igen",
      "sub_message": "Noget gik galt. Prøv igen."
    },
    "userrole": {
      "you_have_changed_userrole": "Du har ændret rolle til {role}",
      "you_have_changed_userrole_header": "Rettigheder for {user} er gemt"
    },
    "role": {
      "role_saved": "{role} er blevet gemt",
      "you_have_saved_role": "Du har gemt indstillingerne for {role}"
    },
    "two_factor": {
      "two_factor_authentication_was_changed": "Tofaktorgodkendelse blev ændret",
      "two_factor_authentication_was_removed_from_account": "Du har successfuldt fjernet tofaktorgodkendelse fra din konto"
    },
    "userwork": {
      "you_have_updated_user_work_status": "Arbejdsstatus er blevet opdateret"
    }
  },
  "multi_selector": {
    "selected": "valgt",
    "documents_selected": "{count} dokument | {count} dokumenter",
    "deselect_documents": "Fravælg dokument | Fravælg dokumenter"
  },
  "note": {
    "date": {
      "days": "{days} dage siden",
      "today": "I dag kl: {time}"
    }
  },
  "note_popup": {
    "no_comments": "Ingen kommentarer",
    "total_replies": "besvarelser",
    "hover_text_start_new": "Start samtale",
    "hover_text": "Gå til samtale"
  },
  "notification": {
    "subtitle": "Vælg den handling, du ønsker at udføre på dine meddelelser",
    "user_disabled": {
      "body": "Kontakt venligst din Administrator for flere oplysninger.",
      "title": "Din adgang til Batchflow er blevet tilbagekaldt"
    }
  },
  "navigation": {
    "notifications": "Meddelelser",
    "hold": "Hold fast",
    "archive": "Arkiv",
    "documents": "Dokumenter",
    "profile": "Profil"
  },
  "pagination": {
    "of": "ud af",
    "showing": "Viser"
  },
  "pdf": {
    "document_details": {
      "approved": "Godkendt",
      "comments": "Kommentarer",
      "batchflow_id": "Batchflow ID",
      "flow_changed": "Flow ændret",
      "received": "Modtaget",
      "email": "E-mail",
      "decline": "Afvisning(er)",
      "approval_summary": "Godkendelsesoversigt",
      "action": "Handling",
      "user": "Bruger",
      "comment": "Kommentar",
      "flow_started": "Flow startet",
      "reason": "Årsag",
      "view_invoice_in_batchflow": "Se faktura i Batchflow",
      "export_details": "Eksportdetaljer",
      "declined": "Afvist",
      "approval": "Godkendelse(r)",
      "export_date": "Eksportdato",
      "creditor_and_creditor_no": "Kreditor",
      "invoice_no": "Fakturanummer",
      "date": "Dato"
    },
    "sections": {
      "section_subtitle_attachments": "Vedhæftninger til dokumentet",
      "section_attachments": "Bilag",
      "section_document_details": "Dokumentdetaljer",
      "section_invoice": "Dokument",
      "section_subtitle_invoice": "Originalt dokument"
    },
    "layout": {
      "generated_by": "Genereret af",
      "page": "Side",
      "of": "af",
      "document_title": "ERP Eksportdokument",
      "document_subtitle": "Faktura, oversigt og bilag"
    }
  },
  "organisation": {
    "working_from": "Arbejder i",
    "companies": "{count} selskab | {count} selskaber",
    "setting": {
      "apply": "Anvend"
    }
  },
  "settings": {
    "oauth": {
      "copy": "Kopiér",
      "client_secret": "Klienthemmelighed",
      "created_credentials_description": "Kopiér disse værdier nu. Klienthemmeligheden vises kun én gang.",
      "copied_description": "Værdien blev kopieret til udklipsholderen.",
      "client_id": "Klient-id",
      "client_created_description": "Klienthemmeligheden vises kun én gang. Gem den, før du forlader siden.",
      "intro_title": "OAuth-legitimationsoplysninger",
      "clear_scopes": "Ryd",
      "copy_client_id": "Kopiér klient-id",
      "description_placeholder": "Hvor disse legitimationsoplysninger skal bruges",
      "client_name_placeholder": "Ekstern rapporteringstjeneste",
      "no_clients": "Ingen OAuth-klienter oprettet",
      "intro_description": "Opret OAuth-legitimationsoplysninger for {company}.",
      "client_name": "Klientnavn",
      "creating_client": "Opretter legitimationsoplysninger",
      "back_to_clients": "Tilbage til klienter",
      "create_new_client": "Opret ny klient",
      "create_failed": "OAuth-klienten kunne ikke oprettes",
      "copied": "Kopieret",
      "create_client": "Opret OAuth-klient",
      "create_credentials": "Opret legitimationsoplysninger",
      "loading_scopes": "Indlæser rettigheder",
      "client_secret_notice": "Hemmeligheden er kun synlig nu. Den kan ikke gendannes senere.",
      "clients": "OAuth-klienter",
      "description": "Beskrivelse",
      "client_created": "OAuth-klient oprettet",
      "created_credentials": "Oprettede legitimationsoplysninger",
      "create_client_description": "Vælg et klientnavn og de API-rettigheder, legitimationsoplysningerne kan bruge.",
      "scope_read_action": "Læs",
      "scope_default_description": "Giver adgang til {resource}",
      "page_description": "Opret OAuth-legitimationsoplysninger for dette selskab",
      "scope_count": "{count} rettighed | {count} rettigheder",
      "no_clients_description": "Opret en klient for at få et klient-id og en engangs-klienthemmelighed til ekstern API-brug.",
      "select_all_scopes": "Alle rettigheder",
      "scopes_description": "Rettigheder styrer, hvilke API-områder klienten kan tilgå.",
      "scope_delete_action": "Slet",
      "scope_delete_description": "Giver adgang til at slette {resource}",
      "no_scopes": "Der er ingen tilgængelige rettigheder",
      "select_read_scopes": "Læserettigheder",
      "no_client_scopes": "Ingen rettigheder",
      "title": "API-adgang",
      "scope_write_description": "Giver adgang til at oprette eller opdatere {resource}",
      "scopes": "Rettigheder",
      "scope_read_description": "Giver læseadgang til {resource}",
      "scope_write_action": "Skriv",
      "scope_default_action": "Adgang",
      "clients_description": "Se OAuth-legitimationsoplysninger oprettet for {company}"
    },
    "company_settings": {
      "amount_validation_field_total_amount": "Totalbeløb",
      "amount_validation_field_warning_body": "Ændringen kan få historiske dokumenter til at se inkonsistente ud, fordi eksisterende bogføringslinjer kan være afstemt mod det tidligere felt.",
      "amount_validation_field": "Beløbsfelt til bogføring",
      "amount_validation_field_net_amount": "Nettobeløb",
      "default_currency": "Standardvaluta",
      "attachment_export_settings_description": "Vælg hvad der sker, hvis vedhæftninger ikke kan eksporteres til ERP",
      "accounting_controls": "Bogføringsregler",
      "attachment_export_settings": "Ved fejl i vedhæftning",
      "company_wide_settings_description": "Generelle indstillinger for {company}",
      "company_timezone_description": "Bruges til tidsstempler og eksport",
      "amount_validation_field_warning_title": "Skift beløbsfelt til bogføring?",
      "company_wide_settings": "Selskabsindstillinger",
      "amount_validation_field_description": "Afstemmer bogføringslinjer mod total- eller nettobeløb",
      "approval_controls": "Godkendelsesregler",
      "default_currency_description": "Bruges til dokumenter, godkendelser og rapportering",
      "amount_validation_field_warning_confirm": "Skift felt",
      "company_timezone": "Tidszone",
      "maximum_allowed_accounting_difference": "Tilladt difference",
      "failed_to_save_message": "Der opstod en uventet fejl under gemning af selskabsindstillinger.",
      "default_language_description": "Sprog, der bruges til kommunikation og genererede dokumenter",
      "localization": "Regionale indstillinger",
      "default_language": "Standardsprog",
      "force_export": "Eksporter uden vedhæftninger",
      "financial_defaults": "Finansielle indstillinger",
      "saved_toast": "Selskabsindstillinger gemt",
      "move_to_export_errors_description": "Stopper eksporten og flytter dokumentet til Eksportfejl",
      "move_to_export_errors": "Flyt til Eksportfejl",
      "failed_to_save_toast": "Selskabsindstillinger kunne ikke gemmes",
      "title": "Selskabsindstillinger",
      "export_timestamp_format_description": "Tidsstempler tilføjes automatisk til eksporterede dokumentfilnavne",
      "maximum_allowed_accounting_difference_description": "Små differencer under dette beløb accepteres automatisk ved bogføring",
      "force_export_description": "Fortsætter eksporten uden vedhæftninger",
      "export_timestamp_format": "Eksporttidsstempel format",
      "page_description": "Administrer generelle indstillinger i dit selskab",
      "export_attachment": "Eksport af vedhæftninger",
      "export_timestamp_format_title": "Eksporttidsstempel format",
      "payment_information": "Betalingsoplysninger",
      "payment_information_source": "Brug betalingsoplysninger fra",
      "payment_type_order": "Foretrukken rækkefølge for betalingstyper",
      "payment_information_source_description": "Vælg, om betalingsoplysningerne skal følge kreditoren eller de enkelte dokument",
      "payment_information_source_creditor": "Kreditor",
      "payment_type_fik": "FIK",
      "payment_type_none": "Ingen",
      "payment_type_bank": "Bankkonto",
      "payment_type_international": "IBAN",
      "payment_type_order_description": "Bruges når flere betalingstyper er registreret på et dokument",
      "payment_information_source_invoice": "Dokument",
      "inherit_approval_limits_when_out_of_office_description": "Stedfortrædere bruger beløbsgrænsen for den bruger, de handler på vegne af",
      "inherit_approval_limits_when_out_of_office": "Stedfortrædere arver beløbsgrænser",
      "payment_information_source_creditor_description": "Brug de betalingsoplysninger, der er gemt på kreditoren. Hvis du skifter kreditor, opdateres betalingsoplysningerne",
      "payment_information_source_invoice_description": "Brug det, der blev registreret på fakturaen. Hvis du skifter kreditor, ændres betalingsoplysningerne ikke",
      "auto_approve_previously_approved_documents": "Auto-godkend tidligere godkendte dokumenter",
      "auto_approve_previously_approved_documents_description": "Sendes en faktura til samme bruger igen, godkendes den automatisk, hvis brugeren har godkendt den før, valideringer er valgfrie, og flowet har 2+ brugere",
      "add_reconciliation_account": "Tilføj betalingskonto",
      "reconciliation_accounts_description": "Vælg de konti, der kan bruges ved Kun bogføring",
      "remove_reconciliation_account": "Fjern betalingskonto",
      "search_for_reconciliation_accounts_to_add": "Søg efter konti ovenfor for at tilføje dem",
      "reconciliation_accounts": "Betalingskonti",
      "no_reconciliation_accounts_added_yet": "Ingen betalingskonti tilføjet endnu",
      "payment_type_order_reset": "Gendan standardrækkefølge"
    },
    "inactive": "Inaktiv",
    "header": "Indstillinger",
    "subheader": "Administrer din organisations brugere, roller og andre indstillinger",
    "global_settings": "Globale indstillinger",
    "company_specific_settings": "Selskabsindstillinger",
    "activated": "Aktiveret",
    "company": {
      "manage_company_settings": "Administrer selskabsindstillinger"
    },
    "miscellaneous": {
      "onhold_mandatory_additional_note_description": "Gør det obligatorisk for brugere at tilføje en supplerende note, når de sætter et dokument på hold",
      "onhold_group_description": "Indstil præferencer for On hold",
      "title": "Diverse",
      "onhold_mandatory_additional_note_title": "Obligatorisk supplerende note",
      "onhold_group_title": "På hold",
      "subtitle": "Administrer diverse indstillinger in your organization",
      "description": "Beskrivelse",
      "miscellaneous_description": "Se og administrer de forskellige indstillinger i din organisation"
    },
    "log_button": {
      "roles_tooltip": "Log for roller",
      "projects_tooltip": "Log for projekter",
      "security_tooltip": "Log for sikkerhed",
      "widgets_tooltip": "Log for widgets",
      "user_tooltip": "Log for bruger",
      "inbound_tooltip": "Log for indgående",
      "users_tooltip": "Log for brugere",
      "miscellaneous_tooltip": "Log for diverse",
      "automations_tooltip": "Log for automations",
      "flow_tooltip": "Log for flow",
      "flows_tooltip": "Log for flows",
      "automation_tooltip": "Log for automation",
      "role_tooltip": "Log for rolle",
      "widget_tooltip": "Log for widget",
      "settings_tooltip": "Log for globale indstillinger",
      "tenant-oauth_tooltip": "Log for API-adgang",
      "validations_tooltip": "Log for valideringer",
      "tenant_tooltip": "Log for selskabsindstillinger"
    },
    "inbound": {
      "title": "Indgående",
      "emails_title": "Indgående emails",
      "emails_subtitle": "Se hvordan Batchflow modtager og håndterer ingående dokumenter",
      "copy_email": "Kopier email",
      "description": "Se og administrer indgående indstillinger",
      "registration_unclassified": "Ikke klassificeret",
      "registrations_empty": "Der er ingen e-fakturaregistreringer.",
      "registrations_title": "e-fakturaregistreringer",
      "registration_gln_ean_number": "GLN/EAN-nummer: {receiver}",
      "registration_receiver_id": "Modtager-id: {receiver}",
      "registrations_subtitle": "Se registrerede CVR- og GLN/EAN-numre, der bruges til at modtage elektroniske fakturaer gennem BatchFlow",
      "registration_vat_number": "CVR-nummer: {receiver}",
      "subtitle": "Administrer indgående indstillinger i din organisation"
    },
    "general": {
      "revert_changes": "Nulstil ændringer",
      "save_changes": "Gem ændringer",
      "saving_changes": "Gemmer ændringer",
      "create_template": "Opret skabelon"
    },
    "flow_profiles": {
      "required_declines": "Påkrævede afvisninger",
      "required_approvals": "Påkrævede godkendere"
    },
    "tenant": {
      "validations_subtitle": "Administrer valideringer i dit selskab",
      "automations_subtitle": "Administrer automatiseringer i dit selskab",
      "subtitle": "Administrer dit selskabs indstillinger og add-ons",
      "creditors": "Kreditorer",
      "oauth": "API-adgang",
      "invite_user_subtitle": "Inviter nye brugere til dit selskab",
      "validations": "Valideringer",
      "flows": "Flows",
      "projects": "Projekter",
      "company_settings": "Selskabsindstillinger",
      "manage": "Indstillinger",
      "additional_modules": "Øvrige udvidelser",
      "company_settings_subtitle": "Administrer generelle indstillinger i dit selskab",
      "oauth_subtitle": "Opret OAuth-legitimationsoplysninger for dette selskab",
      "creditors_subtitle": "Administrer kreditorerne i dit selskab",
      "flows_subtitle": "Administrer flows i dit selskab",
      "journal_entries": "Konteringsskabeloner",
      "automations": "Automatiseringer",
      "my_addons": "Mine udvidelser",
      "invite_user": "Inviter bruger",
      "journal_entries_subtitle": "Administrer konteringslinjeskabeloner i dit selskab",
      "projects_description": "Administrer projekter for dette selskab",
      "validations_description": "Administrer valideringer for dette selskab",
      "automations_description": "Administrer automatiseringer for dette selskab",
      "creditors_description": "Administrer kreditorer for dette selskab",
      "flows_description": "Administrer flows for dette selskab",
      "journal_entries_title": "Konteringslinjer",
      "journal_entry_subtitle": "Administrer konteringsskabeloner i dit selskab",
      "departments_description": "Administrer afdelinger for dette selskab",
      "departments": "Afdelinger",
      "email_notifications": "E-mailnotifikationer",
      "email_notifications_subtitle": "Se og administrer indstillinger for e-mailnotifikationer"
    },
    "permissions": {
      "can_view_description": "Brugere kan kun se",
      "can_view": "Kan se",
      "can_edit": "Kan redigere",
      "disabled_description": "Brugere kan hverken se eller redigere",
      "can_edit_description": "Brugere kan se og redigere",
      "disabled": "Deaktiveret"
    },
    "users": {
      "change_avatar": "Upload billede",
      "avatar": "Avatar",
      "activating_user_consequences": "Ved aktivering får brugeren adgang til at logge ind i BatchFlow",
      "activating_user": "Aktiverer bruger",
      "are_you_sure_request_password_reset": "Er du sikker på, at du ønsker at anmode om en nulstilling af adgangskoden?",
      "avatar_description": "Upload eller skift dit profilbillede",
      "activate": "Aktiver bruger",
      "action_will_request_password_reset": "Denne handling vil sende en e-mail til nulstilling af adgangskode til {email}",
      "change_language": "Skift sprog",
      "change_email": "Skift e-mail",
      "change_name": "Skift navn",
      "activate_user": "Aktiver bruger",
      "change_language_title": "Sprog",
      "companies": "Selskaber",
      "out_of_office": "Out of office",
      "two_factor_is_required_description": "Du er medlem af en organisation, der har påkrævet, at brugere anvender tofaktorgodkendelse for at sikre deres konto",
      "security_and_whereabouts": "Personlige indstillinger",
      "edit_two_factor_authentication": "Rediger 2FA",
      "change_organisation_change": "Skift organisation",
      "update_users_whereabouts": "Sæt brugeren til out of office",
      "change_work_status": "Skift arbejdsstatus",
      "change_password": "Skift adgangskode",
      "pending_invite": "Invitation afventer",
      "deactivating_user": "Deaktivere bruger",
      "password_title": "Adgangskode",
      "request_password_reset": "Anmod om nulstilling",
      "not_working": "Arbejder ikke",
      "view_permissions": "Se rettigheder",
      "edit_whereabouts": "Skift arbejdsstatus",
      "companies_in_total": "{count} selskab | {count} selskaber i alt",
      "pending": "Afventer",
      "change_password_description": "Opdater din adgangskode",
      "working": "Arbejder",
      "yes_request_password_reset": "Ja, anmod om nulstilling",
      "phone": "Telefonnummer",
      "deactivating_user_consequences": "Deaktivering af brugeren vil låse dem ude af Batchflow",
      "user_information": "Personlige informationer",
      "preparing_to_invite_user": "Inviterer ny bruger",
      "email": "E-mail",
      "deactivate_user": "Deaktiver bruger",
      "set_up_two_factor_authentication": "Opsæt 2FA",
      "enable_two_factor_authentication": "Hold din konto sikker med tofaktorgodkendelse (2FA)",
      "password_request_sent_to": "Du har sendt en anmodning om nulstilling til {username}",
      "password_reset": "Nulstil adgangskode",
      "change_phone_number": "Skift telefonnummer",
      "password_reset_request_sent": "Anmodning er blevet sendt",
      "send_user_password_reset": "Send brugeren en anmodning om at nulstille sit password",
      "expired_invite": "Invitation udløbet",
      "companies_header": "Selskaber",
      "two_factor_authentication": "Tofaktorgodkendelse",
      "full_name": "Fulde navn",
      "set_yourself_out_of_office": "Sæt dig selv som værende Out of office",
      "deactivate": "Deaktiver bruger",
      "two_factor_is_required": "Tofaktorgodkendelse er påkrævet",
      "whereabouts": "Out of Office",
      "title": "Brugere",
      "invite_new_user": "Inviter ny bruger",
      "description": "Se og administrer brugere",
      "yes_remove": "Ja, fjern",
      "disable_two_factor": "Deaktiver 2FA",
      "disable_two_factor_title": "Deaktiver 2FA?",
      "yes_remove_two_factor": "Ja, deaktiver 2FA",
      "disable_two_factor_confirmation": "Dette vil fjerne tofaktorgodkendelse for {name}. \nPersonen kan til enhver tid sætte det op igen.",
      "subtitle": "Administrer brugere i din organisation",
      "layout_style": "Layoutstil",
      "layout_style_description": "Vælg et standard- eller kompakt layout",
      "view_layout_standard": "Standard",
      "view_layout_compact": "Kompakt"
    },
    "roles": {
      "company_addons_projects_subtitle": "Aktiver projekt udvidelsen og giv rollen adgang til at se disse",
      "admin_settings_header": "Globale indstillinger",
      "admin_settings_see_header": "Tillad at se administrative oplysninger",
      "archive_widgets_subtitle": "Vælg, hvilke arkiver der skal være synlige for rollen",
      "journal_entries_header": "Kontering",
      "admin_settings_see_subtitle": "Giver brugeren mulighed for at se administrative oplysninger i selskabet",
      "document_fields_subtitle": "Indstillinger der gælder for dokumentfelterne i Batchflow",
      "admin_settings_subtitle": "Aktiver Globale indstillinger og giv rollen adgang til at se disse",
      "journal_entries_see_subtitle": "Tillader visning af kontering",
      "admin_settings_invite_user_header": "Tillad at invitere brugere til Batchflow",
      "admin_settings_edit_header": "\nTillad at redigere administrative oplysninger",
      "title": "Roller",
      "company_settings_subtitle": "Aktiver Selskabsindstillinger og giv rollen adgang til at se disse",
      "widgets_header": "Widgets",
      "journal_entries_see_header": "Se kontering",
      "document_fields_header": "Dokument felter",
      "company_addons_projects_header": "Projekter",
      "journal_entries_edit_subtitle": "Tillad brugere at arbejde med kontering",
      "archive_widgets_header": "Arkiv",
      "admin_settings_edit_subtitle": "Giver brugeren mulighed for at foretage ændringer til brugere i selskabet",
      "role_description": "Beskrivelse",
      "approval_permissions_subtitle": "Aktiver godkendelsesrettigheder og giv rollen adgang til at se disse",
      "admin_settings_invite_user_subtitle": "Giver brugeren mulighed for at invitere nye brugere til selskabet i Batchflow",
      "approval_permissions_header": "Godkendelsesrettigheder",
      "company_settings_header": "Selskabsinstillinger",
      "journal_entries_edit_header": "Rediger kontering",
      "widgets_subtitle": "Angiv, hvilke widgets der er synlige for denne rolle",
      "description": "Se og administrer roller",
      "journal_entries_subtitle": "Aktiver konteringslinjer for denne widget",
      "approval_permissions_activation": "Aktivér godkendelsesrettigheder",
      "document_fields_activation": "Aktivér dokumentfelter",
      "company_settings_activation": "Aktivér selskabsindstillinger",
      "journal_entries_activation": "Aktivér kontering",
      "document_fields_enable_subtitle": "Aktivér dokumentfelter for denne widget",
      "company_addons_projects_activation": "Aktivér projekter",
      "admin_settings_activation": "Aktivér globale indstillinger"
    },
    "security": {
      "mandatory_two_factor": "Obligatorisk tofaktorgodkendelse (2FA)",
      "description": "Beskrivelse",
      "authentication": "Autentificering",
      "authentication_description": "Indstillinger, der gælder for login-sektionen i Batchflow",
      "title": "Sikkerhed",
      "subtitle": "Administrer sikkerheden i din organisation",
      "mandatory_two_factor_description": "Gør det obligatorisk for brugere at anvende en app til tofaktorgodkendelse ved login",
      "security_description": "Se og administrer sikkerheden i din organisation"
    },
    "user": {
      "organisation_name": "Organisationer",
      "you_can_always_enable_it_again": "Du kan altid opsætte tofaktorgodkendelse igen",
      "remove_two_factor_confirmation": "Er du sikker på, at du ønsker at fjerne tofaktorgodkendelse for din bruger?",
      "organisation_description": "Vælg den organisation, du ønsker at arbejde for",
      "remove_two_factor": "Fjern tofaktorgodkendelse?"
    },
    "validations": {
      "copy_selected": "Valgt",
      "copy_no_results_description": "Prøv en anden søgning for at finde valideringer at kopiere.",
      "copy_search_placeholder": "Søg valideringer",
      "copy_disabled_tooltip": "Tilføj valideringer før du kan kopiere dem",
      "badge_warning": "Advarsel",
      "dependency_action_disabled_tooltip": "Denne validering har allerede afhængige valideringer under sig, og kan ikke udvides yderligere",
      "already_added": "Allerede tilføjet",
      "choose_fields_label": "Vælg obligatoriske felter",
      "copy_validations": "Kopier eksisterende valideringer",
      "action_export": "Eksport",
      "add_validation_executing": "Tilføjer validering",
      "copy_parameter_overlap": "Allerede tilføjet",
      "badge_error": "Blokerende",
      "delete_confirm_title": "Vil du slette valideringen?",
      "delete_confirm_warning": "Denne ændring kan ikke fortrydes.",
      "copy_parameter_overlap_tooltip": "Denne validering findes allerede med de samme felter",
      "badge_disabled": "Deaktiveret",
      "copy_existing_validations_title": "Kopier eksisterende valideringer",
      "delete_confirm_body": "Valideringen slettes og vil ikke længere køre ved denne handling for denne dokumenttype.",
      "copy_empty_description": "Der er ingen aktiverede valideringer på andre handlinger for denne dokumenttype.",
      "copy_no_results_title": "Ingen matchende valideringer",
      "choose_action_label": "Vælg handlingen hvor valideringen skal bruges",
      "copy_one_severity_only_tooltip": "Denne validering kan kun tilføjes én gang pr. handling. Fjern den eksisterende validering for at bruge en anden type",
      "copy_one_severity_only": "Allerede tilføjet",
      "action_approve": "Godkend",
      "add_dependency_tooltip": "Tilføj afhængighed",
      "add_validation": "Tilføj validering",
      "configure_title": "Konfigurer validering",
      "continue": "Fortsæt",
      "copy_selected_tooltip": "En validering med denne type og tilstand er allerede valgt",
      "action_document_received": "Dokument modtaget",
      "delete_confirm_submit": "Ja, slet validering",
      "copy_existing_validations_description": "Vælg valideringer der skal kopieres til {documentType} → {action}",
      "choose_type_label": "Vælg valideringstype",
      "choose_rule_label": "Vælg valideringsregel",
      "add_validation_submit": "Tilføj validering",
      "copy_empty_title": "Ingen valideringer at kopiere",
      "copy_validations_submit": "Kopier valideringer",
      "copy_existing_validations": "Kopier eksisterende valideringer",
      "choose_rule_title": "Vælg valideringsregel",
      "add_dependency_submit": "Tilføj afhængighed",
      "action_send_for_review": "Send til gennemgang",
      "copy_already_exists_tooltip": "Denne validering findes allerede i denne handling",
      "empty_description": "Tilføj valideringsregler for at styre, hvad der skal kontrolleres, når der udføres handlinger på dokumenter",
      "toast_sort_error_title": "Valideringsrækkefølgen blev ikke opdateret",
      "toast_delete_dependency_error_title": "Valideringen kan ikke slettes",
      "toast_dependency_remove_success_text": "Afhængigheden blev fjernet fra {dependency}.",
      "type_contra_account_is_not_active_title": "Aktiv modkonto",
      "no_results_description": "Vi kunne ikke finde det, du ledte efter. Prøv en anden søgning.",
      "toast_update_error_title": "Valideringen blev ikke opdateret",
      "type_net_amount_plus_vat_equals_total_amount_description": "Sikrer at nettobeløb og moms tilsammen svarer til totalbeløbet",
      "toast_copy_success_text": "{count} validering blev kopieret til {scope}. | {count} valideringer blev kopieret til {scope}.",
      "toast_update_success_text": "{validation} blev opdateret for {scope}.",
      "remove_dependency_tooltip": "Fjern afhængighed",
      "feedback_dependency_save_error": "Afhængigheden kunne ikke gemmes.",
      "type_due_date_is_outside_allowed_range_description": "Sikrer at forfaldsdatoen er inden for det tilladte eksportinterval",
      "dependency_descendant_tooltip": "Denne validering er allerede afhængig af denne",
      "type_cost_type_requires_project_description": "Sikrer at der er valgt et projekt, når omkostningstypen kræver det",
      "type_invoice_date_is_outside_allowed_range_title": "Fakturadato inden for tilladt interval",
      "type_cost_type_requires_project_title": "Omkostningstype kræver projekt",
      "toast_copy_error_title": "Valideringerne blev ikke kopieret",
      "dependency_unavailable_badge": "Kan ikke bruges som afhængighed",
      "dependency_modal_description": "Vælg den validering, denne afhænger af. Denne validering kører kun, hvis den valgte validering er opfyldt.",
      "toast_update_success_title": "Validering opdateret",
      "feedback_delete_error": "Valideringen kunne ikke slettes.",
      "feedback_updated": "Validering opdateret",
      "feedback_title": "Valideringer",
      "field_locked_tooltip": "Dette felt bruges allerede af {severity}-valideringen for denne regel",
      "type_document_has_already_been_exported_description": "Sikrer at dokumentet ikke allerede er eksporteret",
      "toast_copy_success_title": "Valideringer kopieret",
      "dependency_dropzone_active_hint": "Slip her for at tilføje som afhængighed til denne validering",
      "toast_delete_success_title": "Validering slettet",
      "error_exists_tooltip": "Fejlvalidering findes allerede for denne regel",
      "type_payment_fields_validation_failed_description": "Sikrer at betalingsoplysningerne indeholder en gyldig kombination af værdier",
      "type_creditor_is_not_active_title": "Aktiv kreditor",
      "feedback_sort_error": "Den nye valideringsrækkefølge kunne ikke gemmes.",
      "type_cost_type_requires_matching_ongoing_account_description": "Sikrer at omkostningstypen matcher den konfigurerede igangværende konto på omkostningsgruppen",
      "toast_dependency_save_success_text": "Afhængighed gemt for {dependency}.",
      "edit": "Rediger",
      "toast_dependency_invalid_drop_title": "Afhængighed er ikke tilladt",
      "type_missing_journal_entries_title": "Konteringslinje findes",
      "dependency_dropzone_hint": "Slip her for at tilføje som afhængighed",
      "type_payment_fields_do_not_match_creditor_defaults_title": "Betalingsfelter matcher kreditors betalingsindstillinger",
      "type_creditor_is_not_active_description": "Sikrer at den valgte kreditor er aktiv i integrationen",
      "type_account_is_not_active_title": "Aktiv konto",
      "dependency_empty_description": "Vi kunne ikke finde nogen valideringer der kan vælges som afhængighed.",
      "dependency_unavailable_tooltip": "Denne validering kan ikke bruges som afhængighed",
      "feedback_delete_dependency_error": "Fjern de afhængige valideringer først, før du sletter denne validering.",
      "type_contra_account_is_not_active_description": "Sikrer at den valgte modkonto er aktiv i integrationen",
      "dependency_no_candidates_tooltip": "Ingen valideringer er tilgængelige at tilføje som afhængighed",
      "toast_dependency_remove_error_title": "Afhængigheden blev ikke fjernet",
      "type_cost_type_requires_matching_ongoing_account_title": "Omkostningstype matcher igangværende konto",
      "type_invoice_date_is_before_due_date_title": "Forfaldsdato efter fakturadato",
      "type_invoice_date_is_before_due_date_description": "Sikrer at forfaldsdatoen er efter fakturadatoen",
      "toast_sort_error_text": "Vi kunne ikke gemme den nye valideringsrækkefølge for {scope}.",
      "search_placeholder": "Søg efter valideringsregel",
      "toast_create_success_text": "{validation} blev tilføjet til {scope}.",
      "dependency_modal_title": "Tilføj afhængighed",
      "type_net_amount_plus_vat_equals_total_amount_title": "Nettobeløb plus moms svarer til totalbeløb",
      "rule_exists_tooltip": "Reglen er allerede tilføjet til denne handling",
      "type_invoice_date_is_outside_allowed_range_description": "Sikrer at fakturadatoen er inden for det tilladte eksportinterval",
      "list_no_results_title": "Ingen matchende valideringer",
      "maximum_age_placeholder": "Indtast antal dage",
      "empty_title": "Der er endnu ikke tilføjet nogen valideringsregler",
      "type_document_has_already_been_exported_title": "Dokument er ikke allerede eksporteret",
      "maximum_age_badge": "{count} dage",
      "toast_delete_error_title": "Valideringen blev ikke slettet",
      "list_no_results_description": "Vi kunne ikke finde nogen valideringer for denne handling. Prøv en anden søgning.",
      "maximum_age_label": "Maksimal tilladt alder (dage)",
      "missing_field_translation": "Manglende oversættelse for {field}",
      "type_due_date_is_outside_allowed_range_title": "Forfaldsdato inden for tilladt interval",
      "toast_dependency_save_error_title": "Afhængigheden blev ikke opdateret",
      "feedback_deleted": "Validering slettet",
      "type_payment_fields_do_not_match_creditor_defaults_description": "Sikrer at dokumentets betalingsfelter matcher kreditors opsatte betalingsindstillinger",
      "feedback_created": "Validering tilføjet",
      "list_search_placeholder": "Søg valideringer",
      "toast_dependency_remove_success_title": "Afhængighed fjernet",
      "error_description": "Forhindrer at fortsætte",
      "dependency_search_placeholder": "Søg valideringer",
      "feedback_save_error": "Valideringen kunne ikke gemmes.",
      "dependency_depth_tooltip": "Denne validering ligger allerede sidst i rækken af afhængigheder",
      "type_employee_is_not_active_description": "Sikrer at den valgte medarbejder er aktiv i integrationen",
      "no_additional_configuration": "Der kræves ingen yderligere konfiguration for denne regel.",
      "type_document_is_duplicate_title": "Dokument er ikke en dublet",
      "toast_dependency_save_success_title": "Afhængighed opdateret",
      "toast_delete_success_text": "{validation} blev fjernet fra {scope}.",
      "maximum_age_description": "Angiver hvor mange dage tilbage fra i dag datoen må være",
      "toast_create_success_title": "Validering tilføjet",
      "type_document_is_duplicate_description": "Sikrer at dokumentet ikke er markeret som en dublet",
      "dependency_empty_title": "Ingen matchende valideringer",
      "feedback_dependency_remove_error": "Afhængigheden kunne ikke fjernes.",
      "type_cost_type_is_not_active_title": "Aktiv omkostningstype",
      "type_account_is_not_active_description": "Sikrer at den valgte konto er aktiv i integrationen",
      "type_cost_type_is_not_active_description": "Sikrer at den valgte omkostningstype er aktiv i integrationen",
      "toast_create_error_title": "Valideringen blev ikke tilføjet",
      "no_results_title": "Der er ikke noget i boksen!",
      "type_missing_journal_entries_description": "Sikrer at der er oprettet mindst én postering, før handlingen kan fortsætte",
      "type_employee_is_not_active_title": "Aktiv medarbejder",
      "type_project_requires_cost_type_title": "Projekt kræver omkostningstype",
      "used_by_error": "Bruges af fejlvalidering",
      "type_project_requires_cost_type_description": "Sikrer at der er valgt en omkostningstype, når projektet kræver det",
      "used_by_warning": "Bruges af advarselsvalidering",
      "type_payment_fields_validation_failed_title": "Gyldige betalingsoplysninger",
      "type_project_is_not_active_title": "Aktivt projekt",
      "type_required_accounting_lines_are_not_filled_title": "Obligatoriske felter på konteringslinjer",
      "warning_exists_tooltip": "Advarselsvalidering findes allerede for denne regel",
      "update_validation_executing": "Opdaterer validering",
      "update_validation_submit": "Opdater validering",
      "type_required_item_fields_are_not_filled_title": "Obligatoriske dokumentfelter",
      "type_project_is_not_active_description": "Sikrer at det valgte projekt er aktivt i integrationen",
      "warning_description": "Viser en advarsel, men tillader at fortsætte",
      "type_required_accounting_lines_are_not_filled_description": "Sikrer at alle obligatoriske felter på konteringslinjer er udfyldt",
      "type_required_item_fields_are_not_filled_description": "Sikrer at alle obligatoriske dokumentfelter er udfyldt",
      "feedback_copy_error": "Valideringerne kunne ikke kopieres. Prøv igen.",
      "load_error_title": "Valideringer kunne ikke indlæses",
      "disabled_description": "Denne validering er deaktiveret og vil ikke køre",
      "load_error_description": "Vi kunne ikke indlæse valideringsopsætningen. Prøv igen for at genindlæse valideringsreglerne.",
      "load_error_retry": "Prøv igen",
      "type_total_amount_is_not_sum_of_accounting_lines_description": "Sikrer, at summen af konteringslinjer stemmer med dokumentets valgte beløb",
      "type_total_amount_is_not_sum_of_accounting_lines_title": "Konteringslinjer stemmer med beløb",
      "activity_log_created": "Validering oprettet: {validationName}",
      "activity_log_updated": "Validering opdateret: {validationName}",
      "activity_log_deleted": "Validering slettet: {validationName}"
    },
    "widgets": {
      "actions": "Handlinger",
      "description": "Beskrivelse",
      "key_metrics": "Nøglemetrikker",
      "subtitle": "Administrer widgets i din organisation",
      "key_metrics_description": "Angiv, hvilke KPI'er der vises i {widget}",
      "title": "Widgets",
      "global_settings": "Globale indstillinger",
      "actions_description": "Angiv, hvilke handlinger der er tilgængelige i {widget}",
      "widget_activation": "Aktiver widget",
      "widgets_visibility_description": "Aktivering af widgetten vil gøre det muligt at tildele den til en rolle. Det er rollen, der afgør, om en bruger kan se widgetten",
      "document_fields_description": "Angiv, hvilke dokumentfelter der er tilgængelige i {widget}",
      "journal_entries_description": "Angiv, hvilke konteringslinjer der er tilgængelige i {widget}"
    },
    "role": {
      "subtitle": "Administrer roller i din organisation"
    },
    "email_notifications": {
      "page_description": "Vælg hvilke e-mailnotifikationer der skal sendes, og hvornår",
      "load_failed": "Indstillinger for e-mailnotifikationer kunne ikke indlæses. Genindlæs siden for at prøve igen.",
      "global": "Globale indstillinger",
      "subtitle": "Administrer e-mailnotifikationer i din organisation",
      "types_description": "Choose which document notifications to include",
      "week_before": "{count} uge før | {count} uger før",
      "due_date_approaching_description": "Giv besked, når et dokument nærmer sig forfaldsdatoen",
      "pending_from_last_month": "Afventer fra sidste måned",
      "global_description": "Slå e-mailnotifikationer til eller fra for organisationen",
      "weekday_friday": "Fredag",
      "day_after": "{count} dag efter | {count} dage efter",
      "day_before": "{count} dag før | {count} dage før",
      "weekday_sunday": "Søndag",
      "weekday_monday": "Mandag",
      "immediately": "Med det samme",
      "save_failed": "Indstillinger for e-mailnotifikationer kunne ikke gemmes. Dine senest gemte indstillinger er gendannet.",
      "weekday_tuesday": "Tirsdag",
      "weekday_saturday": "Lørdag",
      "types": "Notifikationstyper",
      "saved": "Indstillinger for e-mailnotifikationer er gemt",
      "past_due_description": "Giv besked, når et dokument har overskredet forfaldsdatoen",
      "month_end_approaching_description": "Giv besked om afventende dokumenter inden månedens afslutning",
      "description": "Beskrivelse",
      "frequency": "Leveringsplan",
      "week_after": "{count} uge efter | {count} uger efter",
      "weekday_thursday": "Torsdag",
      "weekday_wednesday": "Onsdag",
      "activate_description": "Send planlagte e-mailnotifikationer om dokumenter, der kræver opmærksomhed",
      "due_date_approaching": "Forfaldsdato nærmer sig",
      "month_end_approaching": "Månedsafslutning nærmer sig",
      "past_due": "Overskredet forfaldsdato",
      "pending_from_last_month_description": "Giv besked om dokumenter, der stadig afventer fra sidste måned",
      "title": "E-mailnotifikationer",
      "frequency_description": "Vælg hvilke dage og tidspunkter notifikationerne skal sendes",
      "activate": "Aktivér e-mailnotifikationer"
    }
  },
  "onhold": {
    "reason_choice": {
      "credit_note_await": "Afventer kreditnota",
      "test_4": "Tja, det er en grund...",
      "test_1": "En lidt bedre grund",
      "test_3": "En god grund",
      "goods_or_services_not_received": "Varer eller tjenesteydelser blev ikke modtaget",
      "test_2": "En ikke så god grund",
      "missing_documentation": "Nødvendige dokumenter mangler"
    },
    "reason": {
      "1": "Afventer kreditnota"
    },
    "modal": {
      "subtitle": "Vælg årsagen til at sætte dokumentet på hold",
      "nevermind": "Ikke alligevel",
      "execute": "Sæt på hold",
      "title": "Sæt dokumentet på hold"
    }
  },
  "outbound": {
    "empty": {
      "exporting_documents_appear_here": "Dokumenter, der i øjeblikket er ved at blive eksporteret, vises her.",
      "view_export_errors": "Se eksport fejl",
      "looking_for_documents_or_export_errors": "Leder du efter eksporterede dokumenter eller eksportfejl? Du kan finde dem nedenfor.",
      "view_exported_documents": "Se eksporterede dokumenter"
    },
    "title": "Udgående",
    "description": "Se og administrer udgående dokumenter"
  },
  "pdf_file": {
    "download": {
      "title": "Gør din PDF klar",
      "message": "Dette tager et øjeblik...",
      "missing_data": "Der er ingen PDF-fil tilgængelig for dette dokument.",
      "error_title": "PDF-download mislykkedes",
      "error_message": "PDF-filen kunne ikke downloades. Prøv igen."
    }
  },
  "pdf_viewer": {
    "expand_view": "Udvidet visning",
    "move": "Flyt",
    "cannot_preview_file": "Kan ikke vise denne fil",
    "download_to_preview": "Download filen for at se den",
    "e_invoice": "e-faktura",
    "show": {
      "as_pdf": "Vis som PDF",
      "as_e_invoice": "Vis som e-faktura"
    },
    "select": "Marker tekst",
    "page_of": "{pageNum} af {totalPages}",
    "zoom_to_fit": "Tilpas til bredde",
    "empty": {
      "header": "Dokumentet kunne ikke findes",
      "subheader": "Vi ledte grundigt efter, men vi kunne ikke finde noget"
    },
    "zoom_out": "Zoom ud",
    "pdf": "PDF",
    "view": "Vis som",
    "next_page": "Næste side",
    "pop_out": "Pop ud",
    "previous_page": "Forrige side",
    "zoom_in": "Zoom ind",
    "popout": {
      "elsewhere": "Dokumentet vises i et andet vindue.",
      "show_here": "Vis her",
      "empty": "Åbn en faktura for at vise den.",
      "empty_title": "Ingen faktura valgt"
    }
  },
  "page": {
    "errors": {
      "404": "Har du mistet mælet?",
      "500": "Noget gik galt...",
      "404_description": "Det ser ud til, at siden er blevet lagt i den forkerte skuffe.\nTjek venligst URL'en, eller gå tilbage til forsiden.",
      "500_description": "Det ser ud til, at vi oplever nogle tekniske problemer i øjeblikket. Hvis problemet fortsætter, bedes du kontakte vores support.",
      "error": "Fejl {code}"
    }
  },
  "origination": {
    "change": {
      "message": "Organisatorisk ændring"
    }
  },
  "organisations": {
    "subheader": "Vælg en organisation",
    "header": "Organisationer"
  },
  "permissions": {
    "setting_admin_user": "Brugere",
    "setting_journal_read_description": "Tillader visning af kontering",
    "setting_approval_limits": "Beløbsgrænser",
    "setting_company_journals_description": "Tillad brugere at administrere konteringsskabeloner i det specifikke selskab",
    "setting_company_flows_description": "Tillad brugere at administrere flows i det specifikke selskab",
    "setting_company_invite_user": "Tillad invitation af brugere",
    "setting_company_document_fields_description": "Giver brugere adgang til at se eller redigere dokumentfelterne",
    "setting_allow_user_invite": "Tillad at invitere brugere til Batchflow",
    "setting_admin_role": "Roller",
    "setting_journal_edit_description": "Tillad brugere at arbejde med kontering",
    "setting_company_settings_description": "Tillad brugere at administrere selskabets standarder og eksportadfærd i det specifikke selskab",
    "setting_company_creditor_description": "Tillad brugere at administrere kreditorer i det specifikke selskab",
    "setting_company_flow_edit": "Tillad redigering af Flows",
    "setting_company_validations_description": "Tillad brugere at administrere selskabsindstillinger",
    "setting_company_validations": "Selskabsindstillinger",
    "setting_company_automations_description": "Tillad brugere at administrere automatiseringer i det specifikke selskab",
    "not_set": "Ikke angivet",
    "setting_company_automations": "Automatiseringer",
    "setting_journal": "Rediger kontering",
    "setting_admin_security_description": "Tillad brugere at administrere sikkerhed i organisationen",
    "setting_admin_inbound": "Indgående",
    "setting_admin_security": "Sikkerhed",
    "setting_admin_edit": "Tillad at redigere administrative oplysninger",
    "setting_company_journals": "Tillad redigering af Konteringsskabeloner",
    "setting_admin_widget_description": "Tillad brugere at administrere widgets i organisationen",
    "setting_admin_edit_description": "Giver brugeren mulighed for at foretage ændringer til brugere i selskabet",
    "setting_company_flows": "Flows",
    "setting_journal_edit": "Rediger kontering",
    "setting_admin_widget": "Widgets",
    "setting_company_flow_edit_description": "Giv brugerne mulighed for at styre flows i det specifikke selskab",
    "setting_approval_limits_description": "Tillad brugere at se og redigere beløbsgrænser",
    "settings_company_addons_projects_description": "Tillad brugere at administrere ansvarlige i det specifikke selskab",
    "setting_company_addons_projects": "Administrer ansvarlige",
    "setting_admin_inbound_description": "Tillad brugere at administrere indstillingerne for den indgående funktion",
    "setting_admin_user_description": "Tillad brugere at invitere og administrere brugerne i organisationen",
    "setting_admin_role_description": "Tillad brugere at administrere rollerne i organisationen",
    "setting_document_fields": "Rediger dokumentfelter",
    "setting_allow_user_invite_description": "Giver brugeren mulighed for at invitere nye brugere til selskabet i Batchflow",
    "setting_company_settings": "Selskabsindstillinger",
    "setting_journal_read": "Se kontering",
    "setting_company_creditor": "Kreditorer",
    "setting_company_invite_user_description": "Tillad brugere at invitere nye brugere til et bestemt selskab",
    "setting_journal_description": "Giver brugere adgang til at kunne se eller redigere konteringslinjer"
  },
  "projects": {
    "search_and_filter": "Søg",
    "employee_mapping": {
      "choose_a_user_to_match": "Vælg den bruger, der skal knyttes til den ansvarlige",
      "employees_are_imported_from_erp": "Ansvarlige bliver importeret fra dit økonomisystem, har du oprettet nogle?",
      "erp_user_id": "Økonomisystems ID:",
      "filter_employees": "Filtrer ansvarlige",
      "title": "Administrer ansvarlige",
      "show_mapping_issues": "Vis tilknytningsproblemer",
      "please_ensure_correct_mapping": "Sørg venligst for, at ansvarlige er tilknyttet til de korrekte brugere",
      "search_for_a_user": "Søg efter navn eller e-mail",
      "no_employees_found": "Ingen ansvarlig fundet",
      "not_found": "Ingen bruger fundet",
      "no_mapping_issues_found": "Vi fandt ingen problemer med tilknytninger mellem ansvarlige og brugere",
      "show_all": "Vis alle",
      "browse_batchflow_users": "Find en Batchflow-bruger at tilknytte",
      "no_email_found": "Ingen e-mail fundet",
      "issues_regarding_mapping_appear_here": "Potentielle problemer med tilknytninger vises her",
      "select_employee": "Tilknyt bruger",
      "please_verify": "Bekræft bruger",
      "find_employee": "Tilknyt bruger",
      "verify": "Bekræft",
      "update_mappings": "Anvend tilknytninger",
      "verify_all": "Bekræft alle",
      "verified": "Bekræftet",
      "unmap_user": "Fjern tilknytning",
      "linked": "Tilknyttet"
    },
    "employees_mapping": {
      "mappings_updated": "Medarbejder mapning er opdateret",
      "mappings_updated_title": "Opdaterede {count} medarbejder | Opdaterede {count} medarbejdere"
    },
    "employee": {
      "linked_to": "Tilknyttet til",
      "no_user_linked": "Ingen bruger tilknyttet"
    },
    "columns": {
      "description": "Beskrivelse",
      "projectnumber": "Projektnummer",
      "name": "Navn",
      "co_responsible_employee": "Medansvarlig",
      "responsible_employee": "Ansvarlig",
      "status": "Status"
    },
    "buttons": {
      "manage_project_owners": "Administrer ansvarlige",
      "manage_columns": "Administrer kolonner"
    },
    "search_empty": {
      "subheader": "Alle dine projekter vil blive vist her, når de er blevet importeret...",
      "header": "Kunne ikke finde nogle projeker"
    },
    "manage_columns": {
      "update_columns": "Anvend kolonner",
      "description": "Vælg venligst hvilke projektkolonner, der skal være tilgængelige på konteringslinjer",
      "columns_updated_title": "Opdaterede kolonner",
      "title": "Administrer kolonner",
      "columns_updated": "Konteringskolonner er blevet opdateret"
    }
  },
  "project": {
    "fields": {
      "responsibleemployeenumber": "Ansvarlig",
      "projectnumbe": "Projektnummer",
      "customernumber": "Kundenummer",
      "projectnumber": "Projektnummer",
      "coresponsibleemployeenumber": "Medansvarlig",
      "active": "Status",
      "description": "Beskrivelse"
    }
  },
  "popup": {
    "onhold_reason": {
      "no_additional_note": "Ingen yderligere bemærkning"
    }
  },
  "profile": {
    "title": "Profil",
    "description": "Se og administrer din profil"
  },
  "resetpassword": {
    "error_message": "Vi oplever i øjeblikket nogle tekniske problemer.<br/><br/>Hvis problemet fortsætter, bedes du kontakte vores supportteam.",
    "error": {
      "password_not_meets_criteria": "Din nye adgangskode er ikke helt stærk nok. Sørg for, at den opfylder alle fire kriterier",
      "password_validation_empty": "Password er påkrævet",
      "reset_failed": "Nulstilling af adgangskode mislykkedes. Prøv venligst igen."
    },
    "sub_title": "For kontoen <b>{email}</b>",
    "validation": {
      "nonalfa": "Et symbol (fx #&%)",
      "numeric": "Et tal",
      "title": "Opret en sikker adgangskode",
      "upperlower": "Store og små bogstaver",
      "length": "8 karakterer langt"
    },
    "resetting": "Opdaterer adgangskode",
    "error_title": "Det er ikke dig, det er os",
    "confirm_password_placeholder": "Bekræft din nye adgangskode",
    "invalid_token_header": "Tiden er gået...",
    "password_mismatch": "Adgangskoderne er ikke ens",
    "invalid_token_message": "Linket til nulstilling af din adgangskode, som du modtog i e-mailen, er udløbet eller allerede brugt; det kan kun klikkes én gang.<br/><br/>Vi kan sende et nyt link til din e-mail:<br/>{email}.<br/><br/>Hvis du ikke har modtaget en e-mail, bedes du prøve at nulstille din adgangskode igen eller kontakte vores supportteam.",
    "meta": {
      "description": "Nultil din adgangskode",
      "title": "Nultil adgangskode"
    },
    "back": "Tilbage til log ind",
    "confirm_password": "Bekræft adgangskode",
    "success_message": "Din adgangskode er blevet opdateret, og kan nu bruges til at få adgang til Batchflow.",
    "resend": "Gensend e-mail",
    "title": "Nulstil adgangskode",
    "reset_error_header": "Noget gik galt...",
    "invalid_token": "Linket til nulstilling af adgangskode er udløbet.",
    "success_title": "Adgangskoden er blevet opdateret",
    "new_password_placeholder": "Indtast din nye adgangskode",
    "reset": "Opdater din adgangskode",
    "new_password": "Ny adgangskode",
    "password_validation_error": "Din nye adgangskode er ikke helt stærk nok. Sørg for, at den opfylder alle fire kriterier"
  },
  "search_and_filter": {
    "recent_searches": "Seneste søgninger",
    "search_and_filter": "Søg og filtrer efter",
    "companies": "Selskaber",
    "active_filters": "Aktive filtre",
    "no_results": "Tryk Enter for at søge...",
    "work_status": "Arbejdsstatus",
    "users": "Brugere",
    "or": "eller",
    "document_types": "Dokumenttyper"
  },
  "roles": {
    "approver": "Godkender",
    "purchaser_description": "Denne rolle er kun tilladt at se sine afventede dokumenter + Match",
    "accountant_description": "Denne rolle må alting udover rolle administration",
    "roles_in_total": "{count} roller i alt",
    "header": "Roller",
    "columns": {
      "description": "Beskrivelse",
      "amount_of_users": "Antal brugere",
      "name": "Navn"
    },
    "purchaser": "Indkøber",
    "administrator": "Administrator",
    "auditor_description": "Denne rolle er kun tilladt at læse data (read-only bruger)",
    "approver_plus_description": "Denne rolle kan se sine egene afventede dokumenter og redigere konteringslinjer",
    "not_set": "Ikke angivet",
    "accountant": "Bogholder",
    "approver_description": "Denne rolle kan se sine egene afventede dokumenter",
    "administrator_description": "Denne rolle kan se og redigere alting",
    "approver_plus": "Godkender Plus",
    "auditor": "Revisor"
  },
  "re": {
    "back": "Tilbage til log ind"
  },
  "shortcuts": {
    "focus_prev_item": "Vælg forrige dokument",
    "switch_to_approved": "Godkendte",
    "move_to_another_document": "Flyt til et andet dokument",
    "expanded_view": "Udvidet visning",
    "download_as_pdf": "Download som PDF",
    "see_all_shortcuts": "Se alle genvejstaster",
    "move_to_another_company": "Flyt til et andet selskab",
    "copy_invoice_link": "Kopiér fakturalink",
    "remind_assignees": "Påmind tildelte",
    "export_documents": "Eksporter dokument | Eksporter dokumenter",
    "standard_view": "Standardvisning",
    "fit_to_width": "Tilpas til bredde",
    "shortcuts_for": "Tastaturgenveje for {page}",
    "download_as_xml": "Download som XML",
    "go_to_first_row": "Gå til første række",
    "keyboard_shortcuts": "Genvejstaster",
    "navigate_up": "Naviger op",
    "previous_field": "Forrige felt",
    "jump_to_first_field": "Hop til første felt",
    "open_batchflow_wiki": "Åbn Batchflow Wiki",
    "review_documents": "Gennemgå dokument | Gennemgå dokumenter",
    "open_shortcuts": "Åbn genveje",
    "move_mode": "Flyttetilstand",
    "open_document": "Åbn dokument",
    "focus_next_item": "Vælg næste dokument",
    "copy_row_above": "Kopiér række ovenfor",
    "show_activity_log": "Vis aktivitetslog",
    "jump_to_first_journal_entry": "Hop til den første konteringslinje",
    "deselect_items": "Fravælg valgte dokument | Fravælg valgte dokumenter",
    "select_mode": "Markeringstilstand",
    "next_field": "Næste felt",
    "multi_select_document": "Multivælg dokument",
    "process_documents": "Behandl dokumenter",
    "command_palette_search": "Søg i kommandopaletten",
    "preview_document": "Forhåndsvis dokument",
    "switch_to_declined": "Afviste",
    "select_document": "Vælg dokument",
    "show_attachments": "Vis vedhæftninger",
    "previous_document": "Forrige dokument",
    "navigate_down": "Naviger ned",
    "search_placeholder": "Søg efter genveje",
    "expand_view": "Udvid",
    "move_freely_journal_entries": "Flyt frit rundt i konteringsfelterne",
    "pagination_prev": "Gå til forrige side",
    "previous_page": "Forrige side",
    "select_all_items": "Vælg alle dokumenter",
    "pagination_next": "Gå til næste side",
    "go_to_last_row": "Gå til sidste række",
    "export_to_excel": "Eksporter til Excel",
    "secondary_action": "Sekundær handling",
    "show_comments": "Vis kommentarer",
    "begin_approval": "Begynd godkendelse",
    "copy_row_below": "Kopiér række nedenfor",
    "next_document": "Næste dokument",
    "back_to_document_lists": "Tilbage til dokumentlister",
    "document_view": "Dokumentvisning",
    "no_results_title": "Vi kunne ikke finde den genvej, du søgte efter",
    "focus_item_list": "Vælg første dokument",
    "search_and_filter": "Søg og filtrer",
    "next_page": "Næste side",
    "copy_field_value_below": "Kopiér feltværdi nedenfor",
    "place_on_hold": "Sæt på hold",
    "copy_field_value_above": "Kopiér feltværdi ovenfor",
    "no_results": "Ingen genveje fundet",
    "compact_view": "Kompakt visning",
    "move_to_exported": "Flyt til eksporteret",
    "primary_action": "Primær handling",
    "switch_panel": "Skift panel",
    "no_results_description": "Tjek stavningen, eller prøv en ny søgning",
    "keys": {
      "spacebar": "Mellemrum",
      "tab": "Tab",
      "page_up": "Page Up",
      "arrows": "Piletaster",
      "end": "End",
      "plus": "Plus",
      "cmd": "Cmd",
      "page_down": "Page Down",
      "ctrl": "Ctrl",
      "home": "Home",
      "minus": "Minus",
      "enter": "Enter",
      "alt": "Alt",
      "shift": "Shift"
    },
    "toggle_invoice_format": "Skift fakturaformat",
    "context": {
      "download": "Download",
      "field_navigation": "Feltnavigation",
      "navigation": "Navigation",
      "actions": "Handlinger",
      "misc": "Diverse",
      "document_list": "Dokumentliste",
      "search": "Søgning",
      "move_to": "Flyt til",
      "change_widget": "Skift widget",
      "layout": "Layout",
      "invoice_viewer": "Fakturavisning",
      "journal_entries": "Konteringslinjer"
    },
    "upload_documents": "Upload dokument",
    "switch_to_on-hold": "På hold",
    "zoom_out": "Zoom ud",
    "zoom_in": "Zoom ind",
    "view_documents": "Vis dokumenter",
    "switch_to_my-archive": "Mit arkiv",
    "switch_to_new-documents": "Nye dokumenter",
    "switch_to_under-review": "Under behandling",
    "tertiary_action": "Tertiær handling",
    "switch_to_export-errors": "Eksportfejl",
    "switch_to_inbox": "Min indbakke",
    "get_help": "Få hjælp",
    "create_journal_entry": "Opret ny konteringslinje",
    "move_to_archived": "Flyt til Arkiverede"
  },
  "user": {
    "confirm": {
      "remove_from_company_text_2": "Denne handling kræver, at du finder en erstatning for deres dokumenter.",
      "remove_from_company_text_is_last": "Hvis de fjernes fra virksomheden, vil deres adgang til Batchflow blive tilbagekaldt, og de vil ikke længere kunne logge ind.",
      "remove_from_company_text": "Hvis du fjerner dem fra virksomheden, vil de miste adgangen til alt, der er relateret til virksomheden.",
      "deactivate_user_title": "Er du sikker på, at du vil deaktivere brugeren {user}?",
      "remove_from_company_bottom": "Denne handling kan ikke fortrydes og kræver, at der sendes en ny invitation til dem.",
      "remove_from_company_title": "Er du sikker på, at du vil fjerne {user} fra {company}?",
      "deactivate_user_text2": "Du skal vælge en erstatning, der skal overtage i alle flows, som stedfortræder og deres dokumenter vil automatisk blive overført til erstatningen.",
      "deactivate_user_text": "Dette vil fjerne brugeren fra alle anførte virksomheder, som de er en del af i organisationen."
    },
    "fields": {
      "phonenumber": "Telefonnummer",
      "displayname": "Navn",
      "language": "Sprog",
      "email": "E-mail"
    },
    "work_status": {
      "user_is_out_of_office": "Bruger er out of office",
      "select_user": "Vælg stedfortræder",
      "working": "Arbejder",
      "out_of_office_until": "Bruger er out of office indtil {date}",
      "out_of_office": "Out of office",
      "out_of_office_in_days": "Bruger går out of office om {count} dag | Bruger går out of office om {count} dage",
      "only_user": "Du er den eneste bruger"
    },
    "deactivate": {
      "confirm_text": "Er du sikker på du vil deaktivere",
      "confirm_text_2": "Denne handling vil låse dem ude af Batchflow",
      "yes_deactivate": "Ja, deaktiver"
    },
    "activate": {
      "confirm_text": "Er du sikker på, at du vil aktivere brugeren",
      "confirm_text_2": "Denne aktion vil give brugeren adgang til Batchflow",
      "yes_activate": "Ja, aktiver"
    },
    "remove_from_company": {
      "yes_find_replacement": "Ja, find en erstatning"
    },
    "work": {
      "you_are_only_user": "Du kan ikke udpege en stedfortræder, da du er den eneste medarbejder i virksomheden"
    },
    "tooltip": {
      "approval_limit_title": "Flere godkendelsesgrænser",
      "approval_view_all": "Se alle",
      "approval_more_companies": "+{count} flere virksomheder | +{count} flere virksomheder",
      "approval_more_limits": "+{count} grænse | +{count} grænser"
    }
  },
  "system": {
    "automation_username": "Batchflow automatiseringer",
    "username": "Batchflow"
  },
  "time": {
    "months": "{count} måned | {count} måneder",
    "hours": "{count} time | {count} timer",
    "years": "{count} år",
    "minutes": "{count} minut | {count} minutter",
    "seconds": "{count} sekund | {count} sekunder",
    "days": "{count} dag | {count} dage"
  },
  "sign": {
    "out": "Log ud"
  },
  "validation": {
    "error": {
      "could_not_approve_item": "Dokumentet kan ikke godkendes, før valideringsproblemerne er løst.",
      "could_not_load_flow_templates": "Flowskabelonerne kunne ikke indlæses.",
      "could_not_export_item": "Dokumentet kan ikke eksporteres, før valideringsproblemerne er løst.",
      "could_not_assign_template": "Flowskabelonen kunne ikke tildeles.",
      "could_not_send_for_review": "Dokumentet kan ikke sendes til gennemgang, før valideringsproblemerne er løst."
    },
    "fields": {
      "min_value": "{field} må ikke være mindre end {length}",
      "bic_swift_invalid": "Format: 6 bogstaver, 2 alfanumeriske tegn og valgfrit 3 alfanumeriske tegn",
      "required": "{field} er påkrævet",
      "url": "{field} er ikke en gyldig URL",
      "numeric": "{field} må kun indeholde tal",
      "password": "Adgangskoden lever ikke op til sikkerhedskravene",
      "max": "{field} må ikke være mere end {length} karakterer",
      "iban_invalid_format": "Format: 2 store bogstaver, derefter 13-31 alfanumeriske karakterer",
      "email_already_used": "E-mailen er allerede i brug, angiv venligst en unik email",
      "cant_assign_delegated_user_loop": "Brugeren er stedfortræder for denne bruger",
      "min": "{field} skal mindst være {length} karakterer",
      "password_incorrect": "Adgangskoden er ikke korrekt",
      "same_email_as_current": "Den indtastede mail er den samme som din nuværende mail",
      "confirmed_fields": "{fields} matcher ikke",
      "iban_invalid": "Kontrolcifrene er forkerte, hvilket indikerer, at IBAN-nummeret ikke er gyldigt",
      "max_value": "{field} må ikke være mere end {length}",
      "email": "Ikke en gyldig e-mail, prøv venligst igen",
      "max_length": "Telefonnummeret må ikke overstige 15 cifre.",
      "invalid_payment_id": "{fieldName} for Kortart {typeFieldName} skal være {minNumber}-{maxNumber} tal",
      "invalid_length": "{fieldName} skal være {minNumber}-{maxNumber} numre",
      "confirmed": "Adgangskoderne er ikke ens",
      "invalid_non_zero": "Værdien må ikke være nul",
      "invalid_field": "Ugyldigt felt"
    },
    "flow": {
      "decliners_cant_exceed_users": "Afvisninger må ikke overstige mængden af brugere",
      "approvers_cant_exceed_users": "Godkendelser er højere end antal brugere",
      "approvers_cant_be_empty": "Der skal være mindst én godkender"
    },
    "default": "{field} er ugyldigt"
  },
  "widget": {
    "buttons": {
      "view_selected_documents": "Vis valgte dokumenter",
      "remind_selected_assignees_executing": "Påminder valgte tildelte",
      "review_selected_documents_executing": "Gennemgår valgte dokumenter",
      "remind_assignees": "Påmind tildelte",
      "export_excel_selected": "Eksporter valgte til Excel",
      "process_documents": "Behandl dokumenter",
      "decline_item_executing": "Afviser dokument",
      "move_documents_executing": "Flytter dokumenter",
      "refresh": "Opdater",
      "export_selected_documents": "Eksporter valgte dokument | Eksporter valgte dokumenter",
      "export_documents_executing": "Eksporterer dokumenter",
      "export_documents": "Eksporter dokumenter",
      "review_documents_executing": "Gennemgår dokumenter",
      "process_selected_documents_executing": "Behandler valgte dokumenter",
      "review_selected_documents": "Gennemgå valgte dokument | Gennemgå valgte dokumenter",
      "refresh_executing": "Opdaterer",
      "process_documents_executing": "Behandler dokumenter",
      "remind_item_assignees_executing": "Påminder",
      "remind_assignees_executing": "Påminder tildelte",
      "process_selected_documents": "Behandl valgte dokument | Behandl valgte dokumenter",
      "review_documents": " Gennemgå dokumenter",
      "move_documents": "Flyt dokument | Flyt dokumenter",
      "remind_selected_assignees": "Påmind valgte tildelte",
      "upload_documents": "Upload dokument",
      "export_selected_documents_executing": "Eksporterer valgte dokumenter",
      "export_excel": "Eksporter til Excel "
    },
    "under-review": "Under gennemgang",
    "description": {
      "declined": "Dokumenter, der er blevet afvist",
      "inbox": "Dokumenter, der er klar til at blive godkendt (personlig indbakke)",
      "approved": "Dokumenter, der er blevet godkendt, og er klar til eksport",
      "exported": "Dokumenter, der er blevet eksporteret",
      "my-on-hold": "Dokumenter, der er sat på hold til videre behandling af brugeren (personlig på hold)",
      "deleted": "Dokumenter, der er blevet slettet",
      "archived": "Dokumenter, der er blevet arkiveret",
      "on-hold": "Dokumenter, der er sat på hold til videre behandling",
      "export-errors": "Dokumenter, der er fejlet under eksport, og hvor fejl kan håndteres",
      "my-archive": "Dokumenter, der tidligere er blevet behandlet af brugeren (personligt arkiv)",
      "under-review": "Dokumenter, der er sendt til gennemgang (oversigt over flere indbakker)",
      "new-documents": "Dokumenter, der er modtaget, og er klar til at blive behandlet",
      "outbound": "Dokumenter, der er ved at blive eksporteret",
      "departments": "Dokumenter fra Min indbakke, indtil afdelingsfiltrering er tilgængelig"
    },
    "my-on-hold": "Mine på hold\n",
    "my-archive": "Mit arkiv",
    "approved": "Godkendte",
    "inbox": "Min indbakke",
    "archived": "Arkiverede",
    "outbound": "Udgående",
    "declined": "Afviste",
    "archive": {
      "deleted_warning_button": "Slettede dokumenter fjernes efter 90 dage"
    },
    "export-errors": "Eksportfejl",
    "assignee": "tildelte",
    "exported": "Eksporterede",
    "new-documents": "Nye dokumenter",
    "deleted": "Slettede",
    "on-hold": "På hold",
    "departments": "Afdelinger",
    "all-documents": "Alle dokumenter"
  },
  "widgets": {
    "columns": {
      "widget": "Widget",
      "description": "Beskrivelse",
      "status": "Status"
    },
    "active": "Aktiv",
    "inactive": "Deaktiveret",
    "deactivated": "Deaktiveret"
  },
  "websockets": {
    "users_in_room": "Er aktive på dokumentet",
    "users_on_field": "Er aktiv i dette felt"
  },
  "wiki": {
    "header": {
      "link": "Åben i et nyt vindue",
      "title": "Batchflow Wiki"
    }
  },
  "workstatus": {
    "change_status": "Skift status",
    "find_delegate": "Find en delegeret",
    "return_to_office": "Tilbage til kontoret",
    "apply_delegate": "Anvend stedfortræder",
    "calendar_message": "Vælg en tidsramme for din arbejdsstatus",
    "start_end_day": "Vælg en slutdato",
    "apply_indefinitely": "Anvend ubestemt tid",
    "edit_out_of_office": "Rediger uden for kontoret",
    "please_select_time": "Vælg en tidsramme",
    "apply_timeframe": "Anvend tidsramme",
    "find_delegate_message": "Vælg en person, der skal være din delegerede i ",
    "edit_your_out_of_office": "Rediger din fraværsmeddelelse",
    "update": "Opdatering",
    "select_delegate": "Vælg en stedfortræder for følgende selskab | Vælg en stedfortræder for følgende selskaber",
    "edit_message": "Vælg den status, der passer til din nuværende arbejdsstatus",
    "timeframe": "Tidsramme",
    "status_as_working": "Indstil arbejdsstatus som arbejdende",
    "no_delegate_message": "Du kan ikke selv afskedige dig selv, da du er den eneste ansatte i ",
    "no_delegate_title": "Der er ingen delegeret til rådighed"
  },
  "work_status": {
    "out_of_office": "Out of office"
  },
  "xml_file": {
    "download": {
      "message": "Dette tager et øjeblik...",
      "title": "Gør din XML klar",
      "error_title": "XML-download mislykkedes",
      "error_message": "XML-filen kunne ikke downloades. Prøv igen."
    }
  },
  "activity": {
    "flow": {
      "auto_decline_2": "Årsag til afslag: “Der kunne ikke træffes en endelig beslutning i godkendelsesforløbet”",
      "auto_decline_1": "Dokumentet blev afvist, fordi godkendelsesprocessen ikke kunne nå frem til en endelig afgørelse."
    },
    "customfield": "Brugerdefineret felt"
  },
  "common": {
    "unknown_company": "Ukendt selskab",
    "unknown_email": "Ukendt e-mail",
    "unknown_user": "Ukendt bruger",
    "creditor": "Kreditor"
  },
  "column": {
    "reset_columns": "Nulstil kolonner"
  },
  "activity_log": {
    "employees": {
      "no_employee_name": "Intet medarbejdernavn"
    },
    "projects": {
      "no_project_number": "Intet projektnummer",
      "no_cost_type_name": "Intet omkostningstypenavn"
    }
  },
  "export": {
    "errors": {
      "no_error_found": "Ingen fejl fundet"
    }
  },
  "errors": {
    "something_went_wrong": "Noget gik galt"
  },
  "top_bar": {
    "get_help": "Få hjælp"
  },
  "integration": {
    "name": {
      "unknown": "Ukendt integration"
    }
  },
  "works": {
    "status": {
      "you_are_only_user": "Du er den eneste bruger"
    }
  },
  "button": {
    "desktop_app_warning": {
      "stay_on_mobile": "Bliv på mobilen",
      "open_desktop_version": "Åbn desktopversionen"
    }
  },
  "permission": {
    "setting_approval_limits": "Beløbsgrænser"
  },
  "journal_profiles": {
    "form": {
      "creditor": "Kreditor",
      "delete_template_title": "Vil du slette denne skabelon?",
      "delete_template": "Slet skabelon",
      "delete_template_confirmation_warning": "Denne handling kan ikke fortrydes",
      "added_creditors": "Tilknyttede kreditorer",
      "amount_fields_subtitle": "Vælg, om Beløb-felterne skal være tomme eller udfyldes med de gemte værdier, når skabelonen anvendes",
      "amount_fields": "Beløbsfelter",
      "add_a_creditors": "Tilføj en kreditor",
      "delete_template_confirmation": "Skabelonen vil blive taget ud af brug i Batchflow",
      "icon_subtitle": "Vælg et ikon til skabelonen",
      "save_amounts_description": "Når skabelonen anvendes, udfyldes Beløb-felterne med de gemte værdier",
      "linked_creditors": "Tilknyttede kreditorer",
      "template_icon": "Skabelonikon",
      "link_creditors_description": "Knyt kreditorer til denne skabelon, så den som standard vises som favorit, når kreditoren vælges i et dokument",
      "keep_amounts_empty": "Lad beløb være tomme",
      "icon": "Ikon",
      "search_for_creditors": "Søg efter kreditorer",
      "no_icons_found": "Det var ikke muligt at finde det ikon, du ledte efter",
      "no_creditors_linked_yet": "Der er endnu ikke tilknyttet nogen kreditorer",
      "name": "Navn",
      "description": "Beskrivelse",
      "unlink": "Fjern kreditor fra listen",
      "save_amounts": "Forudfyld beløb",
      "template_details": "Skabelondetaljer",
      "selected_icon": "Valgt ikon",
      "select_for_creditors": "Vælg en kreditor",
      "linked_creditors_subtitle": "Denne skabelon vises som en favorit, når der vælges en tilknyttet kreditor i et dokument",
      "empty_link_creditors_description": "Tilknyt kreditorer til denne skabelon for at vise den som favorit, når der browses skabeloner for dokumenter med de valgte kreditorer",
      "search_for_creditors_to_link": "Søg efter kreditorer ovenfor for at knytte dem til denne skabelon",
      "empty_creditors_linked_yet": "Der er endnu ikke knyttet nogen kreditorer til sagen",
      "icon_subtitle_template": "Vælg et ikon, der skal repræsentere denne skabelon",
      "manage_creditor_links": "Administrer kreditorer",
      "keep_amounts_empty_description": "Når skabelonen anvendes, forbliver Beløb-felterne tomme",
      "search_icons": "Søg efter ikon",
      "no_icons_found_spelling": "Tjek stavningen, eller prøv en ny søgning",
      "link_creditors": "Tilknyt kreditorer",
      "template_details_subtitle": "Angiv navn og beskrivelse for denne skabelon",
      "name_subtitle": "Bruges i skabelonoversigter og når skabelonen anvendes",
      "description_subtitle": "Valgfri note, der hjælper andre med at vælge denne skabelon"
    },
    "search_and_filter": "Søg og filtrer efter Navn, Beskrivelse og Kreditor",
    "columns": {
      "creditor": "kreditorer",
      "number_of_lines": "Linjer",
      "description": "beskrivelse",
      "name": "Navn"
    },
    "buttons": {
      "create_journal_entry_template": "Opret konteringsskabelon"
    },
    "template": {
      "link_creditors_description": "Ved at knytte en kreditor til en skabelon kan brugerne se skabelonen til journalposten, når de arbejder fra dokumentsiden.",
      "link_creditors": "Tilknyttet kreditor"
    },
    "notifications": {
      "template_saved_subtitle": "Dine ændringer er blevet gemt for:",
      "template_created_subtitle": "Du har oprettet skabelonen:",
      "template_deleted": "Skabelonen er slettet ",
      "template_saved": "Skabelonen er gemt",
      "template_deleted_subtitle": "Du har slettet skabelonen permanent"
    }
  },
  "creditor": {
    "not": {
      "found": "Vælg en kreditor for at gennemse skabeloner"
    }
  },
  "template": {
    "name": {
      "placeholder": "Vælg venligst en skabelon, der skal overskrives"
    }
  },
  "departments": {
    "details": "Afdelingsoplysninger",
    "buttons": {
      "update": "Opdater afdeling",
      "create_new": "Opret ny afdeling"
    },
    "description_optional": "Beskrivelse (valgfri)",
    "role": {
      "member_description": "Medlemmer vises i afdelingen, men kan ikke se aktive eller arkiverede dokumenter",
      "supervisor": "Supervisor",
      "supervisor_description": "Supervisorer kan se afdelingens aktive og arkiverede dokumenter i en separat widget.",
      "member": "Medlem"
    },
    "columns": {
      "description": "Beskrivelse",
      "members": "Antal medlemmer",
      "name": "Afdelingsnavn"
    },
    "edit_title": "Rediger afdeling",
    "empty_members": "Der er endnu ikke tilføjet nogen medlemmer",
    "search_members": "Søg efter et navn eller en e-mail",
    "description_placeholder": "Beskriv afdelingen",
    "search_and_filter": "Søg og filtrer efter afdelingsnavn eller beskrivelse",
    "search_empty": {
      "header": "Kunne ikke finde nogen afdelinger",
      "subheader": "Alle dine afdelinger vises her, når de er oprettet..."
    },
    "name_placeholder": "Angiv et afdelingsnavn",
    "members": "Medlemmer"
  }
};